export const widgets = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Виджеты 2 дизайн</title>
  </head>
  <body>
    <div class="dropright-1">
      <button class="drop-1">
        Аналоговые часы <br />
        16, 18 вариант
      </button>
      <div class="drop-content-1">
        <div class="navbar-2">
          <div class="dropdown-2">
            <button
              class="drop-2"
              id="btn-10-1"
              onclick="alert(getCode('btn-10-1'))"
            >
              <div class="design-2 widget-analog-clock-16-1-widget analog-clock-M">
                <canvas id="canvas16-1" width="250px" height="250px">
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-2-2: 252px;
                      --background-widgets: rgba(30, 30, 30, 1);
                    }
                    .design-2 {
                      background-color: var(--background-widgets);
                      border-radius: 26px;
                    }
                    .widget-analog-clock-16-1-widget {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: var(--size-2-2);
                      height: var(--size-2-2);
                    }
                  </style>
                  <script>
                    analogClock16_1();
                    function analogClock16_1() {
                      let center_x = 125;
                      let center_y = 125;
                      let radius = 117;
                      pi = Math.PI;
                      drawClock16_1();
                      setInterval(drawClock16_1, 100);

                      function drawClock16_1() {
                        clock16_1();
                        drawWBlackNumbers(ctx, radius);
                        timing16_1();
                      }
                      // стрелки
                      function timing16_1() {
                        const d = new Date();
                        angle =
                          Math.PI * 2 * (d.getSeconds() / 60) -
                          (Math.PI * 2) / 4;

                        // часовая
                        ctx.beginPath();
                        ctx.lineWidth = 5;
                        ctx.strokeStyle = "rgba(0, 0, 0, 1)";
                        ctx.moveTo(center_x, center_y);
                        ctx.lineTo(
                          center_x +
                            Math.sin((d.getHours() * Math.PI) / 6) *
                              radius *
                              0.4,
                          center_y -
                            Math.cos((d.getHours() * Math.PI) / 6) *
                              radius *
                              0.4
                        );
                        ctx.stroke();
                        ctx.closePath();
                        //минутная
                        ctx.beginPath();
                        ctx.lineWidth = 5;
                        ctx.strokeStyle = "rgba(0, 0, 0, 1)";
                        ctx.moveTo(center_x, center_y);
                        ctx.lineTo(
                          center_x +
                            Math.sin((d.getMinutes() * Math.PI) / 30) *
                              radius *
                              0.7,
                          center_y -
                            Math.cos((d.getMinutes() * Math.PI) / 30) *
                              radius *
                              0.7
                        );
                        ctx.stroke();
                        ctx.closePath();
                        // секундная
                        ctx.lineWidth = 3;
                        ctx.beginPath();
                        ctx.moveTo(center_x, center_y);
                        ctx.lineTo(
                          canvas.width / 2 + (Math.cos(angle) * 60 * 25) / 14,
                          canvas.height / 2 + (Math.sin(angle) * 60 * 25) / 14
                        );
                        ctx.moveTo(canvas.width / 2, canvas.height / 2);
                        ctx.lineTo(
                          canvas.width / 2 - Math.cos(angle) * 20,
                          canvas.height / 2 - Math.sin(angle) * 20
                        );
                        ctx.strokeStyle = "rgba(57, 182, 251, 1)";
                        ctx.stroke();
                        ctx.closePath();

                        ctx.beginPath(); // начало нового пути
                        ctx.fillStyle = "rgba(57, 182, 251, 1)";
                        // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                        ctx.arc(center_x, center_y, 8, 0, 2 * pi, false);
                        ctx.fill();
                        ctx.closePath();

                        ctx.beginPath(); // начало нового пути
                        ctx.fillStyle = "rgba(255, 255, 255, 1)";
                        // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                        ctx.arc(center_x, center_y, 5, 0, 2 * pi, false);
                        ctx.fill();
                        ctx.closePath();
                      }

                      // отрисовка цифры черные
                      function drawWBlackNumbers(ctx, radius) {
                        var ang;
                        var num;
                        ctx.fillStyle = "black";
                        ctx.font = radius * 0.18 + "px Montserrat";
                        ctx.textBaseline = "middle";
                        ctx.textAlign = "center";
                        for (num = 1; num < 13; num++) {
                          ang = (num * Math.PI) / 6;
                          ctx.rotate(ang);
                          ctx.translate(0, -radius * 0.85);
                          ctx.rotate(-ang);
                          ctx.fillText(num.toString(), center_x, center_y);
                          ctx.rotate(ang);
                          ctx.translate(0, radius * 0.85);
                          ctx.rotate(-ang);
                        }
                      }
                      function fill(fn, params) {
                        ctx.beginPath();
                        fn(params);
                        ctx.fill();
                        ctx.closePath();
                      }
                      function clock16_1() {
                        canvas = document.getElementById("canvas16-1");
                        ctx = canvas.getContext("2d");
                        ctx.beginPath(); // начало нового пути
                        ctx.lineWidth = 2;
                        ctx.fillStyle = "white";
                        ctx.strokeStyle = "white";
                        // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                        ctx.arc(center_x, center_y, radius, 0, 2 * pi, false);
                        ctx.fill();
                        ctx.stroke();
                        ctx.closePath();
                      }
                    }
                  </script>
                </canvas>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-10-2"
              onclick="alert(getCode('btn-10-2'))"
            >
              <div class="design-2 widget-analog-clock-16-2-widget analog-clock-M">
                <canvas id="canvas16-2" width="250px" height="250px">
                  <style>
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-2-2: 252px;
                      --background-widgets: rgba(30, 30, 30, 1);
                    }
                    .design-2 {
                      background-color: var(--background-widgets);
                      border-radius: 26px;
                    }
                    .widget-analog-clock-16-2-widget {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: var(--size-2-2);
                      height: var(--size-2-2);
                    }
                  </style>
                  <script>
                    analogClock16_2();
                    function analogClock16_2() {
                      let center_x = 125;
                      let center_y = 125;
                      let radius = 117;
                      pi = Math.PI;
                      drawClock16_2();
                      setInterval(drawClock16_2, 100);

                      function drawClock16_2() {
                        clock16_2();
                        mark_circle_hours1(ctx, radius);
                        timing16_2();
                      }
                      // стрелки
                      function timing16_2() {
                        const d = new Date();
                        angle =
                          Math.PI * 2 * (d.getSeconds() / 60) -
                          (Math.PI * 2) / 4;

                        // часовая
                        ctx.beginPath();
                        ctx.lineWidth = 6;
                        ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                        ctx.moveTo(center_x, center_y);
                        ctx.lineTo(
                          center_x +
                            Math.sin((d.getHours() * Math.PI) / 6) *
                              radius *
                              0.4,
                          center_y -
                            Math.cos((d.getHours() * Math.PI) / 6) *
                              radius *
                              0.4
                        );
                        ctx.stroke();
                        ctx.closePath();
                        //минутная
                        ctx.beginPath();
                        ctx.lineWidth = 6;
                        ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                        ctx.moveTo(center_x, center_y);
                        ctx.lineTo(
                          center_x +
                            Math.sin((d.getMinutes() * Math.PI) / 30) *
                              radius *
                              0.7,
                          center_y -
                            Math.cos((d.getMinutes() * Math.PI) / 30) *
                              radius *
                              0.7
                        );
                        ctx.stroke();
                        ctx.closePath();
                        // секундная
                        ctx.lineWidth = 3;
                        ctx.beginPath();
                        ctx.moveTo(center_x, center_y);
                        ctx.lineTo(
                          canvas.width / 2 + (Math.cos(angle) * 60 * 25) / 14,
                          canvas.height / 2 + (Math.sin(angle) * 60 * 25) / 14
                        );
                        ctx.moveTo(canvas.width / 2, canvas.height / 2);
                        ctx.lineTo(
                          canvas.width / 2 - Math.cos(angle) * 20,
                          canvas.height / 2 - Math.sin(angle) * 20
                        );
                        ctx.strokeStyle = "rgb(57, 182, 251, 1)";
                        ctx.stroke();
                        ctx.closePath();

                        ctx.beginPath(); // начало нового пути
                        ctx.fillStyle = "rgba(57, 182, 251, 1)";
                        // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                        ctx.arc(center_x, center_y, 9, 0, 2 * pi, false);
                        ctx.fill();
                        ctx.closePath();

                        ctx.beginPath(); // начало нового пути
                        ctx.fillStyle = "rgba(255, 255, 255, 1)";
                        // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                        ctx.arc(center_x, center_y, 6, 0, 2 * pi, false);
                        ctx.fill();
                        ctx.closePath();
                      }

                      // часовые метки серые точечные
                      function mark_circle_hours1(ctx, radius) {
                        for (
                          var i = 0;
                          i <= Math.PI * 2;
                          i += (2 * Math.PI) / 12
                        ) {
                          fill(function () {
                            ctx.fillStyle = "rgba(0, 0, 0, 1)";
                            ctx.arc(
                              ctx.canvas.width / 2 +
                                ((15 * radius) / 16) * Math.cos(i),
                              ctx.canvas.height / 2 +
                                ((15 * radius) / 16) * Math.sin(i),
                              4,
                              0,
                              2 * Math.PI
                            );
                          });
                        }
                      }
                      function fill(fn, params) {
                        ctx.beginPath();
                        fn(params);
                        ctx.fill();
                        ctx.closePath();
                      }
                      function clock16_2() {
                        canvas = document.getElementById("canvas16-2");
                        ctx = canvas.getContext("2d");
                        ctx.beginPath(); // начало нового пути
                        ctx.lineWidth = 2;
                        ctx.fillStyle = "white";
                        ctx.strokeStyle = "white";
                        // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                        ctx.arc(center_x, center_y, radius, 0, 2 * pi, false);
                        ctx.fill();
                        ctx.stroke();
                        ctx.closePath();
                      }
                    }
                  </script>
                </canvas>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-10-3"
              onclick="alert(getCode('btn-10-3'))"
            >
              <div class="design-2 widget-analog-clock-16-3-widget analog-clock-M">
                <canvas id="canvas16-3" width="250px" height="250px">
                  <style>
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-2-2: 252px;
                      --background-widgets: rgba(30, 30, 30, 1);
                    }
                    .design-2 {
                      background-color: var(--background-widgets);
                      border-radius: 26px;
                    }
                    .widget-analog-clock-16-3-widget {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: var(--size-2-2);
                      height: var(--size-2-2);
                    }
                  </style>
                  <script>
                    analogClock16_3();
                    function analogClock16_3() {
                      let center_x = 125;
                      let center_y = 125;
                      let radius = 117;
                      pi = Math.PI;
                      drawClock16_3();
                      setInterval(drawClock16_3, 100);

                      function drawClock16_3() {
                        clock16_3();
                        mark_line_hours1();
                        timing16_3();
                      }
                      // стрелки
                      function timing16_3() {
                        const d = new Date();
                        angle =
                          Math.PI * 2 * (d.getSeconds() / 60) -
                          (Math.PI * 2) / 4;

                        // часовая
                        ctx.beginPath();
                        ctx.lineWidth = 6;
                        ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                        ctx.moveTo(center_x, center_y);
                        ctx.lineTo(
                          center_x +
                            Math.sin((d.getHours() * Math.PI) / 6) *
                              radius *
                              0.4,
                          center_y -
                            Math.cos((d.getHours() * Math.PI) / 6) *
                              radius *
                              0.4
                        );
                        ctx.stroke();
                        ctx.closePath();
                        //минутная
                        ctx.beginPath();
                        ctx.lineWidth = 6;
                        ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                        ctx.moveTo(center_x, center_y);
                        ctx.lineTo(
                          center_x +
                            Math.sin((d.getMinutes() * Math.PI) / 30) *
                              radius *
                              0.7,
                          center_y -
                            Math.cos((d.getMinutes() * Math.PI) / 30) *
                              radius *
                              0.7
                        );
                        ctx.stroke();
                        ctx.closePath();
                        // секундная
                        ctx.lineWidth = 2;
                        ctx.beginPath();
                        ctx.moveTo(center_x, center_y);
                        ctx.lineTo(
                          canvas.width / 2 + (Math.cos(angle) * 60 * 25) / 14,
                          canvas.height / 2 + (Math.sin(angle) * 60 * 25) / 14
                        );
                        ctx.moveTo(canvas.width / 2, canvas.height / 2);
                        ctx.lineTo(
                          canvas.width / 2 - Math.cos(angle) * 20,
                          canvas.height / 2 - Math.sin(angle) * 20
                        );
                        ctx.strokeStyle = "rgb(57, 182, 251, 1)";
                        ctx.stroke();
                        ctx.closePath();

                        ctx.beginPath(); // начало нового пути
                        ctx.fillStyle = "rgba(115, 115, 115, 1)";
                        // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                        ctx.arc(center_x, center_y, 9, 0, 2 * pi, false);
                        ctx.fill();
                        ctx.closePath();

                        ctx.beginPath(); // начало нового пути
                        ctx.fillStyle = "rgba(57, 182, 251, 1)";
                        // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                        ctx.arc(center_x, center_y, 7, 0, 2 * pi, false);
                        ctx.fill();
                        ctx.closePath();

                        ctx.beginPath(); // начало нового пути
                        ctx.fillStyle = "rgba(255, 255, 255, 1)";
                        // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                        ctx.arc(center_x, center_y, 5, 0, 2 * pi, false);
                        ctx.fill();
                        ctx.closePath();
                      }

                      //часовые метки темно-серые линейные
                      function mark_line_hours1() {
                        for (var i = 0; i < 12; i++) {
                          angle = ((i - 3) * (Math.PI * 2)) / 12;
                          ctx.lineWidth = 4;
                          ctx.beginPath();
                          var x1 = center_x + (Math.cos(angle) * 60 * 22) / 12;
                          var y1 = center_y + (Math.sin(angle) * 60 * 22) / 12;
                          var x2 =
                            center_x +
                            (Math.cos(angle) * (60 - 60 / 30) * 10) / 6;
                          var y2 =
                            center_y +
                            (Math.sin(angle) * (60 - 60 / 30) * 10) / 6;
                          ctx.moveTo(x1, y1);
                          ctx.lineTo(x2, y2);
                          ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                          ctx.stroke();
                          ctx.closePath();
                        }
                      }
                      function fill(fn, params) {
                        ctx.beginPath();
                        fn(params);
                        ctx.fill();
                        ctx.closePath();
                      }
                      function clock16_3() {
                        canvas = document.getElementById("canvas16-3");
                        ctx = canvas.getContext("2d");
                        ctx.beginPath(); // начало нового пути
                        ctx.lineWidth = 2;
                        ctx.fillStyle = "white";
                        ctx.strokeStyle = "white";
                        // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                        ctx.arc(center_x, center_y, radius, 0, 2 * pi, false);
                        ctx.fill();
                        ctx.stroke();
                        ctx.closePath();
                      }
                    }
                  </script>
                </canvas>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-10-4"
              onclick="alert(getCode('btn-10-4'))"
            >
              <div class="design-2 widget-analog-clock-16-4-widget analog-clock-M">
                <canvas id="canvas16-4" width="250px" height="250px">
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-2-2: 252px;
                      --background-widgets: rgba(30, 30, 30, 1);
                    }
                    .design-2 {
                      background-color: var(--background-widgets);
                      border-radius: 26px;
                    }
                    .widget-analog-clock-16-4-widget {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: var(--size-2-2);
                      height: var(--size-2-2);
                    }
                  </style>
                  <script>
                    analogClock16_4();
                    function analogClock16_4() {
                      let center_x = 125;
                      let center_y = 125;
                      let radius = 117;
                      pi = Math.PI;
                      drawClock16_4();
                      setInterval(drawClock16_4, 100);

                      function drawClock16_4() {
                        clock16_4();
                        drawWBlackNumbers(ctx, radius);
                        timing16_4();
                      }
                      // стрелки
                      function timing16_4() {
                        const d = new Date();
                        angle =
                          Math.PI * 2 * (d.getSeconds() / 60) -
                          (Math.PI * 2) / 4;

                        // часовая
                        ctx.beginPath();
                        ctx.lineWidth = 5;
                        ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                        ctx.moveTo(center_x, center_y);
                        ctx.lineTo(
                          center_x +
                            Math.sin((d.getHours() * Math.PI) / 6) *
                              radius *
                              0.4,
                          center_y -
                            Math.cos((d.getHours() * Math.PI) / 6) *
                              radius *
                              0.4
                        );
                        ctx.stroke();
                        ctx.closePath();
                        //минутная
                        ctx.beginPath();
                        ctx.lineWidth = 5;
                        ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                        ctx.moveTo(center_x, center_y);
                        ctx.lineTo(
                          center_x +
                            Math.sin((d.getMinutes() * Math.PI) / 30) *
                              radius *
                              0.7,
                          center_y -
                            Math.cos((d.getMinutes() * Math.PI) / 30) *
                              radius *
                              0.7
                        );
                        ctx.stroke();
                        ctx.closePath();
                        // секундная
                        ctx.lineWidth = 3;
                        ctx.beginPath();
                        ctx.moveTo(center_x, center_y);
                        ctx.lineTo(
                          canvas.width / 2 + (Math.cos(angle) * 60 * 25) / 14,
                          canvas.height / 2 + (Math.sin(angle) * 60 * 25) / 14
                        );
                        ctx.moveTo(canvas.width / 2, canvas.height / 2);
                        ctx.lineTo(
                          canvas.width / 2 - Math.cos(angle) * 20,
                          canvas.height / 2 - Math.sin(angle) * 20
                        );
                        ctx.strokeStyle = "rgb(57, 182, 251, 1)";
                        ctx.stroke();
                        ctx.closePath();

                        ctx.beginPath(); // начало нового пути
                        ctx.fillStyle = "rgba(57, 182, 251, 1)";
                        // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                        ctx.arc(center_x, center_y, 8, 0, 2 * pi, false);
                        ctx.fill();
                        ctx.closePath();
                        ctx.beginPath(); // начало нового пути
                        ctx.fillStyle = "rgba(255, 255, 255, 1)";
                        // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                        ctx.arc(center_x, center_y, 5, 0, 2 * pi, false);
                        ctx.fill();
                        ctx.closePath();
                      }
                      // отрисовка цифры белые
                      function drawWBlackNumbers(ctx, radius) {
                        var ang;
                        var num;
                        ctx.fillStyle = "white";
                        ctx.font = radius * 0.18 + "px Montserrat";
                        ctx.textBaseline = "middle";
                        ctx.textAlign = "center";
                        for (num = 1; num < 13; num++) {
                          ang = (num * Math.PI) / 6;
                          ctx.rotate(ang);
                          ctx.translate(0, -radius * 0.85);
                          ctx.rotate(-ang);
                          ctx.fillText(num.toString(), center_x, center_y);
                          ctx.rotate(ang);
                          ctx.translate(0, radius * 0.85);
                          ctx.rotate(-ang);
                        }
                      }
                      function fill(fn, params) {
                        ctx.beginPath();
                        fn(params);
                        ctx.fill();
                        ctx.closePath();
                      }
                      function clock16_4() {
                        canvas = document.getElementById("canvas16-4");
                        ctx = canvas.getContext("2d");
                        ctx.beginPath(); // начало нового пути
                        ctx.lineWidth = 3;
                        ctx.fillStyle = "rgba(30, 30, 30, 1)";
                        ctx.strokeStyle = "rgba(57, 182, 251, 1)";
                        // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                        ctx.arc(center_x, center_y, radius, 0, 2 * pi, false);
                        ctx.fill();
                        ctx.stroke();
                        ctx.closePath();
                      }
                    }
                  </script>
                </canvas>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="dropright-1">
      <button class="drop-1">
        Цифровые часы <br />
        16, 18 вариант
      </button>
      <div class="drop-content-1">
        <div class="navbar-2">
          <div class="dropdown-2">
            <button
              class="drop-2"
              id="btn-11-1"
              onclick="alert(getCode('btn-11-1'))"
            >
              <div class="design-2 widget-digital-clock-16-1-widget digital-clock-XL">
                <p id="hour-minutes16-1"></p>
                <p id="seconds16-1"></p>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-2-2: 252px;
                    --size-4-2: 516px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-digital-clock-16-1-widget {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: var(--size-4-2);
                    height: var(--size-2-2);
                  }
                  .widget-digital-clock-16-1-widget p {
                    font-family: Montserrat;
                    font-size: 130px;
                    font-weight: 100;
                    background-image: linear-gradient(
                      0deg,
                      rgba(57, 182, 251, 1) 0%,
                      rgba(57, 182, 251, 1) 50%,
                      rgba(255, 255, 251, 1) 50%,
                      rgba(255, 255, 251, 1) 100%
                    );
                    background-clip: text;
                    -webkit-background-clip: text;
                    color: transparent;
                  }
                  .widget-digital-clock-16-1-widget p:nth-child(1) {
                    width: 365px;
                    text-align: center;
                  }
                  .widget-digital-clock-16-1-widget p:nth-child(2) {
                    width: 93px;
                    margin-top: 50px;
                    font-size: 70px;
                    color: var(--actent-color);
                    text-align: end;
                  }
                </style>
                <script>
                  setInterval(function setTime_16_1() {
                    d = new Date();
                    document.getElementById(
                      "hour-minutes16-1"
                    ).innerHTML = \`\${d.toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}\`;
                    document.getElementById(
                      "seconds16-1"
                    ).innerHTML = \`\${d.toLocaleTimeString([], {
                      second: "2-digit",
                    })}\`;
                  }, 100);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-11-2"
              onclick="alert(getCode('btn-11-2'))"
            >
              <div class="design-2 widget-digital-clock-11-2-widget digital-clock-XL">
                <p id="hour-minutes16-2">00:00</p>
                <p id="seconds16-2">00</p>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-2-2: 252px;
                    --size-4-2: 516px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-digital-clock-11-2-widget {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: var(--size-4-2);
                    height: var(--size-2-2);
                  }
                  .widget-digital-clock-11-2-widget p {
                    font-family: Montserrat;
                    font-size: 130px;
                    font-weight: 100;
                    color: white;
                  }
                  .widget-digital-clock-11-2-widget p:nth-child(1) {
                    width: 365px;
                    text-align: center;
                  }
                  .widget-digital-clock-11-2-widget p:nth-child(2) {
                    width: 93px;
                    margin-top: 50px;
                    font-size: 70px;
                    color: rgba(115, 115, 115, 1);
                    text-align: start;
                  }
                </style>
                <script>
                  setInterval(function setTime_16_2() {
                    d = new Date();
                    document.getElementById(
                      "hour-minutes16-2"
                    ).innerHTML = \`\${d.toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}\`;
                    document.getElementById(
                      "seconds16-2"
                    ).innerHTML = \`\${d.toLocaleTimeString([], {
                      second: "2-digit",
                    })}\`;
                  }, 100);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-11-3"
              onclick="alert(getCode('btn-11-3'))"
            >
              <div class="design-2 widget-digital-clock-11-3-widget digital-clock-L">
                <p id="hours16-3"></p>
                <p>:</p>
                <p id="minutes16-3"></p>
                <p>:</p>
                <p id="seconds16-3"></p>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --size-3-2: 384px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-digital-clock-11-3-widget {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: var(--size-3-2);
                    height: var(--size-1-2);
                  }
                  .widget-digital-clock-11-3-widget p {
                    font-family: Montserrat;
                    color: white;
                    font-size: 70px;
                    font-weight: 100;
                    text-align: center;
                  }
                  .widget-digital-clock-11-3-widget p:nth-child(2n + 1) {
                    width: 92px;
                  }
                  .widget-digital-clock-11-3-widget p:nth-child(2n + 2) {
                    width: 20px;
                  }
                  .widget-digital-clock-11-3-widget p:nth-child(5) {
                    color: rgba(115, 115, 115, 1);
                  }
                  .widget-digital-clock-11-3-widget p:nth-child(2) {
                    color: var(--actent-color);
                  }
                  .widget-digital-clock-11-3-widget p:nth-child(4) {
                    color: var(--actent-color);
                  }
                </style>
                <script>
                  setInterval(function setTime_16_3() {
                    d = new Date();
                    document.getElementById(
                      "hours16-3"
                    ).innerHTML = \`\${d.toLocaleTimeString([], {
                      hour: "2-digit",
                    })}\`;
                    document.getElementById(
                      "minutes16-3"
                    ).innerHTML = \`\${d.toLocaleTimeString([], {
                      minute: "2-digit",
                    })}\`;
                    document.getElementById(
                      "seconds16-3"
                    ).innerHTML = \`\${d.toLocaleTimeString([], {
                      second: "2-digit",
                    })}\`;
                  }, 100);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-11-4"
              onclick="alert(getCode('btn-11-4'))"
            >
              <div class="design-2 widget-digital-clock-16-4-widget digital-clock-S">
                <p id="hours16-4"></p>
                <p>:</p>
                <p id="minutes16-4"></p>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --size-2-2: 252px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-digital-clock-16-4-widget {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: var(--size-2-2);
                    height: var(--size-1-2);
                  }
                  .widget-digital-clock-16-4-widget p {
                    font-family: Montserrat;
                    width: 90px;
                    color: white;
                    font-size: 70px;
                    font-weight: 100;
                  }
                  .widget-digital-clock-16-4-widget p:nth-child(2) {
                    color: var(--actent-color);
                    width: 20px;
                  }
                </style>
                <script>
                  setInterval(function setTime_16_4() {
                    d = new Date();
                    document.getElementById(
                      "hours16-4"
                    ).innerHTML = \`\${d.toLocaleTimeString([], {
                      hour: "2-digit",
                    })}\`;
                    document.getElementById(
                      "minutes16-4"
                    ).innerHTML = \`\${d.toLocaleTimeString([], {
                      minute: "2-digit",
                    })}\`;
                  }, 100);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-11-5"
              onclick="alert(getCode('btn-11-5'))"
            >
              <div class="design-2 widget-digital-clock-16-5-widget digital-clock-S">
                <p id="hours16-5"></p>
                <p>:</p>
                <p id="minutes16-5"></p>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --size-2-2: 252px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-digital-clock-16-5-widget {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: var(--size-2-2);
                    height: var(--size-1-2);
                  }
                  .widget-digital-clock-16-5-widget p {
                    font-family: Montserrat;
                    color: white;
                    font-size: 70px;
                    font-weight: 100;
                    text-align: center;
                    width: 90px;
                  }
                  .widget-digital-clock-16-5-widget p:nth-child(2) {
                    width: 20px;
                  }
                </style>
                <script>
                  setInterval(function setTime_16_5() {
                    d = new Date();
                    document.getElementById(
                      "hours16-5"
                    ).innerHTML = \`\${d.toLocaleTimeString([], {
                      hour: "2-digit",
                    })}\`;
                    document.getElementById(
                      "minutes16-5"
                    ).innerHTML = \`\${d.toLocaleTimeString([], {
                      minute: "2-digit",
                    })}\`;
                  }, 100);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-11-6"
              onclick="alert(getCode('btn-11-6'))"
            >
              <div class="design-2 widget-digital-clock-16-6-widget digital-clock-M">
                <p id="hours16-6"></p>
                <p>:</p>
                <p id="minutes16-6"></p>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-2-2: 252px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-digital-clock-16-6-widget {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: var(--size-2-2);
                    height: var(--size-2-2);
                  }
                  .widget-digital-clock-16-6-widget p {
                    font-family: Montserrat;
                    color: white;
                    font-size: 70px;
                    font-weight: 100;
                    border-bottom: 3px solid rgba(57, 182, 251, 1);
                    width: 90px;
                    text-align: center;
                  }
                  .widget-digital-clock-16-6-widget p:nth-child(2) {
                    width: 20px;
                  }
                </style>
                <script>
                  setInterval(function setTime_16_6() {
                    d = new Date();
                    document.getElementById(
                      "hours16-6"
                    ).innerHTML = \`\${d.toLocaleTimeString([], {
                      hour: "2-digit",
                    })}\`;
                    document.getElementById(
                      "minutes16-6"
                    ).innerHTML = \`\${d.toLocaleTimeString([], {
                      minute: "2-digit",
                    })}\`;
                  }, 100);
                </script>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="dropright-1">
      <button class="drop-1">
        Календари <br />
        16, 18 вариант
      </button>
      <div class="drop-content-1">
        <div class="navbar-2">
          <div class="dropdown-2">
            <button
              class="drop-2"
              id="btn-12-1"
              onclick="alert(getCode('btn-12-1'))"
            >
              <div class="design-2 widget-calendar-16-1-widget calendar-XL">
                <table id="calendar16-1">
                  <thead>
                    <tr>
                      <td
                        style="
                          font-weight: 500;
                          text-decoration: underline 3px rgba(27, 182, 251, 1);
                          text-align: center;
                          width: 100%;
                        "
                        colspan="7"
                      ></td>
                      <td>
                        <tr style="font-weight: 500">
                          <td>пн</td>
                          <td>вт</td>
                          <td>ср</td>
                          <td>чт</td>
                          <td>пт</td>
                          <td>сб</td>
                          <td>вс</td>
                        </tr>
                      </td>
                    </tr>
                  </thead>
                  <tbody id="body-calendar-16-1"></tbody>
                </table>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-3-2: 384px;
                    --size-4-2: 516px;
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  #calendar16-1 {
                    text-align: center;
                    font-size: 26px;
                    color: white;
                    font-weight: 300;
                    border-spacing: 20px 4px;
                    display: flex;
                    flex-direction: column;
                    margin: auto;
                    /* width: 464px; */
                    justify-content: space-around;
                  }
                  .widget-calendar-16-1-widget {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-family: Montserrat;
                    width: var(--size-4-2);
                    height: var(--size-3-2);
                  }
                  #today-16-1 {
                    border: 3px solid rgba(27, 182, 251, 1);
                    border-radius: 50%;
                  }
                  #body-calendar-16-1 tr td {
                    width: 46px;
                    height: 46px;
                    text-align: center;
                  }
                  thead tr:nth-child(1) {
                    display: flex;
                    justify-content: center;
                  }
                  thead tr:nth-child(2) {
                    display: flex;
                    justify-content: space-evenly;
                    align-items: flex-end;
                    height: 60px;
                  }
                  thead tr td {
                    width: 46px;
                  }
                </style>
                <script>
                  const getCalendar_16_1 = () => {
                    var D1 = new Date(),
                      D1last = new Date(
                        D1.getFullYear(),
                        D1.getMonth() + 1,
                        0
                      ).getDate(), // последний день месяца
                      D1Nlast = new Date(
                        D1.getFullYear(),
                        D1.getMonth(),
                        D1last
                      ).getDay(), // день недели последнего дня месяца
                      D1Nfirst = new Date(
                        D1.getFullYear(),
                        D1.getMonth(),
                        1
                      ).getDay(), // день недели первого дня месяца
                      calendar1 = "<tr>",
                      month = [
                        "Январь",
                        "Февраль",
                        "Март",
                        "Апрель",
                        "Май",
                        "Июнь",
                        "Июль",
                        "Август",
                        "Сентябрь",
                        "Октябрь",
                        "Ноябрь",
                        "Декабрь",
                      ]; // название месяца, вместо цифр 0-11

                    // пустые клетки до первого дня текущего месяца
                    if (D1Nfirst != 0) {
                      for (var i = 1; i < D1Nfirst; i++) calendar1 += "<td>";
                    } else {
                      // если первый день месяца выпадает на воскресенье, то требуется 7 пустых клеток
                      for (var i = 0; i < 6; i++) calendar1 += "<td>";
                    }

                    // дни месяца
                    for (var i = 1; i <= D1last; i++) {
                      if (i != D1.getDate()) {
                        calendar1 += "<td>" + i;
                      } else {
                        calendar1 += '<td id="today-16-1">' + i; // сегодняшней дате можно задать стиль CSS
                      }
                      if (
                        new Date(D1.getFullYear(), D1.getMonth(), i).getDay() ==
                        0
                      ) {
                        // если день выпадает на воскресенье, то перевод строки
                        calendar1 += "<tr>";
                      }
                    }

                    // пустые клетки после последнего дня месяца
                    if (D1Nlast != 0) {
                      for (var i = D1Nlast; i < 7; i++) calendar1 += "<td>";
                    }

                    document.querySelector("#calendar16-1 tbody").innerHTML =
                      calendar1;
                    // document.querySelector('#calendar16-1 thead td:last-child').innerHTML = D1.getFullYear();
                    document.querySelector(
                      "#calendar16-1 thead td:first-child"
                    ).innerHTML = month[D1.getMonth()];
                  };
                  getCalendar_16_1();
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-12-2"
              onclick="alert(getCode('btn-12-2'))"
            >
              <div class="design-2 widget-date-16-2-widget dates-L">
                <p id="current-day-16-2"></p>
                <div class="space-div-11-1"></div>
                <p id="current-date-16-2"></p>
                <div class="space-div-11-1"></div>
                <p id="current-month-16-2"></p>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --size-4-2: 516px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-date-16-2-widget {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: var(--size-4-2);
                    height: var(--size-1-2);
                  }
                  .widget-date-16-2-widget p {
                    font-family: Montserrat;
                    color: white;
                    font-size: 26px;
                  }
                  .space-div-11-1 {
                    width: 8px;
                  }
                  .widget-date-16-2-widget p:nth-child(3) {
                    height: 30px;
                    text-decoration: underline 2px rgba(57, 182, 251, 1);
                  }
                </style>
                <script>
                  const currentDay_16_2 = () => {
                    let date = new Date();
                    let days = [
                      "Воскресенье",
                      "Понедельник",
                      "Вторник",
                      "Среда",
                      "Четверг",
                      "Пятница",
                      "Суббота",
                    ];
                    return \`\${days[date.getDay()]}, \`;
                  };
                  const currentDate_16_2 = () => {
                    let date = new Date();
                    return \`\${date.getDate()}\`;
                  };
                  const currentMonth_16_2 = () => {
                    let date = new Date();
                    let month = [
                      "января",
                      "февраля",
                      "марта",
                      "апреля",
                      "мая",
                      "июня",
                      "июля",
                      "августа",
                      "сентября",
                      "октября",
                      "ноября",
                      "декабря",
                    ];
                    return \`\${month[date.getMonth()]}\`;
                  };
                  setInterval(() => {
                    document.getElementById("current-day-16-2").innerHTML =
                      currentDay_16_2();
                    document.getElementById("current-date-16-2").innerHTML =
                      currentDate_16_2();
                    document.getElementById("current-month-16-2").innerHTML =
                      currentMonth_16_2();
                  }, 100);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-12-3"
              onclick="alert(getCode('btn-12-3'))"
            >
              <div class="design-2 widget-date-16-3-widget dates-M">
                <p id="previous-date-16-3-2"></p>
                <p id="previous-date-16-3-1"></p>
                <p id="current-date-16-3"></p>
                <p id="next-date-16-3-1"></p>
                <p id="next-date-16-3-2"></p>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-2-2: 252px;
                    --size-3-2: 384px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-date-16-3-widget {
                    display: flex;
                    justify-content: space-evenly;
                    flex-direction: column;
                    align-items: center;
                    width: var(--size-3-2);
                    height: var(--size-2-2);
                  }
                  .widget-date-16-3-widget p {
                    font-family: Montserrat;
                    color: rgba(64, 64, 64, 1);
                    font-size: 20px;
                  }
                  .widget-date-16-3-widget p:nth-child(3) {
                    color: white;
                    font-size: 26px;
                  }
                </style>
                <script>
                  const currentDate_16_3 = () => {
                    let date = new Date();
                    let days = [
                      "Воскресенье",
                      "Понедельник",
                      "Вторник",
                      "Среда",
                      "Четверг",
                      "Пятница",
                      "Суббота",
                    ];
                    let month = [
                      "января",
                      "февраля",
                      "марта",
                      "апреля",
                      "мая",
                      "июня",
                      "июля",
                      "августа",
                      "сентября",
                      "октября",
                      "ноября",
                      "декабря",
                    ];

                    return \`\${days[date.getDay()]}, \${date.getDate()} \${
                      month[date.getMonth()]
                    }\`;
                  };

                  const previous_date_16_3_1 = () => {
                    let date = new Date();
                    let days = [
                      "Воскресенье",
                      "Понедельник",
                      "Вторник",
                      "Среда",
                      "Четверг",
                      "Пятница",
                      "Суббота",
                    ];
                    let month = [
                      "января",
                      "февраля",
                      "марта",
                      "апреля",
                      "мая",
                      "июня",
                      "июля",
                      "августа",
                      "сентября",
                      "октября",
                      "ноября",
                      "декабря",
                    ];
                    let day = date.setDate(date.getDate() - 1);
                    return \`\${days[date.getDay()]}, \${date.getDate()} \${
                      month[date.getMonth()]
                    }\`;
                  };
                  const previous_date_16_3_2 = () => {
                    let date = new Date();
                    let days = [
                      "Воскресенье",
                      "Понедельник",
                      "Вторник",
                      "Среда",
                      "Четверг",
                      "Пятница",
                      "Суббота",
                    ];
                    let month = [
                      "января",
                      "февраля",
                      "марта",
                      "апреля",
                      "мая",
                      "июня",
                      "июля",
                      "августа",
                      "сентября",
                      "октября",
                      "ноября",
                      "декабря",
                    ];
                    let day = date.setDate(date.getDate() - 2);
                    return \`\${days[date.getDay()]}, \${date.getDate()} \${
                      month[date.getMonth()]
                    }\`;
                  };
                  const next_date_16_3_1 = () => {
                    let date = new Date();
                    let days = [
                      "Воскресенье",
                      "Понедельник",
                      "Вторник",
                      "Среда",
                      "Четверг",
                      "Пятница",
                      "Суббота",
                    ];
                    let month = [
                      "января",
                      "февраля",
                      "марта",
                      "апреля",
                      "мая",
                      "июня",
                      "июля",
                      "августа",
                      "сентября",
                      "октября",
                      "ноября",
                      "декабря",
                    ];
                    let day = date.setDate(date.getDate() + 1);
                    return \`\${days[date.getDay()]}, \${date.getDate()} \${
                      month[date.getMonth()]
                    }\`;
                  };
                  const next_date_16_3_2 = () => {
                    let date = new Date();
                    let days = [
                      "Воскресенье",
                      "Понедельник",
                      "Вторник",
                      "Среда",
                      "Четверг",
                      "Пятница",
                      "Суббота",
                    ];
                    let month = [
                      "января",
                      "февраля",
                      "марта",
                      "апреля",
                      "мая",
                      "июня",
                      "июля",
                      "августа",
                      "сентября",
                      "октября",
                      "ноября",
                      "декабря",
                    ];
                    let day = date.setDate(date.getDate() + 2);
                    return \`\${days[date.getDay()]}, \${date.getDate()} \${
                      month[date.getMonth()]
                    }\`;
                  };

                  setInterval(() => {
                    document.getElementById("current-date-16-3").innerHTML =
                      currentDate_16_3();
                    document.getElementById("previous-date-16-3-1").innerHTML =
                      previous_date_16_3_1();
                    document.getElementById("previous-date-16-3-2").innerHTML =
                      previous_date_16_3_2();
                    document.getElementById("next-date-16-3-1").innerHTML =
                      next_date_16_3_1();
                    document.getElementById("next-date-16-3-2").innerHTML =
                      next_date_16_3_2();
                  }, 100);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-12-4"
              onclick="alert(getCode('btn-12-4'))"
            >
              <div class="design-2 widget-date-16-4-widget dates-M">
                <p id="previous-date-16-4-2"></p>
                <p id="previous-date-16-4-1"></p>
                <p id="current-date-16-4"></p>
                <p id="next-date-16-4-1"></p>
                <p id="next-date-16-4-2"></p>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-2-2: 252px;
                    --size-3-2: 384px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-date-16-4-widget {
                    display: flex;
                    justify-content: space-evenly;
                    flex-direction: column;
                    align-items: center;
                    width: var(--size-3-2);
                    height: var(--size-2-2);
                  }
                  .widget-date-16-4-widget p {
                    font-family: Montserrat;
                    color: rgba(64, 64, 64, 1);
                    font-size: 22px;
                  }
                  .widget-date-16-4-widget p:nth-child(3) {
                    color: white;
                    font-size: 30px;
                  }
                </style>
                <script>
                  const currentDate_16_4 = () => {
                    let date = new Date();
                    let days = [
                      "Воскресенье",
                      "Понедельник",
                      "Вторник",
                      "Среда",
                      "Четверг",
                      "Пятница",
                      "Суббота",
                    ];

                    return \`\${days[date.getDay()]}\`;
                  };

                  const previous_date_16_4_1 = () => {
                    let date = new Date();
                    let days = [
                      "Воскресенье",
                      "Понедельник",
                      "Вторник",
                      "Среда",
                      "Четверг",
                      "Пятница",
                      "Суббота",
                    ];

                    let day = date.setDate(date.getDate() - 1);
                    return \`\${days[date.getDay()]}\`;
                  };
                  const previous_date_16_4_2 = () => {
                    let date = new Date();
                    let days = [
                      "Воскресенье",
                      "Понедельник",
                      "Вторник",
                      "Среда",
                      "Четверг",
                      "Пятница",
                      "Суббота",
                    ];
                    let day = date.setDate(date.getDate() - 2);
                    return \`\${days[date.getDay()]}\`;
                  };
                  const next_date_16_4_1 = () => {
                    let date = new Date();
                    let days = [
                      "Воскресенье",
                      "Понедельник",
                      "Вторник",
                      "Среда",
                      "Четверг",
                      "Пятница",
                      "Суббота",
                    ];
                    let day = date.setDate(date.getDate() + 1);
                    return \`\${days[date.getDay()]}\`;
                  };
                  const next_date_16_4_2 = () => {
                    let date = new Date();
                    let days = [
                      "Воскресенье",
                      "Понедельник",
                      "Вторник",
                      "Среда",
                      "Четверг",
                      "Пятница",
                      "Суббота",
                    ];
                    let day = date.setDate(date.getDate() + 2);
                    return \`\${days[date.getDay()]}\`;
                  };

                  setInterval(() => {
                    document.getElementById("current-date-16-4").innerHTML =
                      currentDate_16_4();
                    document.getElementById("previous-date-16-4-1").innerHTML =
                      previous_date_16_4_1();
                    document.getElementById("previous-date-16-4-2").innerHTML =
                      previous_date_16_4_2();
                    document.getElementById("next-date-16-4-1").innerHTML =
                      next_date_16_4_1();
                    document.getElementById("next-date-16-4-2").innerHTML =
                      next_date_16_4_2();
                  }, 100);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-12-5"
              onclick="alert(getCode('btn-12-5'))"
            >
              <div class="design-2 widget-date-16-5-widget dates-S">
                <p id="current-day-16-5"></p>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-2-2: 252px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-date-16-5-widget {
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    align-items: center;
                    width: var(--size-2-2);
                    height: var(--size-2-2);
                  }
                  .widget-date-16-5-widget p {
                    font-family: Montserrat;
                    font-weight: 100;
                    font-size: 150px;
                    background-image: linear-gradient(
                      0deg,
                      rgba(57, 182, 251, 1) 0%,
                      rgba(57, 182, 251, 1) 50%,
                      rgba(255, 255, 251, 1) 50%,
                      rgba(255, 255, 251, 1) 100%
                    );
                    background-clip: text;
                    -webkit-background-clip: text;
                    color: transparent;
                  }
                </style>
                <script>
                  const current_day_16_5 = () => {
                    let date = new Date();
                    return \`\${date.getDate()}\`;
                  };

                  setInterval(() => {
                    document.getElementById("current-day-16-5").innerHTML =
                      current_day_16_5();
                  }, 100);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-12-6"
              onclick="alert(getCode('btn-12-6'))"
            >
              <div class="design-2 widget-date-16-6-widget dates-S">
                <p id="current-day-16-6"></p>
                <p id="current-month-16-6"></p>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-2-2: 252px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-date-16-6-widget {
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    align-items: center;
                    width: var(--size-2-2);
                    height: var(--size-2-2);
                  }
                  .widget-date-16-6-widget p {
                    font-family: Montserrat;
                    font-size: 150px;
                    font-weight: 100;
                  }
                  .widget-date-16-6-widget p:nth-child(1) {
                    background-image: linear-gradient(
                      0deg,
                      rgba(57, 182, 251, 1) 0%,
                      rgba(57, 182, 251, 1) 50%,
                      rgba(255, 255, 251, 1) 50%,
                      rgba(255, 255, 251, 1) 100%
                    );
                    background-clip: text;
                    -webkit-background-clip: text;
                    color: transparent;
                    line-height: 80%;
                  }
                  .widget-date-16-6-widget p:nth-child(2) {
                    color: white;
                    font-weight: 400;
                    font-size: 30px;
                  }
                </style>
                <script>
                  const current_day_16_6 = () => {
                    let date = new Date();
                    return \`\${date.getDate()}\`;
                  };

                  const current_month_16_6 = () => {
                    let date = new Date();
                    let month = [
                      "января",
                      "февраля",
                      "марта",
                      "апреля",
                      "мая",
                      "июня",
                      "июля",
                      "августа",
                      "сентября",
                      "октября",
                      "ноября",
                      "декабря",
                    ];

                    return \`\${month[date.getMonth()]}\`;
                  };

                  setInterval(() => {
                    document.getElementById("current-day-16-6").innerHTML =
                      current_day_16_6();
                    document.getElementById("current-month-16-6").innerHTML =
                      current_month_16_6();
                  }, 100);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-12-7"
              onclick="alert(getCode('btn-12-7'))"
            >
              <div class="design-2 widget-date-16-7-widget dates-XS">
                <p id="current-day-16-7"></p>
                <div class="space-div-12-7"></div>
                <p id="current-month-16-7"></p>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --size-2-2: 252px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-date-16-7-widget {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: var(--size-2-2);
                    height: var(--size-1-2);
                  }
                  .widget-date-16-7-widget p {
                    font-size: 26px;
                    font-weight: 300;
                    font-family: Montserrat;
                    color: white;
                  }
                  .widget-date-16-7-widget p:nth-child(1) {
                    text-decoration: underline 2px rgba(57, 182, 251, 1);
                  }
                  .space-div-12-7 {
                    width: 8px;
                  }
                </style>
                <script>
                  const current_day_16_7 = () => {
                    let date = new Date();
                    return \`\${date.getDate()}\`;
                  };

                  const current_month_16_7 = () => {
                    let date = new Date();
                    let month = [
                      "января",
                      "февраля",
                      "марта",
                      "апреля",
                      "мая",
                      "июня",
                      "июля",
                      "августа",
                      "сентября",
                      "октября",
                      "ноября",
                      "декабря",
                    ];

                    return \`\${month[date.getMonth()]}\`;
                  };

                  setInterval(() => {
                    document.getElementById("current-day-16-7").innerHTML =
                      current_day_16_7();
                    document.getElementById("current-month-16-7").innerHTML =
                      current_month_16_7();
                  }, 100);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-12-8"
              onclick="alert(getCode('btn-12-8'))"
            >
              <div class="design-2 widget-date-16-8-widget dates-XS">
                <p id="current-day-16-8"></p>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --size-2-2: 252px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-date-16-8-widget {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: var(--size-2-2);
                    height: var(--size-1-2);
                  }
                  .widget-date-16-8-widget p {
                    font-size: 26px;
                    font-weight: 300;
                    font-family: Montserrat;
                    color: white;
                  }
                </style>
                <script>
                  const current_day_16_8 = () => {
                    let date = new Date();
                    let days = [
                      "Воскресенье",
                      "Понедельник",
                      "Вторник",
                      "Среда",
                      "Четверг",
                      "Пятница",
                      "Суббота",
                    ];
                    return \`\${days[date.getDay()]}\`;
                  };

                  setInterval(() => {
                    document.getElementById("current-day-16-8").innerHTML =
                      current_day_16_8();
                  }, 100);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-12-9"
              onclick="alert(getCode('btn-12-9'))"
            >
              <div class="design-2 widget-date-16-9-widget dates-XS">
                <p id="current-month-16-9"></p>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --size-2-2: 252px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-date-16-9-widget {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: var(--size-2-2);
                    height: var(--size-1-2);
                  }
                  .widget-date-16-9-widget p {
                    font-size: 26px;
                    font-weight: 300;
                    font-family: Montserrat;
                    color: white;
                  }
                </style>
                <script>
                  const current_month_16_9 = () => {
                    let date = new Date();
                    let month = [
                      "январь",
                      "февраль",
                      "март",
                      "апрель",
                      "май",
                      "июнь",
                      "июль",
                      "август",
                      "сентябрь",
                      "октябрь",
                      "ноябрь",
                      "декабрь",
                    ];

                    return \`\${month[date.getMonth()]}\`;
                  };

                  setInterval(() => {
                    document.getElementById("current-month-16-9").innerHTML =
                      current_month_16_9();
                  }, 100);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-12-10"
              onclick="alert(getCode('btn-12-10'))"
            >
              <div class="design-2 widget-date-16-10-widget dates-XS">
                <p id="current-month-16-10"></p>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --size-2-2: 252px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-date-16-10-widget {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: var(--size-2-2);
                    height: var(--size-1-2);
                  }
                  .widget-date-16-10-widget p {
                    font-size: 26px;
                    font-weight: 300;
                    font-family: Montserrat;
                    color: white;
                  }
                </style>
                <script>
                  const current_month_16_10 = () => {
                    let date = new Date();
                    let month = [
                      "января",
                      "февраля",
                      "марта",
                      "апреля",
                      "мая",
                      "июня",
                      "июля",
                      "августа",
                      "сентября",
                      "октября",
                      "ноября",
                      "декабря",
                    ];

                    return \`\${month[date.getMonth()]}\`;
                  };

                  setInterval(() => {
                    document.getElementById("current-month-16-10").innerHTML =
                      current_month_16_10();
                  }, 100);
                </script>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="dropright-1">
      <button class="drop-1">
        Погода <br />
        16, 18 вариант
      </button>
      <div class="drop-content-1">
        <div class="navbar-2">
          <div class="dropdown-2">
            <button
              class="drop-2"
              id="btn-13-1"
              onclick="alert(getCode('btn-13-1'))"
            >
              <div class="design-2 widget-weather-16-1-widget weather-XL">
                <div class="current-weather-16-1">
                  <img id="current-status-img-16-1" src="" alt="" />
                  <p id="current-status-16-1"></p>
                  <p id="current-weather-16-1"></p>
                </div>
                <div class="time-16-1">
                  <div>
                    <p>04:00</p>
                    <p>12:00</p>
                    <p>20:00</p>
                  </div>
                  <div>
                    <img id="status-img-16-1-1" src="" alt="" />
                    <img id="status-img-16-1-2" src="" alt="" />
                    <img id="status-img-16-1-3" src="" alt="" />
                  </div>
                  <div>
                    <p id="weather-16-1-1"></p>
                    <p id="weather-16-1-2"></p>
                    <p id="weather-16-1-3"></p>
                  </div>
                </div>

                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-2-2: 252px;
                    --size-4-2: 516px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                    --color-icon: "";
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .space-div-13-1 {
                    width: 91px;
                  }
                  .widget-weather-16-1-widget {
                    display: flex;
                    justify-content: space-evenly;
                    width: var(--size-4-2);
                    height: var(--size-2-2);
                  }
                  .current-weather-16-1 {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                  }
                  .current-weather-16-1 img {
                    width: 60px;
                    height: 60px;
                    filter: var(--color-icon);
                  }

                  .current-weather-16-1 p {
                    color: white;
                    font-size: 70px;
                    font-weight: 200;
                    font-family: Montserrat;
                  }
                  .current-weather-16-1 p:nth-child(2) {
                    font-size: 26px;
                    color: rgba(115, 115, 115, 1);
                    text-align:center;
                  }
                  .time-16-1 {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    width: 320px;
                    color: white;
                    font-size: 26px;
                    font-family: Montserrat;
                    font-weight: 400;
                  }
                  .time-16-1 div {
                    display: flex;
                    justify-content: space-evenly;
                  }
                  .time-16-1 img {
                    width: 60px;
                    height: 60px;
                  }
                </style>
                <script>
                  const getWeather16_1 = () => {
                    fetch("http://212.41.9.251:8000/get_weather", {
                      method: "GET",
                      headers: {
                        accept: "application/json",
                      },
                    })
                      .then((response) => response.json())
                      .then((result) => {
                        document.getElementById(
                          "current-weather-16-1"
                        ).innerHTML = result[0][0];
                        document.getElementById(
                          "current-status-16-1"
                        ).innerHTML = result[0][1];
                        document.getElementById("weather-16-1-1").innerHTML =
                          result[1][0][0];
                        document.getElementById("weather-16-1-2").innerHTML =
                          result[1][1][0];
                        document.getElementById("weather-16-1-3").innerHTML =
                          result[1][3][0];

                        const weather = {
                          Ясно: "http://212.41.9.251:8000/static/weather_clear_16.svg",
                          Облачно:
                            "http://212.41.9.251:8000/static/weather_cloudy_16.svg",
                          "Переменная облачность":
                            "http://212.41.9.251:8000/static/weather_p_cloudy_16.svg",
                          "Местами дождь":
                            "http://212.41.9.251:8000/static/weather_rain_16.svg",
                          "Местами грозы": "",
                          "Местами легкий дождь с грозой":
                            "http://212.41.9.251:8000/static/weather_rain_16.svg",
                          "Моросящий дождь":
                            "http://212.41.9.251:8000/static/weather_rain_16.svg",
                        };

                        for (key in weather) {
                          if (key == result[0][1]) {
                            document
                              .getElementById("current-status-img-16-1")
                              .setAttribute("src", weather[key]);
                          }
                          if (key == result[1][0][1]) {
                            document
                              .getElementById("status-img-16-1-1")
                              .setAttribute("src", weather[key]);
                          }
                          if (key == result[1][1][1]) {
                            document
                              .getElementById("status-img-16-1-2")
                              .setAttribute("src", weather[key]);
                          }
                          if (key == result[1][2][1]) {
                            document
                              .getElementById("status-img-16-1-3")
                              .setAttribute("src", weather[key]);
                          }
                        }
                      });
                  };
                  setTimeout(() => {
                    setInterval(() => {
                      getWeather16_1;
                    }, 30000);
                    getWeather16_1();
                  }, 1000);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-13-2"
              onclick="alert(getCode('btn-13-2'))"
            >
              <div class="design-2 widget-weather-16-2-widget weather-L">
                <img id="current-status-img-16-2" src="" alt="" />
                <p id="current-weather-16-2"></p>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --size-3-2: 384px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                    --color-icon: "";
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-weather-16-2-widget {
                    display: flex;
                    justify-content: space-evenly;
                    align-items: center;
                    width: var(--size-3-2);
                    height: var(--size-1-2);
                  }
                  .widget-weather-16-2-widget img {
                    width: 120px;
                    height: 120px;
                    filter: var(--color-icon);
                  }
                  .widget-weather-16-2-widget p {
                    color: white;
                    font-family: Montserrat;
                    font-size: 70px;
                    font-weight: 2 00;
                  }
                </style>
                <script>
                  const getWeather16_2 = () => {
                    fetch("http://212.41.9.251:8000/get_weather", {
                      method: "GET",
                      headers: {
                        accept: "application/json",
                      },
                    })
                      .then((response) => response.json())
                      .then((result) => {
                        document.getElementById(
                          "current-weather-16-2"
                        ).innerHTML = result[0][0];

                        const weather = {
                          Ясно: "http://212.41.9.251:8000/static/weather_clear_16.svg",
                          Облачно:
                            "http://212.41.9.251:8000/static/weather_cloudy_16.svg",
                          "Переменная облачность":
                            "http://212.41.9.251:8000/static/weather_p_cloudy_16.svg",
                          "Местами дождь":
                            "http://212.41.9.251:8000/static/weather_rain_16.svg",
                          "Местами грозы": "",
                          "Местами легкий дождь с грозой":
                            "http://212.41.9.251:8000/static/weather_rain_16.svg",
                          "Моросящий дождь":
                            "http://212.41.9.251:8000/static/weather_rain_16.svg",
                        };

                        for (key in weather) {
                          if (key == result[0][1]) {
                            document
                              .getElementById("current-status-img-16-2")
                              .setAttribute("src", weather[key]);
                          }
                        }
                      });
                  };
                  setTimeout(() => {
                    setInterval(() => {
                      getWeather16_2;
                    }, 30000);
                    getWeather16_2();
                  }, 5000);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-13-3"
              onclick="alert(getCode('btn-13-3'))"
            >
              <div class="design-2 widget-weather-16-3-widget weather-M">
                <div>
                  <img id="current-status-img-16-3" src="" alt="" />
                  <p id="current-status-16-3"></p>
                  <p id="current-weather-16-3"></p>
                </div>

                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-2-2: 252px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                    --color-icon: "";
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-weather-16-3-widget {
                    display: flex;
                    width: var(--size-2-2);
                    height: var(--size-2-2);
                    justify-content: center;
                    text-align: start;
                  }
                  .widget-weather-16-3-widget div {
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    padding: 10px;
                  }
                  .widget-weather-16-3-widget p {
                    font-family: Montserrat;
                    font-size: 70px;
                    color: white;
                  }
                  .widget-weather-16-3-widget img {
                    width: 60px;
                    height: 60px;
                    filter: var(--color-icon);
                  }
                  .widget-weather-16-3-widget p:nth-child(2) {
                    color: rgba(115, 115, 115, 1);
                    font-size: 30px;
                  }
                  .widget-weather-16-3-widget p:nth-child(3) {
                    font-weight: 200;
                  }
                </style>
                <script>
                  const getWeather16_3 = () => {
                    fetch("http://212.41.9.251:8000/get_weather", {
                      method: "GET",
                      headers: {
                        accept: "application/json",
                      },
                    })
                      .then((response) => response.json())
                      .then((result) => {
                        document.getElementById(
                          "current-weather-16-3"
                        ).innerHTML = result[0][0];
                        document.getElementById(
                          "current-status-16-3"
                        ).innerHTML = result[0][1];

                        const weather = {
                          Ясно: "http://212.41.9.251:8000/static/weather_clear_16.svg",
                          Облачно:
                            "http://212.41.9.251:8000/static/weather_cloudy_16.svg",
                          "Переменная облачность":
                            "http://212.41.9.251:8000/static/weather_p_cloudy_16.svg",
                          "Местами дождь":
                            "http://212.41.9.251:8000/static/weather_rain_16.svg",
                          "Местами грозы": "",
                          "Местами легкий дождь с грозой":
                            "http://212.41.9.251:8000/static/weather_rain_16.svg",
                          "Моросящий дождь":
                            "http://212.41.9.251:8000/static/weather_rain_16.svg",
                        };

                        for (key in weather) {
                          if (key == result[0][1]) {
                            document
                              .getElementById("current-status-img-16-3")
                              .setAttribute("src", weather[key]);
                          }
                        }
                      });
                  };
                  setTimeout(() => {
                    setInterval(() => {
                      getWeather16_3;
                    }, 30000);
                    getWeather16_3();
                  }, 5000);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-13-4"
              onclick="alert(getCode('btn-13-4'))"
            >
              <div class="design-2 widget-weather-16-4-widget weather-S">
                <p id="current-weather-16-4"></p>
                <p>C</p>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --size-2-2: 252px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-weather-16-4-widget {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: var(--size-2-2);
                    height: var(--size-1-2);
                  }
                  .widget-weather-16-4-widget p {
                    font-family: Montserrat;
                    font-size: 70px;
                    color: white;
                    font-weight: 100;
                  }
                  .widget-weather-16-4-widget p:nth-child(2) {
                    color: rgba(57, 182, 251, 1);
                  }
                </style>
                <script>
                  const getWeather16_4 = () => {
                    fetch("http://212.41.9.251:8000/get_weather", {
                      method: "GET",
                      headers: {
                        accept: "application/json",
                      },
                    })
                      .then((response) => response.json())
                      .then((result) => {
                        document.getElementById(
                          "current-weather-16-4"
                        ).innerHTML = result[0][0];
                      });
                  };
                  setTimeout(() => {
                    setInterval(() => {
                      getWeather16_4;
                    }, 30000);
                    getWeather16_4();
                  }, 5000);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-13-5"
              onclick="alert(getCode('btn-13-5'))"
            >
              <div class="design-2 widget-weather-16-5-widget weather-XS">
                <img id="current-status-img-16-5" src="" alt="" />
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                    --color-icon: "";
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-weather-16-5-widget {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: var(--size-1-2);
                    height: var(--size-1-2);
                  }
                  .widget-weather-16-5-widget img {
                    width: 90px;
                    height: 90px;
                    filter: var(--color-icon);
                  }
                </style>
                <script>
                  const getWeather16_5 = () => {
                    fetch("http://212.41.9.251:8000/get_weather", {
                      method: "GET",
                      headers: {
                        accept: "application/json",
                      },
                    })
                      .then((response) => response.json())
                      .then((result) => {
                        const weather = {
                          Ясно: "http://212.41.9.251:8000/static/weather_clear_16.svg",
                          Облачно:
                            "http://212.41.9.251:8000/static/weather_cloudy_16.svg",
                          "Переменная облачность":
                            "http://212.41.9.251:8000/static/weather_p_cloudy_16.svg",
                          "Местами дождь":
                            "http://212.41.9.251:8000/static/weather_rain_16.svg",
                          "Местами грозы": "",
                          "Местами легкий дождь с грозой":
                            "http://212.41.9.251:8000/static/weather_rain_16.svg",
                          "Моросящий дождь":
                            "http://212.41.9.251:8000/static/weather_rain_16.svg",
                        };

                        for (key in weather) {
                          if (key == result[0][1]) {
                            document
                              .getElementById("current-status-img-16-5")
                              .setAttribute("src", weather[key]);
                          }
                        }
                      });
                  };
                  setTimeout(() => {
                    setInterval(() => {
                      getWeather16_5;
                    }, 30000);
                    getWeather16_5();
                  }, 5000);
                </script>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="dropright-1">
      <button class="drop-1">
        Пробки <br />
        16, 18 вариант
      </button>
      <div class="drop-content-1">
        <div class="navbar-2">
          <div class="dropdown-2">
            <button
              class="drop-2"
              id="btn-14-1"
              onclick="alert(getCode('btn-14-1'))"
            >
              <div class="design-2 widget-traffic-16-1-widget traffic-XL">
                <p>Пробки</p>
                <div class="space-div-14-1"></div>
                <p id="current-traffic-16-1"></p>
                <div class="space-div-14-1"></div>
                <p>баллов</p>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --size-4-2: 516px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-traffic-16-1-widget {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: var(--size-4-2);
                    height: var(--size-1-2);
                  }
                  .widget-traffic-16-1-widget p {
                    font-family: Montserrat;
                    font-weight: 200;
                    color: white;
                    font-size: 32px;
                  }
                  .widget-traffic-16-1-widget p:nth-child(3) {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: rgba(57, 182, 251, 1);
                    font-size: 70px;
                  }
                  .space-div-14-1 {
                    width: 26px;
                  }
                </style>
                <script>
                  const getTraffic_16_1 = () => {
                    min = Math.ceil(1);
                    max = Math.floor(8);
                    return Math.floor(Math.random() * (max - min) + min);
                  };

                  document.getElementById("current-traffic-16-1").innerHTML =
                    getTraffic_16_1();
                  setInterval(() => {
                    document.getElementById("current-traffic-16-1").innerHTML =
                      getTraffic_16_1();
                  }, 1800000);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-14-2"
              onclick="alert(getCode('btn-14-2'))"
            >
              <div class="design-2 widget-traffic-16-2-widget traffic-L">
                <p>Пробки</p>
                <div class="space-div-14-2"></div>
                <p id="current-traffic-16-2"></p>
                <div class="space-div-14-2"></div>
                <p>баллов</p>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --size-3-2: 384px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-traffic-16-2-widget {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: var(--size-3-2);
                    height: var(--size-1-2);
                  }
                  .widget-traffic-16-2-widget p {
                    font-family: Montserrat;
                    font-weight: 200;
                    color: white;
                    font-size: 32px;
                  }
                  .widget-traffic-16-2-widget p:nth-child(3) {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: rgba(57, 182, 251, 1);
                    font-size: 70px;
                  }
                  .space-div-14-2 {
                    width: 16px;
                  }
                </style>
                <script>
                  const getTraffic_16_2 = () => {
                    min = Math.ceil(1);
                    max = Math.floor(8);
                    return Math.floor(Math.random() * (max - min) + min);
                  };

                  document.getElementById("current-traffic-16-2").innerHTML =
                    getTraffic_16_2();
                  setInterval(() => {
                    document.getElementById("current-traffic-16-2").innerHTML =
                      getTraffic_16_2();
                  }, 1800000);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-14-3"
              onclick="alert(getCode('btn-14-3'))"
            >
              <div class="design-2 widget-traffic-16-3-widget traffic-M">
                <p>Пробки</p>
                <div class="space-div-14-3"></div>
                <div>
                  <p id="current-traffic-16-3"></p>
                </div>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --size-2-2: 252px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-traffic-16-3-widget {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: var(--size-2-2);
                    height: var(--size-1-2);
                  }
                  .widget-traffic-16-3-widget p {
                    font-family: Montserrat;
                    font-weight: 200;
                    color: white;
                    font-size: 32px;
                  }
                  .widget-traffic-16-3-widget div:nth-child(3) {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 76px;
                    height: 76px;
                    border: 3px solid rgba(57, 182, 251, 1);
                    border-radius: 50%;
                  }
                  .widget-traffic-16-3-widget div p {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 70px;
                  }
                  .space-div-14-3 {
                    width: 13px;
                  }
                </style>
                <script>
                  const getTraffic_16_3 = () => {
                    min = Math.ceil(1);
                    max = Math.floor(8);
                    return Math.floor(Math.random() * (max - min) + min);
                  };

                  document.getElementById("current-traffic-16-3").innerHTML =
                    getTraffic_16_3();
                  setInterval(() => {
                    document.getElementById("current-traffic-16-3").innerHTML =
                      getTraffic_16_3();
                  }, 1800000);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-14-4"
              onclick="alert(getCode('btn-14-4'))"
            >
              <div class="design-2 widget-traffic-16-4-widget traffic-S">
                <div>
                  <canvas id="canvas16-5" width="100px" height="80px"></canvas>
                </div>
                <div>
                  <p id="current-traffic-16-4"></p>
                </div>
                <div>
                  <p>
                    <canvas
                      id="canvas16-6"
                      width="100px"
                      height="90px"
                    ></canvas>
                  </p>
                </div>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --size-2-2: 252px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-traffic-16-4-widget {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    width: var(--size-1-2);
                    height: var(--size-2-2);
                  }
                  .widget-traffic-16-4-widget div:nth-child(2) {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 60px;
                    height: 60px;
                    border: 3px solid rgba(57, 182, 251, 1);
                    border-radius: 50%;
                  }
                  .widget-traffic-16-4-widget div p {
                    font-size: 30px;
                    font-family: Montserrat;
                    color: white;
                  }
                </style>
                <script>
                  const getTraffic_16_4 = () => {
                    min = Math.ceil(1);
                    max = Math.floor(8);
                    return Math.floor(Math.random() * (max - min) + min);
                  };

                  document.getElementById("current-traffic-16-4").innerHTML =
                    getTraffic_16_4();
                  setInterval(() => {
                    document.getElementById("current-traffic-16-4").innerHTML =
                      getTraffic_16_4();
                  }, 1800000);
                  traffic1();
                  traffic2();
                  function traffic1() {
                    pi = Math.PI;
                    canvas = document.getElementById("canvas16-5");
                    ctx = canvas.getContext("2d");
                    ctx.beginPath(); // начало нового пути
                    ctx.lineWidth = 3;
                    ctx.strokeStyle = "rgba(64, 64, 64, 1)";
                    // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                    ctx.arc(50, 45, 30, 0, 2 * pi, false);
                    ctx.stroke();
                    ctx.closePath();

                    ctx.beginPath(); // начало нового пути
                    ctx.lineWidth = 3;

                    ctx.strokeStyle = "rgba(64, 64, 64, 1)";
                    // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                    ctx.arc(50, 45, 40, pi, 0, false);
                    ctx.stroke();
                    ctx.closePath();
                  }
                  function traffic2() {
                    pi = Math.PI;
                    canvas = document.getElementById("canvas16-6");
                    ctx = canvas.getContext("2d");
                    ctx.beginPath(); // начало нового пути
                    ctx.lineWidth = 3;
                    ctx.strokeStyle = "rgba(64, 64, 64, 1)";
                    // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                    ctx.arc(50, 40, 30, 0, 2 * pi, false);
                    ctx.stroke();
                    ctx.closePath();
                  }
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-14-5"
              onclick="alert(getCode('btn-14-5'))"
            >
              <div class="design-2 widget-traffic-16-5-widget traffic-XS">
                <canvas id="canvas16-7" width="120px" height="120px"></canvas>
                <p id="current-traffic-16-5"></p>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  #current-traffic-16-5 {
                    position: absolute;
                    font-size: 70px;
                    font-family: Montserrat;
                    font-weight: 200;
                    color: white;
                  }
                  .widget-traffic-16-5-widget {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    width: var(--size-1-2);
                    height: var(--size-1 -2);
                  }
                  .widget-traffic-16-5-widget div:nth-child(2) {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 60px;
                    height: 60px;
                    border: 3px solid rgba(57, 182, 251, 1);
                    border-radius: 50%;
                  }
                  .widget-traffic-16-5-widget div p {
                    font-size: 30px;
                    font-family: Montserrat;
                    color: white;
                  }
                </style>
                <script>
                  const getTraffic_16_5 = () => {
                    min = Math.ceil(1);
                    max = Math.floor(8);
                    return Math.floor(Math.random() * (max - min) + min);
                  };

                  document.getElementById("current-traffic-16-5").innerHTML =
                    getTraffic_16_5();
                  setInterval(() => {
                    document.getElementById("current-traffic-16-5").innerHTML =
                      getTraffic_16_5();
                  }, 1800000);
                  traffic3();
                  function traffic3() {
                    canvas = document.getElementById("canvas16-7");
                    ctx = canvas.getContext("2d");
                    ctx.beginPath(); // начало нового пути
                    ctx.lineWidth = 3;
                    ctx.strokeStyle = "rgba(57, 182, 251, 1)";
                    // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                    ctx.arc(
                      60,
                      60,
                      52,
                      0 - (5 * Math.PI) / 6,
                      0 - Math.PI / 6,
                      false
                    );
                    ctx.stroke();
                    ctx.closePath();

                    ctx.beginPath(); // начало нового пути
                    ctx.lineWidth = 3;
                    ctx.strokeStyle = "rgba(57, 182, 251, 1)";
                    // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                    ctx.arc(
                      60,
                      87,
                      69,
                      0 - (73 * Math.PI) / 100,
                      0 - (28 * Math.PI) / 100,
                      false
                    );
                    ctx.stroke();
                    ctx.closePath();

                    ctx.beginPath(); // начало нового пути
                    ctx.lineWidth = 3;
                    ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                    // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                    ctx.arc(
                      60,
                      60,
                      52,
                      0 - Math.PI / 8,
                      Math.PI + Math.PI / 8,
                      false
                    );
                    ctx.stroke();
                    ctx.closePath();
                  }
                </script>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="dropright-1">
      <button class="drop-1">
        Новости <br />
        16, 18 вариант
      </button>
      <div class="drop-content-1">
        <div class="navbar-2">
          <div class="dropdown-2">
            <button
              class="drop-2"
              id="btn-15-1"
              onclick="alert(getCode('btn-15-1'))"
            >
              <div class="design-2 widget-news-16-1-widget news-L">
                <p id="header-news-16-1">------</p>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-2-2: 252px;
                    --size-4-2: 516px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-news-16-1-widget {
                    width: var(--size-4-2);
                    height: var(--size-2-2);
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                  }
                  .widget-news-16-1-widget p {
                    color: white;
                    font-family: Montserrat;
                    font-weight: 300;
                    font-size: 26px;
                    text-align: start;
                    margin-left: 32px;
                    padding-left: 16px;
                    margin-right: 32px;
                    border-left: 3px solid rgba(57, 182, 251, 1);
                  }
                </style>
                <script>
                  const getNews_16_1 = () => {
                    fetch("http://212.41.9.251:8000/news", {
                      method: "GET",
                      headers: {
                        accept: "application/json",
                      },
                    })
                      .then((response) => response.json())
                      .then((result) => {
                        document.getElementById("header-news-16-1").innerHTML =
                          result[0];
                      });
                  };
                  setTimeout(() => {
                    setInterval(() => {
                      getNews_16_1();
                    }, 300000);
                    getNews_16_1();
                  }, 5000);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-15-1"
              onclick="alert(getCode('btn-15-1'))"
            >
              <div class="design-2 widget-news-16-2-widget news-L">
                <div
                  style="
                    width: 40%;
                    height: 3px;
                    background-color: rgba(57, 182, 251, 1);
                    margin-bottom: 26px;
                  "
                ></div>
                <p id="header-news-16-2">------</p>
                <div
                  style="
                    width: 40%;
                    height: 3px;
                    background-color: rgba(57, 182, 251, 1);
                    margin-top: 26px;
                  "
                ></div>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-2-2: 252px;
                    --size-4-2: 516px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-news-16-2-widget {
                    width: var(--size-4-2);
                    height: var(--size-2-2);
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                  }
                  .widget-news-16-2-widget p {
                    color: white;
                    font-family: Montserrat;
                    font-weight: 300;
                    font-size: 26px;
                    text-align: center;
                    padding-left: 28px;
                    padding-right: 28px;
                  }
                </style>
                <script>
                  const getNews_16_2 = () => {
                    fetch("http://212.41.9.251:8000/news", {
                      method: "GET",
                      headers: {
                        accept: "application/json",
                      },
                    })
                      .then((response) => response.json())
                      .then((result) => {
                        document.getElementById("header-news-16-2").innerHTML =
                          result[0];
                      });
                  };
                  setTimeout(() => {
                    setInterval(() => {
                      getNews_16_2();
                    }, 300000);
                    getNews_16_2();
                  }, 5000);
                </script>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="dropright-1">
      <button class="drop-1">
        Курс доллара/евро <br />
        16, 18 вариант
      </button>
      <div class="drop-content-1">
        <div class="navbar-2">
          <div class="dropdown-2">
            <button
              class="drop-2"
              id="btn-16-1"
              onclick="alert(getCode('btn-16-1'))"
            >
              <div class="design-2 widget-rates-16-1-widget rates-L">
                <div>
                  <p id="usd-16-1">0.00</p>
                </div>
                <div style="padding-top: 16px">
                  <canvas
                    id="diagram-16-1"
                    width="272px"
                    height="120px"
                  ></canvas>
                </div>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --size-4-2: 516px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-rates-16-1-widget {
                    display: flex;
                    justify-content: space-evenly;
                    width: var(--size-4-2);
                    height: var(--size-1-2);
                  }
                  .widget-rates-16-1-widget div:nth-child(1) {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    padding-left: 20px;
                    color: white;
                    font-size: 70px;
                    font-family: Montserrat;
                    font-weight: 200;
                    background-image: url("http://212.41.9.251:8000/static/\$.svg");
                    background-repeat: no-repeat;
                  }
                  .space-div-16-1 {
                    width: 26px;
                  }
                </style>
                <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.5.0/Chart.min.js"></script>
                <script>
                  const getUSD_16_1 = async () => {
                    const response = await fetch(
                      "https://www.cbr-xml-daily.ru/daily_json.js",
                      {
                        method: "GET",
                      }
                    );
                    const result = await response.json();
                    return result;
                  };
                  const myChart_16_1 = new Chart(
                    document.getElementById("diagram-16-1").getContext("2d"),
                    {
                      type: "line",
                      data: {
                        labels: ["", "", "", "", "", "", "", "", "", ""],
                        datasets: [
                          {
                            label: "\$",
                            lineTension: 0,
                            data: [
                              0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
                            ],
                            pointRadius: 0,
                            borderColor: "rgba(57, 182, 251, 1)",
                            borderWidth: 4,
                            fill: false,
                          },
                        ],
                      },
                      options: {
                        legend: {
                          display: false,
                          maintainAspectRatio: false,
                        },
                        scales: {
                          xAxes: [
                            {
                              gridLines: {
                                display: false,
                              },
                            },
                          ],
                          yAxes: [
                            {
                              gridLines: {
                                color: "rgba(64,64,64,1)",
                              },
                            },
                          ],
                        },
                      },
                    }
                  );
                  setTimeout(() => {
                    setInterval(() => {
                      getUSD_16_1().then((result) => {
                        document.getElementById("usd-16-1").innerHTML =
                          result.Valute.USD.Value.toFixed(2);
                        myChart_16_1.data.datasets[0].data.splice(0, 1);
                        myChart_16_1.data.datasets[0].data.push(
                          result.Valute.USD.Value.toFixed(2)
                        );
                        myChart_16_1.update();
                      });
                    }, 43200000);
                    getUSD_16_1().then((result) => {
                      document.getElementById("usd-16-1").innerHTML =
                        result.Valute.USD.Value.toFixed(2);

                      const myChart_16_1_1 = new Chart(
                        document
                          .getElementById("diagram-16-1")
                          .getContext("2d"),
                        {
                          type: "line",
                          data: {
                            labels: ["", "", "", "", "", "", "", "", "", ""],
                            datasets: [
                              {
                                label: "\$",
                                lineTension: 0,
                                data: [
                                  87.37, 87.21, 87.07, 88.05, 88.0, 84.96,
                                  85.75, 87.99, 87.95, 88.12,
                                ],
                                pointRadius: 0,
                                borderColor: "rgba(57, 182, 251, 1)",
                                borderWidth: 4,
                                fill: false,
                              },
                            ],
                          },
                          options: {
                            legend: {
                              display: false,
                              maintainAspectRatio: false,
                            },
                            scales: {
                              xAxes: [
                                {
                                  gridLines: {
                                    display: false,
                                  },
                                },
                              ],
                              yAxes: [
                                {
                                  gridLines: {
                                    color: "rgba(64,64,64,1)",
                                  },
                                },
                              ],
                            },
                          },
                        }
                      );
                      myChart_16_1_1.data.datasets[0].data.splice(0, 1);
                      myChart_16_1_1.data.datasets[0].data.push(
                        result.Valute.USD.Value.toFixed(2)
                      );
                      myChart_16_1_1.update();
                    });
                  }, 5000);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-16-2"
              onclick="alert(getCode('btn-16-2'))"
            >
              <div class="design-2 widget-rates-16-2-widget rates-L">
                <div>
                  <p id="eur-16-2">0.00</p>
                </div>
                <div style="padding-top: 16px">
                  <canvas
                    id="diagram-16-2"
                    width="272px"
                    height="120px"
                  ></canvas>
                </div>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --size-4-2: 516px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-rates-16-2-widget {
                    display: flex;
                    justify-content: space-evenly;
                    width: var(--size-4-2);
                    height: var(--size-1-2);
                  }
                  .widget-rates-16-2-widget div:nth-child(1) {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    padding-left: 20px;
                    color: white;
                    font-size: 70px;
                    font-family: Montserrat;
                    font-weight: 200;
                    background-image: url("http://212.41.9.251:8000/static/€.svg");
                    background-repeat: no-repeat;
                    background-position: left;
                    /* background-size: cover; */
                  }
                  .space-div-16-2 {
                    width: 26px;
                  }
                </style>
                <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.5.0/Chart.min.js"></script>
                <script>
                  const getEUR_16_2 = async () => {
                    const response = await fetch(
                      "https://www.cbr-xml-daily.ru/daily_json.js",
                      {
                        method: "GET",
                      }
                    );
                    const data = await response.json();
                    return data;
                  };
                  const myChart_16_2 = new Chart(
                    document.getElementById("diagram-16-2").getContext("2d"),
                    {
                      type: "line",
                      data: {
                        labels: ["", "", "", "", "", "", "", "", "", ""],
                        datasets: [
                          {
                            label: "\$",
                            lineTension: 0,
                            data: [
                              0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
                            ],
                            pointRadius: 0,
                            borderColor: "rgba(57, 182, 251, 1)",
                            borderWidth: 4,
                            fill: false,
                          },
                        ],
                      },
                      options: {
                        legend: {
                          display: false,
                          maintainAspectRatio: false,
                        },
                        scales: {
                          xAxes: [
                            {
                              gridLines: {
                                display: false,
                              },
                            },
                          ],
                          yAxes: [
                            {
                              gridLines: {
                                color: "rgba(64,64,64,1)",
                              },
                            },
                          ],
                        },
                      },
                    }
                  );
                  setTimeout(() => {
                    setInterval(() => {
                      getEUR_16_2().then((result) => {
                        document.getElementById("eur-16-2").innerHTML =
                          result.Valute.EUR.Value.toFixed(2);
                        myChart_16_2.data.datasets[0].data.splice(0, 1);
                        myChart_16_2.data.datasets[0].data.push(
                          result.Valute.EUR.Value.toFixed(2)
                        );
                        myChart_16_2.update();
                      });
                    }, 43200000);
                    getEUR_16_2().then((result) => {
                      document.getElementById("eur-16-2").innerHTML =
                        result.Valute.EUR.Value.toFixed(2);

                      const myChart_16_2_2 = new Chart(
                        document
                          .getElementById("diagram-16-2")
                          .getContext("2d"),
                        {
                          type: "line",
                          data: {
                            labels: ["", "", "", "", "", "", "", "", "", ""],
                            datasets: [
                              {
                                label: "\$",
                                lineTension: 0,
                                data: [
                                  94.08, 93.74, 94.11, 90.99, 92.39, 93.96,
                                  93.69, 94.58, 94.98, 95.1,
                                ],
                                pointRadius: 0,
                                borderColor: "rgba(57, 182, 251, 1)",
                                borderWidth: 4,
                                fill: false,
                              },
                            ],
                          },
                          options: {
                            legend: {
                              display: false,
                              maintainAspectRatio: false,
                            },
                            scales: {
                              xAxes: [
                                {
                                  gridLines: {
                                    display: false,
                                  },
                                },
                              ],
                              yAxes: [
                                {
                                  gridLines: {
                                    color: "rgba(64,64,64,1)",
                                  },
                                },
                              ],
                            },
                          },
                        }
                      );
                      myChart_16_2_2.data.datasets[0].data.splice(0, 1);
                      myChart_16_2_2.data.datasets[0].data.push(
                        result.Valute.EUR.Value.toFixed(2)
                      );
                      myChart_16_2_2.update();
                    });
                  }, 5000);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-16-3"
              onclick="alert(getCode('btn-16-3'))"
            >
              <div class="design-2 widget-rates-16-3-widget rates-XL">
                <div>
                  <p>\$</p>
                  <div class="space-div-16-3"></div>
                  <p id="usd-16-3">0.00</p>
                </div>
                <div style="padding-left: 26px; padding-right: 26px">
                  <canvas
                    id="diagram-16-3"
                    width="325px"
                    height="140px"
                  ></canvas>
                </div>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-2-2: 252px;
                    --size-3-2: 384px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-rates-16-3-widget {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-evenly;
                    width: var(--size-3-2);
                    height: var(--size-2-2);
                  }
                  .widget-rates-16-3-widget p {
                    font-size: 70px;
                    font-family: Montserrat;
                    font-weight: 100;
                    color: white;
                  }
                  .widget-rates-16-3-widget p:nth-child(1) {
                    color: rgba(115, 115, 115, 1);
                  }
                  .widget-rates-16-3-widget div:nth-child(1) {
                    display: flex;
                    margin-left: 26px;
                  }
                  .space-div-16-3 {
                    width: 18px;
                  }
                </style>
                <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.5.0/Chart.min.js"></script>
                <script>
                  const getUSD_16_3 = async () => {
                    const response = await fetch(
                      "https://www.cbr-xml-daily.ru/daily_json.js",
                      {
                        method: "GET",
                      }
                    );
                    const result = await response.json();
                    return result;
                  };
                  const myChart_16_3 = new Chart(
                    document.getElementById("diagram-16-3").getContext("2d"),
                    {
                      type: "line",
                      data: {
                        labels: ["", "", "", "", "", "", "", "", "", ""],
                        datasets: [
                          {
                            label: "\$",
                            lineTension: 0,
                            data: [
                              0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
                            ],

                            pointRadius: 0,
                            borderColor: "rgba(57, 182, 251, 1)",
                            borderWidth: 4,
                            fill: false,
                          },
                        ],
                      },
                      options: {
                        legend: {
                          display: false,
                          maintainAspectRatio: false,
                        },
                        scales: {
                          xAxes: [
                            {
                              gridLines: {
                                display: false,
                              },
                            },
                          ],
                          yAxes: [
                            {
                              gridLines: {
                                color: "rgba(64,64,64,1)",
                              },
                            },
                          ],
                        },
                      },
                    }
                  );
                  setTimeout(() => {
                    setInterval(() => {
                      getUSD_16_3().then((result) => {
                        document.getElementById("usd-16-3").innerHTML =
                          result.Valute.USD.Value.toFixed(2);
                        myChart_16_3.data.datasets[0].data.splice(0, 1);
                        myChart_16_3.data.datasets[0].data.push(
                          result.Valute.USD.Value.toFixed(2)
                        );
                        myChart_16_3.update();
                      });
                    }, 43200000);
                    getUSD_16_3().then((result) => {
                      document.getElementById("usd-16-3").innerHTML =
                        result.Valute.USD.Value.toFixed(2);

                      const myChart_16_3_2 = new Chart(
                        document
                          .getElementById("diagram-16-3")
                          .getContext("2d"),
                        {
                          type: "line",
                          data: {
                            labels: ["", "", "", "", "", "", "", "", "", ""],
                            datasets: [
                              {
                                label: "\$",
                                lineTension: 0,
                                data: [
                                  87.37, 87.21, 87.07, 88.05, 88.0, 84.96,
                                  85.75, 87.99, 87.95, 88.12,
                                ],
                                pointRadius: 0,
                                borderColor: "rgba(57, 182, 251, 1)",
                                borderWidth: 4,
                                fill: false,
                              },
                            ],
                          },
                          options: {
                            legend: {
                              display: false,
                              maintainAspectRatio: false,
                            },
                            scales: {
                              xAxes: [
                                {
                                  gridLines: {
                                    display: false,
                                  },
                                },
                              ],
                              yAxes: [
                                {
                                  gridLines: {
                                    color: "rgba(64,64,64,1)",
                                  },
                                },
                              ],
                            },
                          },
                        }
                      );
                      myChart_16_3_2.data.datasets[0].data.splice(0, 1);
                      myChart_16_3_2.data.datasets[0].data.push(
                        result.Valute.USD.Value.toFixed(2)
                      );
                      myChart_16_3_2.update();
                    });
                  }, 10000);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-16-4"
              onclick="alert(getCode('btn-16-4'))"
            >
              <div class="design-2 widget-rates-16-4-widget rates-XL">
                <div>
                  <p>€</p>
                  <div class="space-div-16-4"></div>
                  <p id="eur-16-4">0.00</p>
                </div>
                <div style="padding-left: 26px; padding-right: 26px">
                  <canvas
                    id="diagram-16-4"
                    width="325px"
                    height="140px"
                  ></canvas>
                </div>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-2-2: 252px;
                    --size-3-2: 384px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-rates-16-4-widget {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-evenly;
                    width: var(--size-3-2);
                    height: var(--size-2-2);
                  }
                  .widget-rates-16-4-widget p {
                    font-size: 70px;
                    font-family: Montserrat;
                    font-weight: 100;
                    color: white;
                  }
                  .widget-rates-16-4-widget p:nth-child(1) {
                    color: rgba(115, 115, 115, 1);
                  }
                  .widget-rates-16-4-widget div:nth-child(1) {
                    display: flex;
                    margin-left: 26px;
                  }
                  .space-div-16-4 {
                    width: 18px;
                  }
                </style>
                <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.5.0/Chart.min.js"></script>
                <script>
                  const getEUR_16_4 = async () => {
                    const response = await fetch(
                      "https://www.cbr-xml-daily.ru/daily_json.js",
                      {
                        method: "GET",
                      }
                    );
                    const data = await response.json();
                    return data;
                  };
                  const myChart_16_4 = new Chart(
                    document.getElementById("diagram-16-4").getContext("2d"),
                    {
                      type: "line",
                      data: {
                        labels: ["", "", "", "", "", "", "", "", "", ""],
                        datasets: [
                          {
                            label: "€",
                            lineTension: 0,
                            data: [
                              0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
                            ],
                            pointRadius: 0,
                            borderColor: "rgba(57, 182, 251, 1)",
                            borderWidth: 4,
                            fill: false,
                          },
                        ],
                      },
                      options: {
                        legend: {
                          display: false,
                          maintainAspectRatio: false,
                        },
                        scales: {
                          xAxes: [
                            {
                              gridLines: {
                                display: false,
                              },
                            },
                          ],
                          yAxes: [
                            {
                              gridLines: {
                                color: "rgba(64,64,64,1)",
                              },
                            },
                          ],
                        },
                      },
                    }
                  );
                  setTimeout(() => {
                    setInterval(() => {
                      getEUR_16_4().then((result) => {
                        document.getElementById("eur-16-4").innerHTML =
                          result.Valute.EUR.Value.toFixed(2);
                        myChart_16_4.data.datasets[0].data.splice(0, 1);
                        myChart_16_4.data.datasets[0].data.push(
                          result.Valute.EUR.Value.toFixed(2)
                        );
                        myChart_16_4.update();
                      });
                    }, 43200000);
                    getEUR_16_4().then((result) => {
                      document.getElementById("eur-16-4").innerHTML =
                        result.Valute.EUR.Value.toFixed(2);

                      const myChart_16_4_2 = new Chart(
                        document
                          .getElementById("diagram-16-4")
                          .getContext("2d"),
                        {
                          type: "line",
                          data: {
                            labels: ["", "", "", "", "", "", "", "", "", ""],
                            datasets: [
                              {
                                label: "€",
                                lineTension: 0,
                                data: [
                                  94.08, 93.74, 94.11, 90.99, 92.39, 93.96,
                                  93.69, 94.58, 94.98, 95.1,
                                ],
                                pointRadius: 0,
                                borderColor: "rgba(57, 182, 251, 1)",
                                borderWidth: 4,
                                fill: false,
                              },
                            ],
                          },
                          options: {
                            legend: {
                              display: false,
                              maintainAspectRatio: false,
                            },
                            scales: {
                              xAxes: [
                                {
                                  gridLines: {
                                    display: false,
                                  },
                                },
                              ],
                              yAxes: [
                                {
                                  gridLines: {
                                    color: "rgba(64,64,64,1)",
                                  },
                                },
                              ],
                            },
                          },
                        }
                      );
                      myChart_16_4_2.data.datasets[0].data.splice(0, 1);
                      myChart_16_4_2.data.datasets[0].data.push(
                        result.Valute.EUR.Value.toFixed(2)
                      );
                      myChart_16_4_2.update();
                    });
                  }, 10000);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-16-5"
              onclick="alert(getCode('btn-16-5'))"
            >
              <div class="design-2 widget-rates-16-5-widget rates-S">
                <div>
                  <p>USD</p>
                  <div class="space-div-16-5"></div>
                  <p id="usd-16-5">0.00</p>
                </div>

                <div>
                  <p>EUR</p>
                  <div class="space-div-16-5"></div>
                  <p id="eur-16-5">0.00</p>
                </div>

                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --size-2-2: 252px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-rates-16-5-widget {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-evenly;
                    align-items: center;
                    width: var(--size-2-2);
                    height: var(--size-1-2);
                  }
                  .widget-rates-16-5-widget div {
                    display: flex;
                    justify-content: space-around;
                    font-size: 30px;
                    font-family: Montserrat;
                  }
                  .widget-rates-16-5-widget div p:nth-child(1) {
                    color: rgba(115, 115, 115, 1);
                  }
                  .widget-rates-16-5-widget div p:nth-child(3) {
                    color: white;
                  }
                  .space-div-16-5 {
                    width: 26px;
                  }
                </style>
                <script>
                  const getUSD_EUR_16_5 = () => {
                    fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
                      method: "GET",
                    })
                      .then((response) => response.json())
                      .then((result) => {
                        document.getElementById("usd-16-5").innerHTML =
                          result.Valute.USD.Value.toFixed(2);
                        document.getElementById("eur-16-5").innerHTML =
                          result.Valute.EUR.Value.toFixed(2);
                      });
                  };
                  setTimeout(() => {
                    setInterval(() => {
                      getUSD_EUR_16_5;
                    }, 43200000);
                    getUSD_EUR_16_5();
                  }, 10000);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-16-6"
              onclick="alert(getCode('btn-16-6'))"
            >
              <div class="design-2 widget-rates-16-6-widget rates-S">
                <p id="usd-16-6">0.00</p>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --size-2-2: 252px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-rates-16-6-widget {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    width: var(--size-2-2);
                    height: var(--size-1-2);
                    background-image: url("http://212.41.9.251:8000/static/\$.svg");
                    background-repeat: no-repeat;
                    background-size: contain;
                  }
                  .widget-rates-16-6-widget p {
                    font-size: 70px;
                    font-family: Montserrat;
                    color: white;
                    font-weight: 200;
                  }
                </style>
                <script>
                  const getUSD_16_6 = () => {
                    fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
                      method: "GET",
                    })
                      .then((response) => response.json())
                      .then((result) => {
                        document.getElementById("usd-16-6").innerHTML =
                          result.Valute.USD.Value.toFixed(2);
                      });
                  };

                  setTimeout(() => {
                    setInterval(() => {
                      getUSD_16_6;
                    }, 43200000);
                    getUSD_16_6();
                  }, 10000);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-16-7"
              onclick="alert(getCode('btn-16-7'))"
            >
              <div class="design-2 widget-rates-16-7-widget rates-S">
                <p id="eur-16-7">0.00</p>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --size-2-2: 252px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-rates-16-7-widget {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    width: var(--size-2-2);
                    height: var(--size-1-2);
                    background-image: url("http://212.41.9.251:8000/static/€.svg");
                    background-repeat: no-repeat;
                    background-size: contain;
                  }
                  .widget-rates-16-7-widget p {
                    font-size: 70px;
                    font-family: Montserrat;
                    color: white;
                    font-weight: 200;
                  }
                </style>
                <script>
                  const getEUR_16_7 = () => {
                    fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
                      method: "GET",
                    })
                      .then((response) => response.json())
                      .then((result) => {
                        document.getElementById("eur-16-7").innerHTML =
                          result.Valute.EUR.Value.toFixed(2);
                      });
                  };

                  setTimeout(() => {
                    setInterval(() => {
                      getEUR_16_7;
                    }, 43200000);
                    getEUR_16_7();
                  }, 10000);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-16-8"
              onclick="alert(getCode('btn-16-8'))"
            >
              <div class="design-2 widget-rates-16-8-widget rates-XS">
                <div>
                  <p>\$</p>
                  <div class="space-div-16-8"></div>
                  <p id="usd-16-8">0.00</p>
                </div>
                <div>
                  <p>€</p>
                  <div class="space-div-16-8"></div>
                  <p id="eur-16-8">0.00</p>
                </div>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-rates-16-8-widget {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-evenly;
                    align-items: center;
                    text-align: center;
                    width: var(--size-1-2);
                    height: var(--size-1-2);
                  }
                  .widget-rates-16-8-widget p {
                    font-size: 20px;
                    color: white;
                    font-family: Montserrat;
                  }
                  .widget-rates-16-8-widget div {
                    display: flex;
                  }
                  .widget-rates-16-8-widget div p:nth-child(1) {
                    font-size: 20px;
                    color: rgba(115, 115, 115, 1);
                    font-family: Montserrat;
                  }
                  .space-div-16-8 {
                    width: 10px;
                  }
                </style>
                <script>
                  const getUSD_EUR_16_8 = () => {
                    fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
                      method: "GET",
                    })
                      .then((response) => response.json())
                      .then((result) => {
                        document.getElementById("usd-16-8").innerHTML =
                          result.Valute.USD.Value.toFixed(2);
                        document.getElementById("eur-16-8").innerHTML =
                          result.Valute.EUR.Value.toFixed(2);
                      });
                  };
                  setTimeout(() => {
                    setInterval(() => {
                      getUSD_EUR_16_8;
                    }, 43200000);
                    getUSD_EUR_16_8();
                  }, 15000);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-16-9"
              onclick="alert(getCode('btn-16-9'))"
            >
              <div class="design-2 widget-rates-16-9-widget rates-S">
                <div>
                  <p>USD</p>
                  <p id="usd-16-9">0.00</p>
                </div>
                <div>
                  <p>EUR</p>
                  <p id="eur-16-9">0.00</p>
                </div>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --size-2-2: 252px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-rates-16-9-widget {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-evenly;
                    align-items: center;
                    width: var(--size-1-2);
                    height: var(--size-2-2);
                  }
                  .widget-rates-16-9-widget p {
                    color: white;
                    font-size: 20px;
                    font-family: Montserrat;
                  }
                  .widget-rates-16-9-widget div p:nth-child(1) {
                    color: rgba(115, 115, 115, 1);
                  }
                </style>
                <script>
                  const getUSD_EUR_16_9 = () => {
                    fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
                      method: "GET",
                    })
                      .then((response) => response.json())
                      .then((result) => {
                        document.getElementById("usd-16-9").innerHTML =
                          result.Valute.USD.Value.toFixed(2);
                        document.getElementById("eur-16-9").innerHTML =
                          result.Valute.EUR.Value.toFixed(2);
                      });
                  };
                  setTimeout(() => {
                    setInterval(() => {
                      getUSD_EUR_16_9;
                    }, 43200000);
                    getUSD_EUR_16_9();
                  }, 15000);
                </script>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="dropright-1">
      <button class="drop-1">
        Цвет. металлы <br />
        16, 18 вариант
      </button>
      <div class="drop-content-1">
        <div class="navbar-2">
          <div class="dropdown-2">
            <button
              class="drop-2"
              id="btn-17-1"
              onclick="alert(getCode('btn-17-1'))"
            >
              <div class="design-2 widget-metals-16-1-widget metal-XL">
                <div>
                  <p class="name-metal-16-1">Нефть</p>
                  <p id="oil-divide-price-16-1">---,--</p>
                  <p id="oil-perc-price-16-1">---,--</p>
                  <div class="widget-metal-last-16-1">
                    <p id="oil-price-16-1">---,--</p>
                    <div class="space-div-17-1"></div>
                    <img
                      id="updown-16-1-1"
                      src="http://212.41.9.251:8000/static/blue_up_triangle.svg"
                    />
                  </div>
                </div>
                <div>
                  <p class="name-metal-16-1">Серебро</p>
                  <p id="silver-divide-price-16-1">---,--</p>
                  <p id="silver-perc-price-16-1">---,--</p>
                  <div class="widget-metal-last-16-1">
                    <p id="silver-price-16-1">---,--</p>
                    <div class="space-div-17-1"></div>
                    <img
                      id="updown-16-1-2"
                      src="http://212.41.9.251:8000/static/blue_up_triangle.svg"
                    />
                  </div>
                </div>
                <div>
                  <p class="name-metal-16-1">Золото</p>
                  <p id="gold-divide-price-16-1">---,--</p>
                  <p id="gold-perc-price-16-1">---,--</p>
                  <div class="widget-metal-last-16-1">
                    <p id="gold-price-16-1">---,--</p>
                    <div class="space-div-17-1"></div>
                    <img
                      id="updown-16-1-3"
                      src="http://212.41.9.251:8000/static/blue_up_triangle.svg"
                    />
                  </div>
                </div>
                <div>
                  <p class="name-metal-16-1">Платина</p>
                  <p id="platinum-divide-price-16-1">---,--</p>
                  <p id="platinum-perc-price-16-1">---,--</p>
                  <div class="widget-metal-last-16-1">
                    <p id="platinum-price-16-1">---,--</p>
                    <div class="space-div-17-1"></div>
                    <img
                      id="updown-16-1-4"
                      src="http://212.41.9.251:8000/static/blue_up_triangle.svg"
                    />
                  </div>
                </div>
                <div>
                  <p class="name-metal-16-1">Палладий</p>
                  <p id="palladium-divide-price-16-1">---,--</p>
                  <p id="palladium-perc-price-16-1">---,--</p>
                  <div class="widget-metal-last-16-1">
                    <p id="palladium-price-16-1">---,--</p>
                    <div class="space-div-17-1"></div>
                    <img
                      id="updown-16-1-5"
                      src="http://212.41.9.251:8000/static/blue_up_triangle.svg"
                    />
                  </div>
                </div>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-2-2: 252px;
                    --size-4-2: 516px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-metals-16-1-widget {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-evenly;
                    width: var(--size-4-2);
                    height: var(--size-2-2);
                  }
                  .widget-metals-16-1-widget div {
                    display: flex;
                    justify-content: space-evenly;
                    align-items: center;
                    color: white;
                    font-family: Montserrat;
                    font-size: 20px;
                  }
                  .name-metal-16-1 {
                    color: white;
                    text-align: start;
                    width: 106px;
                  }
                  .widget-metals-16-1-widget div p:nth-child(2) {
                    color: rgba(115, 115, 115, 1);
                    width: 61px;
                    text-align: end;
                  }
                  .widget-metals-16-1-widget div p:nth-child(3) {
                    color: rgba(115, 115, 115, 1);
                    width: 80px;
                    text-align: end;
                  }
                  .widget-metals-16-1-widget div p:nth-child(4) {
                    width: 100px;
                    text-align: end;
                  }

                  .widget-metals-16-1-widget div img {
                    width: 18px;
                    height: 14px;
                  }
                  .widget-metal-last-16-1 p {
                    width: 108px;
                    text-align: end;
                  }
                  .space-div-17-1 {
                    width: 6px;
                  }
                </style>
                <script>
                  const getOil_16_1 = () => {
                    fetch("http://212.41.9.251:8000/get_brent", {
                      method: "GET",
                      headers: {
                        accept: "application/json",
                      },
                    })
                      .then((response) => response.json())
                      .then((result) => {
                        var old_data =
                          document.getElementById("oil-price-16-1").innerHTML;
                        var new_data = result[1];
                        if (new_data >= old_data) {
                          document
                            .getElementById("updown-16-1-1")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_up_triangle.svg"
                            );
                        } else {
                          document
                            .getElementById("updown-16-1-1")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_down_triangle.svg"
                            );
                        }
                        document.getElementById("oil-price-16-1").innerHTML =
                          result[1];
                        document.getElementById(
                          "oil-divide-price-16-1"
                        ).innerHTML = result[2];
                        document.getElementById(
                          "oil-perc-price-16-1"
                        ).innerHTML = result[3];
                      });
                  };

                  const getMetal_16_1 = () => {
                    fetch(
                      "https://api.metalpriceapi.com/v1/latest?api_key=5196052db469251707517ada2cc2f6e0&base=USD&currencies=XAG,%20XAU,%20XPT,%20XPD",
                      {
                        method: "GET",
                      }
                    )
                      .then((response) => response.json())
                      .then((result) => {
                        var old_silver_price =
                          document.getElementById(
                            "silver-price-16-1"
                          ).innerHTML;
                        var new_silver_price = result.rates.USDXAG;

                        if (new_silver_price >= old_silver_price) {
                          document
                            .getElementById("updown-16-1-2")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_up_triangle.svg"
                            );
                        } else {
                          document
                            .getElementById("updown-16-1-2")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_down_triangle.svg"
                            );
                        }
                        document.getElementById(
                          "silver-divide-price-16-1"
                        ).innerHTML = (
                          new_silver_price - old_silver_price
                        ).toFixed(2);
                        document.getElementById(
                          "silver-perc-price-16-1"
                        ).innerHTML = \`\${(
                          ((new_silver_price - old_silver_price) /
                            new_silver_price) *
                          100
                        ).toFixed(2)}%\`;
                        document.getElementById("silver-price-16-1").innerHTML =
                          result.rates.USDXAG.toFixed(2);
                        //------------------------------------
                        var old_gold_price =
                          document.getElementById("gold-price-16-1").innerHTML;
                        var new_gold_price = result.rates.USDXAU;

                        if (new_gold_price >= old_gold_price) {
                          document
                            .getElementById("updown-16-1-3")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_up_triangle.svg"
                            );
                        } else {
                          document
                            .getElementById("updown-16-1-3")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_down_triangle.svg"
                            );
                        }
                        document.getElementById(
                          "gold-divide-price-16-1"
                        ).innerHTML = (new_gold_price - old_gold_price).toFixed(
                          2
                        );
                        document.getElementById(
                          "gold-perc-price-16-1"
                        ).innerHTML = \`\${(
                          ((new_gold_price - old_gold_price) / new_gold_price) *
                          100
                        ).toFixed(2)}%\`;
                        document.getElementById("gold-price-16-1").innerHTML =
                          result.rates.USDXAU.toFixed(2);
                        //------------------------------------
                        var old_platinum_price = document.getElementById(
                          "platinum-price-16-1"
                        ).innerHTML;
                        var new_platinum_price = result.rates.USDXPT.toFixed(2);

                        if (new_platinum_price >= old_platinum_price) {
                          document
                            .getElementById("updown-16-1-4")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_up_triangle.svg"
                            );
                        } else {
                          document
                            .getElementById("updown-16-1-4")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_down_triangle.svg"
                            );
                        }
                        document.getElementById(
                          "platinum-divide-price-16-1"
                        ).innerHTML = (
                          new_gold_price - old_platinum_price
                        ).toFixed(2);
                        document.getElementById(
                          "platinum-perc-price-16-1"
                        ).innerHTML = \`\${(
                          ((new_platinum_price - old_platinum_price) /
                            new_platinum_price) *
                          100
                        ).toFixed(2)}%\`;
                        document.getElementById(
                          "platinum-price-16-1"
                        ).innerHTML = result.rates.USDXPT.toFixed(2);
                        //------------------------------------
                        var old_palladium_price = document.getElementById(
                          "palladium-price-16-1"
                        ).innerHTML;
                        var new_palladium_price = result.rates.USDXPD;

                        if (new_palladium_price >= old_palladium_price) {
                          document
                            .getElementById("updown-16-1-5")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_up_triangle.svg"
                            );
                        } else {
                          document
                            .getElementById("updown-16-1-5")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_down_triangle.svg"
                            );
                        }
                        document.getElementById(
                          "palladium-divide-price-16-1"
                        ).innerHTML = (
                          new_palladium_price - old_palladium_price
                        ).toFixed(2);
                        document.getElementById(
                          "palladium-perc-price-16-1"
                        ).innerHTML = \`\${(
                          ((new_palladium_price - old_palladium_price) /
                            new_palladium_price) *
                          100
                        ).toFixed(2)}%\`;
                        document.getElementById(
                          "palladium-price-16-1"
                        ).innerHTML = result.rates.USDXPD.toFixed(2);
                      });
                  };
                  // setTimeout(() => {
                  //   setInterval(() => {
                  //     getOil_16_1;
                  //     getMetal_16_1;
                  //   }, 172800000);
                  //   getOil_16_1();
                  //   getMetal_16_1();
                  // }, 1000);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-17-2"
              onclick="alert(getCode('btn-17-2'))"
            >
              <div class="design-2 widget-metals-16-2-widget metal-L">
                <div>
                  <p class="name-metal-16-2">Нефть</p>
                  <p id="oil-divide-price-16-2">---,--</p>
                  <p id="oil-perc-price-16-2">---,--</p>
                  <div class="widget-metal-last-16-2">
                    <p id="oil-price-16-2">---,--</p>
                    <div class="space-div-17-2"></div>
                    <img
                      id="updown-16-2-1"
                      src="http://212.41.9.251:8000/static/blue_up_triangle.svg"
                    />
                  </div>
                </div>
                <div>
                  <p class="name-metal-16-2">Серебро</p>
                  <p id="silver-divide-price-16-2">---,--</p>
                  <p id="silver-perc-price-16-2">---,--</p>
                  <div class="widget-metal-last-16-2">
                    <p id="silver-price-16-2">---,--</p>
                    <div class="space-div-17-2"></div>
                    <img
                      id="updown-16-2-2"
                      src="http://212.41.9.251:8000/static/blue_up_triangle.svg"
                    />
                  </div>
                </div>
                <div>
                  <p class="name-metal-16-2">Золото</p>
                  <p id="gold-divide-price-16-2">---,--</p>
                  <p id="gold-perc-price-16-2">---,--</p>
                  <div class="widget-metal-last-16-2">
                    <p id="gold-price-16-2">---,--</p>
                    <div class="space-div-17-2"></div>
                    <img
                      id="updown-16-2-3"
                      src="http://212.41.9.251:8000/static/blue_up_triangle.svg"
                    />
                  </div>
                </div>

                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --size-4-2: 516px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-metals-16-2-widget {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-evenly;
                    width: var(--size-4-2);
                    height: var(--size-1-2);
                  }

                  .widget-metals-16-2-widget div {
                    display: flex;
                    justify-content: space-evenly;
                    align-items: center;
                    color: white;
                    font-family: Montserrat;
                    font-size: 20px;
                  }
                  .name-metal-16-2 {
                    color: white;
                    text-align: start;
                    width: 106px;
                  }
                  .widget-metals-16-2-widget div p:nth-child(2) {
                    color: rgba(115, 115, 115, 1);
                    width: 61px;
                    text-align: end;
                  }
                  .widget-metals-16-2-widget div p:nth-child(3) {
                    color: rgba(115, 115, 115, 1);
                    width: 80px;
                    text-align: end;
                  }
                  .widget-metals-16-2-widget div p:nth-child(4) {
                    width: 100px;
                    text-align: end;
                  }

                  .widget-metals-16-2-widget div img {
                    width: 18px;
                    height: 14px;
                  }
                  .widget-metal-last-16-2 p {
                    width: 108px;
                    text-align: end;
                  }
                  .space-div-17-2 {
                    width: 6px;
                  }
                </style>
                <script>
                  const getOil_16_2 = () => {
                    fetch("http://212.41.9.251:8000/get_brent", {
                      method: "GET",
                      headers: {
                        accept: "application/json",
                      },
                    })
                      .then((response) => response.json())
                      .then((result) => {
                        var old_data =
                          document.getElementById("oil-price-16-2").innerHTML;
                        var new_data = result[1];
                        if (new_data >= old_data) {
                          document
                            .getElementById("updown-16-2-1")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_up_triangle.svg"
                            );
                        } else {
                          document
                            .getElementById("updown-16-2-1")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_down_triangle.svg"
                            );
                        }
                        document.getElementById("oil-price-16-2").innerHTML =
                          result[1];
                        document.getElementById(
                          "oil-divide-price-16-2"
                        ).innerHTML = result[2];
                        document.getElementById(
                          "oil-perc-price-16-2"
                        ).innerHTML = result[3];
                      });
                  };

                  const getMetal_16_2 = () => {
                    fetch(
                      "https://api.metalpriceapi.com/v1/latest?api_key=5196052db469251707517ada2cc2f6e0&base=USD&currencies=XAG,%20XAU,%20XPT,%20XPD",
                      {
                        method: "GET",
                      }
                    )
                      .then((response) => response.json())
                      .then((result) => {
                        var old_silver_price =
                          document.getElementById(
                            "silver-price-16-2"
                          ).innerHTML;
                        var new_silver_price = result.rates.USDXAG;

                        if (new_silver_price >= old_silver_price) {
                          document
                            .getElementById("updown-16-2-2")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_up_triangle.svg"
                            );
                        } else {
                          document
                            .getElementById("updown-16-2-2")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_down_triangle.svg"
                            );
                        }
                        document.getElementById(
                          "silver-divide-price-16-2"
                        ).innerHTML = (
                          new_silver_price - old_silver_price
                        ).toFixed(2);
                        document.getElementById(
                          "silver-perc-price-16-2"
                        ).innerHTML = \`\${(
                          ((new_silver_price - old_silver_price) /
                            new_silver_price) *
                          100
                        ).toFixed(2)}%\`;
                        document.getElementById("silver-price-16-2").innerHTML =
                          result.rates.USDXAG.toFixed(2);
                        //------------------------------------
                        var old_gold_price =
                          document.getElementById("gold-price-16-2").innerHTML;
                        var new_gold_price = result.rates.USDXAU;

                        if (new_gold_price >= old_gold_price) {
                          document
                            .getElementById("updown-16-2-3")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_up_triangle.svg"
                            );
                        } else {
                          document
                            .getElementById("updown-16-2-3")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_down_triangle.svg"
                            );
                        }
                        document.getElementById(
                          "gold-divide-price-16-2"
                        ).innerHTML = (new_gold_price - old_gold_price).toFixed(
                          2
                        );
                        document.getElementById(
                          "gold-perc-price-16-2"
                        ).innerHTML = \`\${(
                          ((new_gold_price - old_gold_price) / new_gold_price) *
                          100
                        ).toFixed(2)}%\`;
                        document.getElementById("gold-price-16-2").innerHTML =
                          result.rates.USDXAU.toFixed(2);
                      });
                  };
                  // setTimeout(() => {
                  //   setInterval(() => {
                  //     getOil_16_2;
                  //     getMetal_16_2;
                  //   }, 172800000);
                  //   getOil_16_2();
                  //   getMetal_16_2();
                  // }, 1000);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-17-3"
              onclick="alert(getCode('btn-17-3'))"
            >
              <div class="design-2 widget-metals-16-3-widget metal-M">
                <div>
                  <p class="name-metal-16-3">Нефть</p>
                  <div class="widget-metal-last-16-3">
                    <p id="oil-price-16-3">---,--</p>
                    <div class="space-div-17-3"></div>
                    <img
                      id="updown-16-3-1"
                      src="http://212.41.9.251:8000/static/blue_up_triangle.svg"
                    />
                  </div>
                </div>

                <div>
                  <p class="name-metal-16-3">Серебро</p>
                  <div class="widget-metal-last-16-3">
                    <p id="silver-price-16-3">---,--</p>
                    <div class="space-div-17-3"></div>
                    <img
                      id="updown-16-3-2"
                      src="http://212.41.9.251:8000/static/blue_up_triangle.svg"
                    />
                  </div>
                </div>
                <div>
                  <p class="name-metal-16-3">Золото</p>
                  <div class="widget-metal-last-16-3">
                    <p id="gold-price-16-3">---,--</p>
                    <div class="space-div-17-3"></div>
                    <img
                      id="updown-16-3-3"
                      src="http://212.41.9.251:8000/static/blue_up_triangle.svg"
                    />
                  </div>
                </div>
                <div>
                  <p class="name-metal-16-3">Платина</p>
                  <div class="widget-metal-last-16-3">
                    <p id="platinum-price-16-3">---,--</p>
                    <div class="space-div-17-3"></div>
                    <img
                      id="updown-16-3-4"
                      src="http://212.41.9.251:8000/static/blue_up_triangle.svg"
                    />
                  </div>
                </div>
                <div>
                  <p class="name-metal-16-3">Палладий</p>
                  <div class="widget-metal-last-16-3">
                    <p id="palladium-price-16-3">---,--</p>
                    <div class="space-div-17-3"></div>
                    <img
                      id="updown-16-3-5"
                      src="http://212.41.9.251:8000/static/blue_up_triangle.svg"
                    />
                  </div>
                </div>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-2-2: 252px;
                    --size-3-2: 384px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-metals-16-3-widget {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-evenly;
                    width: var(--size-3-2);
                    height: var(--size-2-2);
                  }
                  .widget-metals-16-3-widget div {
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    color: white;
                    font-size: 20px;
                    font-family: Montserrat;
                  }
                  .name-metal-16-3 {
                    text-align: start;
                    width: 106px;
                    color: rgba(115, 115, 115, 1);
                  }
                  .space-div-17-3 {
                    width: 6px;
                  }
                  .widget-metals-16-3-widget img {
                    width: 18px;
                    height: 14px;
                  }
                  .widget-metal-last-16-3 p {
                    width: 100px;
                    text-align: end;
                  }
                </style>
                <script>
                  const getOil_16_3 = () => {
                    fetch("http://212.41.9.251:8000/get_brent", {
                      method: "GET",
                      headers: {
                        accept: "application/json",
                      },
                    })
                      .then((response) => response.json())
                      .then((result) => {
                        var old_data =
                          document.getElementById("oil-price-16-3").innerHTML;
                        var new_data = result[1];
                        if (new_data >= old_data) {
                          document
                            .getElementById("updown-16-3-1")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_up_triangle.svg"
                            );
                        } else {
                          document
                            .getElementById("updown-16-3-1")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_down_triangle.svg"
                            );
                        }
                        document.getElementById("oil-price-16-3").innerHTML =
                          result[1];
                      });
                  };
                  const getMetal_16_3 = () => {
                    fetch(
                      "https://api.metalpriceapi.com/v1/latest?api_key=5196052db469251707517ada2cc2f6e0&base=USD&currencies=XAG,%20XAU,%20XPT,%20XPD",
                      {
                        method: "GET",
                      }
                    )
                      .then((response) => response.json())
                      .then((result) => {
                        var old_silver_price =
                          document.getElementById(
                            "silver-price-16-3"
                          ).innerHTML;
                        var new_silver_price = result.rates.USDXAG;

                        if (new_silver_price >= old_silver_price) {
                          document
                            .getElementById("updown-16-3-2")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_up_triangle.svg"
                            );
                        } else {
                          document
                            .getElementById("updown-16-3-2")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_down_triangle.svg"
                            );
                        }
                        document.getElementById("silver-price-16-3").innerHTML =
                          result.rates.USDXAG.toFixed(2);
                        //------------------------------------
                        var old_gold_price =
                          document.getElementById("gold-price-16-3").innerHTML;
                        var new_gold_price = result.rates.USDXAU;

                        if (new_gold_price >= old_gold_price) {
                          document
                            .getElementById("updown-16-3-3")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_up_triangle.svg"
                            );
                        } else {
                          document
                            .getElementById("updown-16-3-3")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_down_triangle.svg"
                            );
                        }
                        document.getElementById("gold-price-16-3").innerHTML =
                          result.rates.USDXAU.toFixed(2);
                        //------------------------------------
                        var old_platinum_price = document.getElementById(
                          "platinum-price-16-3"
                        ).innerHTML;
                        var new_platinum_price = result.rates.USDXPT.toFixed(2);

                        if (new_platinum_price >= old_platinum_price) {
                          document
                            .getElementById("updown-16-3-4")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_up_triangle.svg"
                            );
                        } else {
                          document
                            .getElementById("updown-16-3-4")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_down_triangle.svg"
                            );
                        }
                        document.getElementById(
                          "platinum-price-16-3"
                        ).innerHTML = result.rates.USDXPT.toFixed(2);
                        //------------------------------------
                        var old_palladium_price = document.getElementById(
                          "palladium-price-16-3"
                        ).innerHTML;
                        var new_palladium_price = result.rates.USDXPD;

                        if (new_palladium_price >= old_palladium_price) {
                          document
                            .getElementById("updown-16-3-5")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_up_triangle.svg"
                            );
                        } else {
                          document
                            .getElementById("updown-16-3-5")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_down_triangle.svg"
                            );
                        }
                        document.getElementById(
                          "palladium-price-16-3"
                        ).innerHTML = result.rates.USDXPD.toFixed(2);
                      });
                  };
                  // setTimeout(() => {
                  //   setInterval(() => {
                  //     getOil_16_3;
                  //     getMetal_16_3;
                  //   }, 172800000);
                  //   getOil_16_3();
                  //   getMetal_16_3();
                  // }, 1000);
                </script>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-17-4"
              onclick="alert(getCode('btn-17-4'))"
            >
              <div class="design-2 widget-metals-16-4-widget metal-S">
                <div>
                  <p class="name-metal-16-4">Нефть</p>
                  <div class="widget-metal-last-16-4">
                    <p id="oil-price-16-4">---,--</p>
                    <div class="space-div-17-4"></div>
                    <img
                      id="updown-16-4-1"
                      src="http://212.41.9.251:8000/static/blue_up_triangle.svg"
                    />
                  </div>
                </div>

                <div>
                  <p class="name-metal-16-4">Серебро</p>
                  <div class="widget-metal-last-16-4">
                    <p id="silver-price-16-4">---,--</p>
                    <div class="space-div-17-4"></div>
                    <img
                      id="updown-16-4-2"
                      src="http://212.41.9.251:8000/static/blue_up_triangle.svg"
                    />
                  </div>
                </div>
                <div>
                  <p class="name-metal-16-4">Золото</p>
                  <div class="widget-metal-last-16-4">
                    <p id="gold-price-16-4">---,--</p>
                    <div class="space-div-17-4"></div>
                    <img
                      id="updown-16-4-3"
                      src="http://212.41.9.251:8000/static/blue_up_triangle.svg"
                    />
                  </div>
                </div>

                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --size-3-2: 384px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-metals-16-4-widget {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-evenly;
                    width: var(--size-3-2);
                    height: var(--size-1-2);
                  }
                  .widget-metals-16-4-widget div {
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    color: white;
                    font-size: 20px;
                    font-family: Montserrat;
                  }
                  .name-metal-16-4 {
                    text-align: start;
                    width: 106px;
                    color: rgba(115, 115, 115, 1);
                  }
                  .space-div-17-4 {
                    width: 6px;
                  }
                  .widget-metals-16-4-widget img {
                    width: 18px;
                    height: 14px;
                  }
                  .widget-metal-last-16-4 p {
                    width: 100px;
                    text-align: end;
                  }
                </style>
                <script>
                  const getOil_16_4 = () => {
                    fetch("http://212.41.9.251:8000/get_brent", {
                      method: "GET",
                      headers: {
                        accept: "application/json",
                      },
                    })
                      .then((response) => response.json())
                      .then((result) => {
                        var old_data =
                          document.getElementById("oil-price-16-4").innerHTML;
                        var new_data = result[1];
                        if (new_data >= old_data) {
                          document
                            .getElementById("updown-16-4-1")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_up_triangle.svg"
                            );
                        } else {
                          document
                            .getElementById("updown-16-4-1")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_down_triangle.svg"
                            );
                        }
                        document.getElementById("oil-price-16-4").innerHTML =
                          result[1];
                      });
                  };
                  const getMetal_16_4 = () => {
                    fetch(
                      "https://api.metalpriceapi.com/v1/latest?api_key=5196052db469251707517ada2cc2f6e0&base=USD&currencies=XAG,%20XAU,%20XPT,%20XPD",
                      {
                        method: "GET",
                      }
                    )
                      .then((response) => response.json())
                      .then((result) => {
                        var old_silver_price =
                          document.getElementById(
                            "silver-price-16-4"
                          ).innerHTML;
                        var new_silver_price = result.rates.USDXAG;

                        if (new_silver_price >= old_silver_price) {
                          document
                            .getElementById("updown-16-4-2")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_up_triangle.svg"
                            );
                        } else {
                          document
                            .getElementById("updown-16-4-2")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_down_triangle.svg"
                            );
                        }
                        document.getElementById("silver-price-16-4").innerHTML =
                          result.rates.USDXAG.toFixed(2);
                        //------------------------------------
                        var old_gold_price =
                          document.getElementById("gold-price-16-4").innerHTML;
                        var new_gold_price = result.rates.USDXAU;

                        if (new_gold_price >= old_gold_price) {
                          document
                            .getElementById("updown-16-4-3")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_up_triangle.svg"
                            );
                        } else {
                          document
                            .getElementById("updown-16-4-3")
                            .setAttribute(
                              "src",
                              "http://212.41.9.251:8000/static/blue_down_triangle.svg"
                            );
                        }
                        document.getElementById("gold-price-16-4").innerHTML =
                          result.rates.USDXAU.toFixed(2);
                      });
                  };
                  // setTimeout(() => {
                  //   setInterval(() => {
                  //     getOil_16_4;
                  //     getMetal_16_4;
                  //   }, 172800000);
                  //   getOil_16_4();
                  //   getMetal_16_4();
                  // }, 1000);
                </script>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="dropright-1">
      <button class="drop-1">
        Управляющая компания<br />
        16, 18 вариант
      </button>
      <div class="drop-content-1">
        <div class="navbar-2">
          <div class="dropdown-2">
            <button
              class="drop-2"
              id="btn-18-1"
              onclick="alert(getCode('btn-18-1'))"
            >
              <div class="design-2 widget-about-company-16-1-widget company-L">
                <div>
                  <p>Лифт обслуживает компания</p>
                </div>
                <div>
                  <p>Телефон поддержки</p>
                  <p>+7(800)555-35-35</p>
                </div>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --size-4-2: 516px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-about-company-16-1-widget {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-evenly;
                    width: var(--size-4-2);
                    height: var(--size-1-2);
                  }
                  .widget-about-company-16-1-widget div {
                    display: flex;
                    justify-content: space-around;
                  }
                  .widget-about-company-16-1-widget p {
                    font-family: Montserrat;
                    color: white;
                    font-size: 20px;
                    font-weight: 400;
                  }
                  .widget-about-company-16-1-widget p:first-child {
                    color: rgba(115, 115, 115, 1);
                  }
                </style>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-18-2"
              onclick="alert(getCode('btn-18-2'))"
            >
              <div class="design-2 widget-about-company-16-2-widget company-L">
                <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
                <div>
                  <img
                    style="width: 116px; height: 12px"
                    src="http://212.41.9.251:8000/static/light_ipanel.svg"
                    alt=""
                  />
                  <div class="space-div-18-2"></div>
                  <img
                    src="http://212.41.9.251:8000/static/light_liftbrand.svg"
                    alt=""
                  />
                </div>
                <img
                  src="http://212.41.9.251:8000/static/light_videovision.svg"
                  alt=""
                />
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --size-4-2: 516px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                    --color-icon: "";
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-about-company-16-2-widget {
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    width: var(--size-4-2);
                    height: var(--size-1-2);
                  }
                  .widget-about-company-16-2-widget div {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                  }
                  .space-div-18-2 {
                    height: 16px;
                  }
                  .widget-about-company-16-2-widget img {
                    filter: var(--color-icon);
                  }
                </style>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-18-3"
              onclick="alert(getCode('btn-18-3'))"
            >
              <div class="design-2 widget-about-company-16-3-widget company-L">
                <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
                <img
                  src="http://212.41.9.251:8000/static/light_ipanel.svg"
                  alt=""
                />
                <img
                  src="http://212.41.9.251:8000/static/light_liftbrand.svg"
                  alt=""
                />
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --size-4-2: 516px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                    --color-icon: "";
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-about-company-16-3-widget {
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    width: var(--size-4-2);
                    height: var(--size-1-2);
                  }
                  .widget-about-company-16-3-widget img {
                    filter: var(--color-icon);
                  }
                </style>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="dropright-1">
      <button class="drop-1">
        Музыка <br />
        16, 18 вариант
      </button>
      <div class="drop-content-1">
        <div class="navbar-2">
          <div class="dropdown-2">
            <button
              class="drop-2"
              id="btn-19-1"
              onclick="alert(getCode('btn-19-1'))"
            >
              <div class="design-2 widget-music-16-1-widget music-L">
                <p>Lynyrd Skynyrd</p>
                <p>Simple man</p>
                <div class="space-div-19-1"></div>
                <div class="music-1">
                  <div class="music-16-1"></div>
                  <div class="music-16-1"></div>
                  <div class="music-16-1"></div>
                  <div class="music-16-1"></div>
                  <div class="music-16-1"></div>
                  <div class="music-16-1"></div>
                  <div class="music-16-1"></div>
                  <div class="music-16-1"></div>
                  <div class="music-16-1"></div>

                  <div class="music-16-1-2"></div>
                  <div class="music-16-1-2"></div>
                </div>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-2-2: 252px;
                    --size-4-2: 516px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-music-16-1-widget {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    width: var(--size-4-2);
                    height: var(--size-2-2);
                  }
                  .widget-music-16-1-widget p {
                    display: flex;
                    color: white;
                    font-size: 20px;
                    font-family: Montserrat;
                    margin-left: 26px;
                  }
                  .widget-music-16-1-widget p:nth-child(1) {
                    color: rgba(115, 115, 115, 1);
                  }
                  .music-1 {
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    margin-left: 26px;
                    margin-right: 26px;
                  }
                  .music-1 div:nth-child(1) {
                    width: 3px;
                    height: 38px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-1 div:nth-child(2) {
                    width: 3px;
                    height: 32px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-1 div:nth-child(3) {
                    width: 3px;
                    height: 39px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-1 div:nth-child(4) {
                    width: 3px;
                    height: 20px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-1 div:nth-child(5) {
                    width: 3px;
                    height: 38px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-1 div:nth-child(6) {
                    width: 3px;
                    height: 50px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-1 div:nth-child(7) {
                    width: 3px;
                    height: 20px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-1 div:nth-child(8) {
                    width: 3px;
                    height: 12px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-1 div:nth-child(9) {
                    width: 3px;
                    height: 18px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-1 div:nth-child(10) {
                    width: 123px;
                    height: 3px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-1 div:nth-child(11) {
                    width: 254px;
                    height: 3px;
                    background-color: white;
                  }
                  .music-16-1 {
                    animation: pulse1 3s infinite;
                  }
                  .space-div-19-1 {
                    height: 26px;
                  }
                  @keyframes pulse1 {
                    from {
                      transform: scaleY(0.3);
                    }
                    50% {
                      transform: scaleY(1.5);
                    }
                    to {
                      transform: scaleY(0.3);
                    }
                  }
                </style>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-19-2"
              onclick="alert(getCode('btn-19-2'))"
            >
              <div class="design-2 widget-music-16-2-widget music-M">
                <div class="music-2">
                  <div class="music-16-2"></div>
                  <div class="music-16-2"></div>
                  <div class="music-16-2"></div>
                  <div class="music-16-2"></div>
                  <div class="music-16-2"></div>
                  <div class="music-16-2"></div>
                  <div class="music-16-2"></div>
                  <div class="music-16-2"></div>
                  <div class="music-16-2"></div>
                </div>
                <div class="music_name-16-2">
                  <p>Lynyrd Skynyrd</p>
                  <p>Simple man</p>
                </div>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --size-4-2: 516px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-music-16-2-widget {
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    width: var(--size-4-2);
                    height: var(--size-1-2);
                  }
                  .widget-music-16-2-widget p {
                    display: flex;
                    color: white;
                    font-size: 30px;
                    font-family: Montserrat;
                    margin-left: 26px;
                  }
                  .widget-music-16-2-widget p:nth-child(1) {
                    color: rgba(115, 115, 115, 1);
                  }
                  .music_name-16-2 {
                    display: flex;
                    flex-direction: column;
                  }
                  .music-2 {
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    width: 75px;
                    margin-left: 26px;
                    margin-right: 26px;
                  }
                  .music-2 div:nth-child(1) {
                    width: 3px;
                    height: 38px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-2 div:nth-child(2) {
                    width: 3px;
                    height: 32px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-2 div:nth-child(3) {
                    width: 3px;
                    height: 39px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-2 div:nth-child(4) {
                    width: 3px;
                    height: 20px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-2 div:nth-child(5) {
                    width: 3px;
                    height: 38px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-2 div:nth-child(6) {
                    width: 3px;
                    height: 29px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-2 div:nth-child(7) {
                    width: 3px;
                    height: 20px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-2 div:nth-child(8) {
                    width: 3px;
                    height: 27px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-2 div:nth-child(9) {
                    width: 3px;
                    height: 38px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-16-2 {
                    animation: pulse2 2.5s infinite;
                  }
                  @keyframes pulse2 {
                    from {
                      transform: scaleY(0.3);
                    }
                    50% {
                      transform: scaleY(1);
                    }
                    to {
                      transform: scaleY(0.3);
                    }
                  }
                </style>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-19-3"
              onclick="alert(getCode('btn-19-3'))"
            >
              <div class="design-2 widget-music-16-3-widget music-S">
                <div class="music-3">
                  <div class="music-16-3"></div>
                  <div class="music-16-3"></div>
                  <div class="music-16-3"></div>
                  <div class="music-16-3"></div>
                  <div class="music-16-3"></div>
                  <div class="music-16-3"></div>
                  <div class="music-16-3"></div>
                  <div class="music-16-3"></div>
                  <div class="music-16-3"></div>
                </div>
                <div class="music_name-16-3">
                  <p>Lynyrd Skynyrd</p>
                  <p>Simple man</p>
                </div>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-1-2: 120px;
                    --size-3-2: 384px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-music-16-3-widget {
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    width: var(--size-3-2);
                    height: var(--size-1-2);
                  }
                  .widget-music-16-3-widget p {
                    display: flex;
                    color: white;
                    font-size: 30px;
                    font-family: Montserrat;
                    margin-left: 26px;
                  }
                  .widget-music-16-3-widget p:nth-child(1) {
                    color: rgba(115, 115, 115, 1);
                  }
                  .music_name-16-3 {
                    display: flex;
                    flex-direction: column;
                  }
                  .music-3 {
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    width: 75px;
                    margin-left: 10px;
                  }
                  .music-3 div:nth-child(1) {
                    width: 3px;
                    height: 38px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-3 div:nth-child(2) {
                    width: 3px;
                    height: 32px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-3 div:nth-child(3) {
                    width: 3px;
                    height: 39px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-3 div:nth-child(4) {
                    width: 3px;
                    height: 20px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-3 div:nth-child(5) {
                    width: 3px;
                    height: 38px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-3 div:nth-child(6) {
                    width: 3px;
                    height: 29px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-3 div:nth-child(7) {
                    width: 3px;
                    height: 20px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-3 div:nth-child(8) {
                    width: 3px;
                    height: 27px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-3 div:nth-child(9) {
                    width: 3px;
                    height: 38px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-16-3 {
                    animation: pulse3 2.5s infinite;
                  }
                  @keyframes pulse3 {
                    from {
                      transform: scaleY(0.3);
                    }
                    50% {
                      transform: scaleY(1);
                    }
                    to {
                      transform: scaleY(0.3);
                    }
                  }
                </style>
              </div>
            </button>
            <button
              class="drop-2"
              id="btn-19-4"
              onclick="alert(getCode('btn-19-4'))"
            >
              <div class="design-2 widget-music-16-4-widget music-M">
                <div class="music-name-16-4">
                  <p>Lynyrd Skynyrd</p>
                  <p>Simple man</p>
                </div>

                <div class="space-div-19-4"></div>
                <div class="music-4">
                  <div class="music-16-4"></div>
                  <div class="music-16-4"></div>
                  <div class="music-16-4"></div>
                  <div class="music-16-4"></div>
                  <div class="music-16-4"></div>
                  <div class="music-16-4"></div>
                  <div class="music-16-4"></div>
                  <div class="music-16-4"></div>
                  <div class="music-16-4"></div>

                  <div class="music-16-4-2"></div>
                  <div class="music-16-4-2"></div>
                </div>
                <style>
                  @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

                  * {
                    margin: 0;
                    padding: 0;
                  }
                  :root {
                    --size-2-2: 252px;
                    --actent-color: rgba(57, 182, 251, 1);
                    --background-widgets: rgba(30, 30, 30, 1);
                  }
                  .design-2 {
                    background-color: var(--background-widgets);
                    border-radius: 26px;
                  }
                  .widget-music-16-4-widget {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    width: var(--size-2-2);
                    height: var(--size-2-2);
                  }
                  .widget-music-16-4-widget p {
                    display: flex;
                    color: white;
                    font-size: 26px;
                    font-family: Montserrat;
                    margin-left: 26px;
                  }
                  .widget-music-16-4-widget p:nth-child(1) {
                    color: rgba(115, 115, 115, 1);
                  }
                  .music-4 {
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    margin-left: 26px;
                    margin-right: 26px;
                  }
                  .music-4 div:nth-child(1) {
                    width: 3px;
                    height: 38px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-4 div:nth-child(2) {
                    width: 3px;
                    height: 32px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-4 div:nth-child(3) {
                    width: 3px;
                    height: 39px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-4 div:nth-child(4) {
                    width: 3px;
                    height: 20px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-4 div:nth-child(5) {
                    width: 3px;
                    height: 38px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-4 div:nth-child(6) {
                    width: 3px;
                    height: 50px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-4 div:nth-child(7) {
                    width: 3px;
                    height: 20px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-4 div:nth-child(8) {
                    width: 3px;
                    height: 12px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-4 div:nth-child(9) {
                    width: 3px;
                    height: 18px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-4 div:nth-child(10) {
                    width: 57px;
                    height: 3px;
                    background-color: rgba(57, 182, 251, 1);
                  }
                  .music-4 div:nth-child(11) {
                    width: 57px;
                    height: 3px;
                    background-color: white;
                  }
                  .music-16-4 {
                    animation: pulse4 3s infinite;
                  }
                  .space-div-19-4 {
                    height: 26px;
                  }
                  @keyframes pulse4 {
                    from {
                      transform: scaleY(0.3);
                    }
                    50% {
                      transform: scaleY(1);
                    }
                    to {
                      transform: scaleY(0.3);
                    }
                  }
                </style>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <style>
      * {
        margin: 0;
        padding: 0;
      }
      body {
        background: url("http://212.41.9.251:8000/static/back.jpg") no-repeat
          center center fixed;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
      }
      .navbar-1 {
        display: flex;
        flex-direction: column;
      }
      .window {
        border-radius: 10px;
        width: 100px;
        height: 50px;
        overflow-y: scroll;
      }
      .drop-1 {
        font-size: 20px;
        color: white;
        margin-top: 35px;
        margin-left: 20px;
        width: 300px;
        height: 252px;
        background-color: rgb(40, 40, 40);
        border: 1px solid red;
        border-radius: 25px;
        cursor: pointer;
        padding: 20px;
        outline: none;
      }
      .dropright-1 {
        display: flex;
        margin-top: 35px;
        gap: 10px;
        width: min-content;
        /* overflow: hidden; */
      }

      .drop-2 {
        font-size: 20px;
        color: white;
        margin-top: 35px;
        margin-left: 20px;
        background-color: rgba(40, 40, 40, 0.3);
        border: 1px solid red;
        border-radius: 25px;
        cursor: pointer;
        padding: 20px;
        outline: none;
      }
      .dropdown-2 {
        display: flex;
        gap: 10px;
        width: min-content;
        overflow: hidden;
      }
    </style>
    <script>
      function getCode(id_button) {
        return document.getElementById(id_button).innerHTML;
      }
    </script>
    
  </body>
</html>
`;

export const widgets1 = `<div class="navbar-1">
      <div class="dropright-1">
        <button class="drop-1">
          Аналоговые часы <br />
          11 вариант
        </button>
        <div class="drop-content-1">
          <div class="navbar-2">
            <div class="dropdown-2">
              <button
                class="drop-2"
                id="btn-1-1"
                onclick="alert(getCode('btn-1-1'))"
              >
                <div class="design-1 widget-analog-clock-M-11-1-widget analog-clock-M">
                  <canvas id="canvas1-1" width="246px" height="246px"></canvas>
                  <style>
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-2: 246px;
                      --background-widgets: rgba(30, 30, 30, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-analog-clock-M-11-1-widget {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: var(--size-2);
                      height: var(--size-2);
                    }
                  </style>
                  <script>
                    analogClock_11_1();
                    function analogClock_11_1() {
                      let center_x = 123;
                      let center_y = 123;
                      let radius = 117;
                      pi = Math.PI;
                      drawClock_11_1();
                      setInterval(drawClock_11_1, 100);

                      function drawClock_11_1() {
                        clock_11_1();
                        mark_circle_hours1(ctx, radius);
                        timing_11_1();
                      }
                      // стрелки
                      function timing_11_1() {
                        const d = new Date();
                        // часовая
                        ctx.beginPath();
                        ctx.lineWidth = 12;
                        ctx.strokeStyle = "rgba(64, 64, 64, 1)";
                        ctx.moveTo(center_x, center_y);
                        ctx.lineTo(
                          center_x +
                            Math.sin((d.getHours() * Math.PI) / 6) *
                              radius *
                              0.35,
                          center_y -
                            Math.cos((d.getHours() * Math.PI) / 6) *
                              radius *
                              0.35
                        );
                        ctx.lineCap = "round";
                        ctx.stroke();
                        ctx.closePath();
                        // минутная
                        ctx.beginPath();
                        ctx.lineWidth = 8;
                        ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                        ctx.moveTo(center_x, center_y);
                        ctx.lineTo(
                          center_x +
                            Math.sin((d.getMinutes() * Math.PI) / 30) *
                              radius *
                              0.65,
                          center_y -
                            Math.cos((d.getMinutes() * Math.PI) / 30) *
                              radius *
                              0.65
                        );
                        ctx.lineCap = "round";
                        ctx.stroke();
                        ctx.closePath();
                        // секундная
                        ctx.beginPath();
                        ctx.lineWidth = 4;
                        ctx.strokeStyle = "rgba(204, 204, 204, 1)";
                        ctx.moveTo(center_x, center_y);
                        ctx.lineTo(
                          center_x +
                            Math.sin((d.getSeconds() * Math.PI) / 30) *
                              radius *
                              0.93,
                          center_y -
                            Math.cos((d.getSeconds() * Math.PI) / 30) *
                              radius *
                              0.93
                        );
                        ctx.lineCap = "round";
                        ctx.stroke();
                        ctx.closePath();
                      }
                      // точки серые часовые
                      function mark_circle_hours1(ctx, radius) {
                        for (
                          var i = 0;
                          i <= Math.PI * 2;
                          i += (2 * Math.PI) / 12
                        ) {
                          fill(function () {
                            ctx.fillStyle = "rgba(115, 115, 115, 1)";
                            ctx.arc(
                              ctx.canvas.width / 2 +
                                ((15 * radius) / 16) * Math.cos(i),
                              ctx.canvas.height / 2 +
                                ((15 * radius) / 16) * Math.sin(i),
                              4,
                              0,
                              2 * Math.PI
                            );
                          });
                        }
                      }
                      function fill(fn, params) {
                        ctx.beginPath();
                        fn(params);
                        ctx.fill();
                        ctx.closePath();
                      }
                      function clock_11_1() {
                        canvas = document.getElementById("canvas1-1");
                        ctx = canvas.getContext("2d");
                        ctx.beginPath(); // начало нового пути
                        ctx.lineWidth = 2;
                        ctx.fillStyle = "white";
                        ctx.strokeStyle = "white";
                        // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                        ctx.arc(
                          center_x,
                          center_y,
                          radius - 2,
                          0,
                          2 * pi,
                          false
                        );
                        ctx.fill();
                        ctx.stroke();
                        ctx.closePath();
                      }
                    }
                  </script>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-1-2"
                onclick="alert(getCode('btn-1-2'))"
              >
                <div class="design-1 widget-analog-clock-M-11-2-widget analog-clock-M">
                  <canvas id="canvas1-2" width="246px" height="246px"></canvas>
                  <style>
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-2: 246px;
                      --background-widgets: rgba(30, 30, 30, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-analog-clock-M-11-2-widget {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: var(--size-2);
                      height: var(--size-2);
                    }
                  </style>
                  <script>
                    analogClock_11_2();
                    function analogClock_11_2() {
                      let center_x = 123;
                      let center_y = 123;
                      let radius = 117;
                      pi = Math.PI;
                      drawClock_11_2();
                      setInterval(drawClock_11_2, 100);

                      function drawClock_11_2() {
                        clock_11_2();
                        timing_11_2();
                      }
                      // стрелки
                      function timing_11_2() {
                        const d = new Date();
                        // минутная
                        ctx.beginPath();
                        ctx.lineWidth = 8;
                        ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                        ctx.moveTo(center_x, center_y);
                        let newX3 =
                          center_x +
                          Math.sin((d.getMinutes() * Math.PI) / 30) *
                            radius *
                            0.43;
                        let newY3 =
                          center_y -
                          Math.cos((d.getMinutes() * Math.PI) / 30) *
                            radius *
                            0.43;
                        ctx.lineTo(
                          center_x + Math.sin((d.getMinutes() * Math.PI) / 30),
                          center_y - Math.cos((d.getMinutes() * Math.PI) / 30)
                        );
                        ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                        ctx.moveTo(newX3, newY3);
                        ctx.lineTo(
                          newX3 +
                            Math.sin((d.getMinutes() * Math.PI) / 30) *
                              radius *
                              0.33,
                          newY3 -
                            Math.cos((d.getMinutes() * Math.PI) / 30) *
                              radius *
                              0.33
                        );
                        ctx.lineCap = "round";
                        ctx.stroke();
                        ctx.closePath();
                        // секундная
                        ctx.beginPath();
                        ctx.lineWidth = 12;
                        ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                        ctx.moveTo(center_x, center_y);
                        let newX =
                          center_x +
                          Math.sin((d.getSeconds() * Math.PI) / 30) *
                            radius *
                            0.9;
                        let newY =
                          center_y -
                          Math.cos((d.getSeconds() * Math.PI) / 30) *
                            radius *
                            0.9;
                        ctx.lineTo(
                          center_x +
                            Math.sin((d.getSeconds() * Math.PI) / 30) *
                              radius *
                              0.001,
                          center_y -
                            Math.cos((d.getSeconds() * Math.PI) / 30) *
                              radius *
                              0.001
                        );
                        ctx.strokeStyle = "rgba(251, 151, 57, 1)";
                        ctx.moveTo(newX, newY);
                        ctx.lineTo(
                          newX + Math.sin((d.getSeconds() * Math.PI) / 30),
                          newY - Math.cos((d.getSeconds() * Math.PI) / 30)
                        );
                        ctx.lineCap = "round";
                        ctx.stroke();
                        ctx.closePath();

                        ctx.beginPath(); // начало нового пути
                        ctx.fillStyle = "rgba(255, 255, 255, 1)";
                        // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                        ctx.arc(center_x, center_y, 10, 0, 2 * pi, false);
                        ctx.fill();
                        ctx.closePath();
                        // часовая
                        ctx.beginPath();
                        ctx.lineWidth = 12;
                        ctx.moveTo(center_x, center_y);
                        let newX2 =
                          center_x + Math.sin((d.getHours() * Math.PI) / 6);
                        let newY2 =
                          center_y - Math.cos((d.getHours() * Math.PI) / 6);
                        ctx.lineTo(
                          center_x + Math.sin((d.getHours() * Math.PI) / 6),
                          center_y - Math.cos((d.getHours() * Math.PI) / 6)
                        );
                        ctx.strokeStyle = "rgba(30, 30, 30, 1)";
                        ctx.moveTo(newX2, newY2);
                        ctx.lineTo(
                          newX2 +
                            Math.sin((d.getHours() * Math.PI) / 6) *
                              radius *
                              0.3,
                          newY2 -
                            Math.cos((d.getHours() * Math.PI) / 6) *
                              radius *
                              0.3
                        );
                        ctx.lineCap = "round";
                        ctx.stroke();
                        ctx.closePath();
                      }
                      function fill(fn, params) {
                        ctx.beginPath();
                        fn(params);
                        ctx.fill();
                        ctx.closePath();
                      }
                      function clock_11_2() {
                        canvas = document.getElementById("canvas1-2");
                        ctx = canvas.getContext("2d");
                        ctx.beginPath(); // начало нового пути
                        ctx.lineWidth = 2;
                        ctx.fillStyle = "white";
                        ctx.strokeStyle = "white";
                        // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                        ctx.arc(
                          center_x,
                          center_y,
                          radius - 2,
                          0,
                          2 * pi,
                          false
                        );
                        ctx.fill();
                        ctx.stroke();
                        ctx.closePath();
                      }
                    }
                  </script>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-1-3"
                onclick="alert(getCode('btn-1-3'))"
              >
                <div class="design-1 widget-analog-clock-M-11-3-widget analog-clock-M">
                  <canvas id="canvas1-3" width="246px" height="246px">
                    <style>
                      @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                      * {
                        margin: 0;
                        padding: 0;
                      }
                      :root {
                        --size-2: 246px;
                        --background-widgets: rgba(30, 30, 30, 1);
                      }
                      .design-1 {
                        background-color: var(--background-widgets);
                        border-radius: 32px;
                      }
                      .widget-analog-clock-M-11-3-widget {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: var(--size-2);
                        height: var(--size-2);
                      }
                    </style>
                    <script>
                      analogClock_11_3();
                      function analogClock_11_3() {
                        let center_x = 123;
                        let center_y = 123;
                        let radius = 117;
                        pi = Math.PI;
                        drawClock_11_3();
                        setInterval(drawClock_11_3, 100);

                        function drawClock_11_3() {
                          clock_11_3();
                          mark_circle_seconds1();
                          mark_circle_hours1(ctx, radius);
                          drawWBlackNumbers(ctx, radius);
                          timing_11_3();
                        }
                        // стрелки
                        function timing_11_3() {
                          const d = new Date();
                          angle =
                            Math.PI * 2 * (d.getSeconds() / 60) -
                            (Math.PI * 2) / 4;

                          // часовая
                          ctx.beginPath();
                          ctx.lineWidth = 8;
                          ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                          ctx.moveTo(center_x, center_y);
                          let newX4 =
                            center_x +
                            Math.sin((d.getHours() * Math.PI) / 6) *
                              radius *
                              0.2;
                          let newY4 =
                            center_y -
                            Math.cos((d.getHours() * Math.PI) / 6) *
                              radius *
                              0.2;
                          ctx.lineTo(
                            center_x + Math.sin((d.getHours() * Math.PI) / 6),
                            center_y - Math.cos((d.getHours() * Math.PI) / 6)
                          );
                          ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                          ctx.moveTo(newX4, newY4);
                          ctx.lineTo(
                            newX4 +
                              Math.sin((d.getHours() * Math.PI) / 6) *
                                radius *
                                0.25,
                            newY4 -
                              Math.cos((d.getHours() * Math.PI) / 6) *
                                radius *
                                0.25
                          );
                          ctx.lineCap = "round";
                          ctx.stroke();
                          ctx.closePath();

                          ctx.beginPath();
                          ctx.lineWidth = 4;
                          ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                          ctx.moveTo(center_x, center_y);
                          ctx.lineTo(
                            center_x +
                              Math.sin((d.getHours() * Math.PI) / 6) *
                                radius *
                                0.2,
                            center_y -
                              Math.cos((d.getHours() * Math.PI) / 6) *
                                radius *
                                0.2
                          );
                          ctx.lineCap = "round";
                          ctx.stroke();
                          ctx.closePath();
                          //минутная
                          ctx.beginPath();
                          ctx.lineWidth = 8;
                          ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                          ctx.moveTo(center_x, center_y);
                          let newX3 =
                            center_x +
                            Math.sin((d.getMinutes() * Math.PI) / 30) *
                              radius *
                              0.2;
                          let newY3 =
                            center_y -
                            Math.cos((d.getMinutes() * Math.PI) / 30) *
                              radius *
                              0.2;
                          ctx.lineTo(
                            center_x +
                              Math.sin((d.getMinutes() * Math.PI) / 30),
                            center_y - Math.cos((d.getMinutes() * Math.PI) / 30)
                          );
                          ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                          ctx.moveTo(newX3, newY3);
                          ctx.lineTo(
                            newX3 +
                              Math.sin((d.getMinutes() * Math.PI) / 30) *
                                radius *
                                0.4,
                            newY3 -
                              Math.cos((d.getMinutes() * Math.PI) / 30) *
                                radius *
                                0.4
                          );
                          ctx.lineCap = "round";
                          ctx.stroke();
                          ctx.closePath();

                          ctx.beginPath();
                          ctx.lineWidth = 4;
                          ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                          ctx.moveTo(center_x, center_y);
                          ctx.lineTo(
                            center_x +
                              Math.sin((d.getMinutes() * Math.PI) / 30) *
                                radius *
                                0.2,
                            center_y -
                              Math.cos((d.getMinutes() * Math.PI) / 30) *
                                radius *
                                0.2
                          );
                          ctx.lineCap = "round";
                          ctx.stroke();
                          ctx.closePath();
                          // секундная
                          ctx.lineWidth = 3;
                          ctx.beginPath();
                          ctx.moveTo(center_x, center_y);
                          ctx.lineTo(
                            canvas.width / 2 + (Math.cos(angle) * 60 * 25) / 14,
                            canvas.height / 2 + (Math.sin(angle) * 60 * 25) / 14
                          );
                          ctx.moveTo(canvas.width / 2, canvas.height / 2);
                          ctx.lineTo(
                            canvas.width / 2 - Math.cos(angle) * 20,
                            canvas.height / 2 - Math.sin(angle) * 20
                          );
                          ctx.lineCap = "round";
                          ctx.strokeStyle = "rgb(0, 0, 0, 1)";
                          ctx.stroke();
                          ctx.closePath();

                          ctx.beginPath(); // начало нового пути
                          ctx.fillStyle = "rgba(0, 0, 0, 1)";
                          // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                          ctx.arc(center_x, center_y, 4, 0, 2 * pi, false);
                          ctx.fill();
                          ctx.closePath();
                        }
                        // метки секундные серые
                        function mark_circle_seconds1() {
                          for (var i = 0; i < 60; i++) {
                            angle = ((i - 3) * (Math.PI * 2)) / 60; // THE ANGLE TO MARK.
                            ctx.lineWidth = 3; // HAND WIDTH.
                            ctx.beginPath();
                            ctx.fillStyle = "rgba(204, 204, 204, 1)";
                            var x1 =
                              center_x + (Math.cos(angle) * 60 * 18) / 10;
                            var y1 =
                              center_y + (Math.sin(angle) * 60 * 18) / 10;
                            ctx.arc(x1, y1, 3, 0, 2 * pi, false);
                            ctx.fill();
                            ctx.closePath();
                          }
                        }
                        // часовые метки серые точечные
                        function mark_circle_hours1(ctx, radius) {
                          for (
                            var i = 0;
                            i <= Math.PI * 2;
                            i += (2 * Math.PI) / 12
                          ) {
                            fill(function () {
                              ctx.fillStyle = "rgba(111, 111, 111, 1)";
                              ctx.arc(
                                ctx.canvas.width / 2 +
                                  ((15 * radius) / 16) * Math.cos(i),
                                ctx.canvas.height / 2 +
                                  ((15 * radius) / 16) * Math.sin(i),
                                3,
                                0,
                                2 * Math.PI
                              );
                            });
                          }
                        }
                        // отрисовка цифры черные
                        function drawWBlackNumbers(ctx, radius) {
                          var ang;
                          var num;
                          ctx.fillStyle = "black";
                          ctx.font = radius * 0.18 + "px rubik";
                          ctx.textBaseline = "middle";
                          ctx.textAlign = "center";
                          for (num = 1; num < 13; num++) {
                            ang = (num * Math.PI) / 6;
                            ctx.rotate(ang);
                            ctx.translate(0, -radius * 0.75);
                            ctx.rotate(-ang);
                            ctx.fillText(num.toString(), center_x, center_y);
                            ctx.rotate(ang);
                            ctx.translate(0, radius * 0.75);
                            ctx.rotate(-ang);
                          }
                        }
                        function fill(fn, params) {
                          ctx.beginPath();
                          fn(params);
                          ctx.fill();
                          ctx.closePath();
                        }
                        function clock_11_3() {
                          canvas = document.getElementById("canvas1-3");
                          ctx = canvas.getContext("2d");
                          ctx.beginPath(); // начало нового пути
                          ctx.lineWidth = 2;
                          ctx.fillStyle = "white";
                          ctx.strokeStyle = "white";
                          // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                          ctx.arc(
                            center_x,
                            center_y,
                            radius - 2,
                            0,
                            2 * pi,
                            false
                          );
                          ctx.fill();
                          ctx.stroke();
                          ctx.closePath();

                          ctx.beginPath(); // начало нового пути
                          ctx.fillStyle = "rgba(115, 115, 115, 1)";
                          // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                          ctx.arc(center_x, center_y, 7, 0, 2 * pi, false);
                          ctx.fill();
                          ctx.closePath();
                        }
                      }
                    </script>
                  </canvas>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-1-4"
                onclick="alert(getCode('btn-1-4'))"
              >
                <div class="design-1 widget-analog-clock-M-11-4-widget analog-clock-M">
                  <canvas id="canvas1-4" width="246px" height="246px">
                    <style>
                      * {
                        margin: 0;
                        padding: 0;
                      }
                      :root {
                        --size-2: 246px;
                        --background-widgets: rgba(30, 30, 30, 1);
                      }
                      .design-1 {
                        background-color: var(--background-widgets);
                        border-radius: 32px;
                      }
                      .widget-analog-clock-M-11-4-widget {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: var(--size-2);
                        height: var(--size-2);
                      }
                    </style>
                    <script>
                      analogClock_11_4();
                      function analogClock_11_4() {
                        let center_x = 123;
                        let center_y = 123;
                        let radius = 117;
                        pi = Math.PI;
                        drawClock_11_4();
                        setInterval(drawClock_11_4, 100);
                        function drawClock_11_4() {
                          clock_11_4();
                          mark_line_hours1();
                          timing_11_4();
                        }
                        // стрелки
                        function timing_11_4() {
                          const d = new Date();
                          angle =
                            Math.PI * 2 * (d.getSeconds() / 60) -
                            (Math.PI * 2) / 4;

                          // часовая
                          ctx.beginPath();
                          ctx.lineWidth = 8;
                          ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                          ctx.moveTo(center_x, center_y);
                          let newX4 =
                            center_x +
                            Math.sin((d.getHours() * Math.PI) / 6) *
                              radius *
                              0.2;
                          let newY4 =
                            center_y -
                            Math.cos((d.getHours() * Math.PI) / 6) *
                              radius *
                              0.2;
                          ctx.lineTo(
                            center_x + Math.sin((d.getHours() * Math.PI) / 6),
                            center_y - Math.cos((d.getHours() * Math.PI) / 6)
                          );
                          ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                          ctx.moveTo(newX4, newY4);
                          ctx.lineTo(
                            newX4 +
                              Math.sin((d.getHours() * Math.PI) / 6) *
                                radius *
                                0.25,
                            newY4 -
                              Math.cos((d.getHours() * Math.PI) / 6) *
                                radius *
                                0.25
                          );
                          ctx.lineCap = "round";
                          ctx.stroke();
                          ctx.closePath();

                          ctx.beginPath();
                          ctx.lineWidth = 4;
                          ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                          ctx.moveTo(center_x, center_y);
                          ctx.lineTo(
                            center_x +
                              Math.sin((d.getHours() * Math.PI) / 6) *
                                radius *
                                0.2,
                            center_y -
                              Math.cos((d.getHours() * Math.PI) / 6) *
                                radius *
                                0.2
                          );
                          ctx.lineCap = "round";
                          ctx.stroke();
                          ctx.closePath();
                          //минутная
                          ctx.beginPath();
                          ctx.lineWidth = 8;
                          ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                          ctx.moveTo(center_x, center_y);
                          let newX3 =
                            center_x +
                            Math.sin((d.getMinutes() * Math.PI) / 30) *
                              radius *
                              0.2;
                          let newY3 =
                            center_y -
                            Math.cos((d.getMinutes() * Math.PI) / 30) *
                              radius *
                              0.2;
                          ctx.lineTo(
                            center_x +
                              Math.sin((d.getMinutes() * Math.PI) / 30),
                            center_y - Math.cos((d.getMinutes() * Math.PI) / 30)
                          );
                          ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                          ctx.moveTo(newX3, newY3);
                          ctx.lineTo(
                            newX3 +
                              Math.sin((d.getMinutes() * Math.PI) / 30) *
                                radius *
                                0.4,
                            newY3 -
                              Math.cos((d.getMinutes() * Math.PI) / 30) *
                                radius *
                                0.4
                          );
                          ctx.lineCap = "round";
                          ctx.stroke();
                          ctx.closePath();

                          ctx.beginPath();
                          ctx.lineWidth = 4;
                          ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                          ctx.moveTo(center_x, center_y);
                          ctx.lineTo(
                            center_x +
                              Math.sin((d.getMinutes() * Math.PI) / 30) *
                                radius *
                                0.2,
                            center_y -
                              Math.cos((d.getMinutes() * Math.PI) / 30) *
                                radius *
                                0.2
                          );
                          ctx.lineCap = "round";
                          ctx.stroke();
                          ctx.closePath();
                          // секундная
                          ctx.lineWidth = 3;
                          ctx.beginPath();
                          ctx.moveTo(center_x, center_y);
                          ctx.lineTo(
                            canvas.width / 2 + (Math.cos(angle) * 60 * 19) / 11,
                            canvas.height / 2 + (Math.sin(angle) * 60 * 19) / 11
                          );
                          ctx.moveTo(canvas.width / 2, canvas.height / 2);
                          ctx.lineTo(
                            canvas.width / 2 - Math.cos(angle) * 20,
                            canvas.height / 2 - Math.sin(angle) * 20
                          );
                          ctx.lineCap = "round";
                          ctx.strokeStyle = "rgb(251, 151, 57, 1)";
                          ctx.stroke();
                          ctx.closePath();

                          ctx.beginPath(); // начало нового пути
                          ctx.fillStyle = "rgba(251, 151, 57, 1)";
                          // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                          ctx.arc(center_x, center_y, 7, 0, 2 * pi, false);
                          ctx.fill();
                          ctx.closePath();

                          ctx.beginPath(); // начало нового пути
                          ctx.fillStyle = "rgba(255, 255, 255, 1)";
                          // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                          ctx.arc(center_x, center_y, 5, 0, 2 * pi, false);
                          ctx.fill();
                          ctx.closePath();
                        }
                        //часовые метки темно-серые линейные
                        function mark_line_hours1() {
                          for (var i = 0; i < 12; i++) {
                            angle = ((i - 3) * (Math.PI * 2)) / 12;
                            ctx.lineWidth = 4;
                            ctx.beginPath();
                            var x1 =
                              center_x + (Math.cos(angle) * 60 * 17) / 10;
                            var y1 =
                              center_y + (Math.sin(angle) * 60 * 17) / 10;
                            var x2 =
                              center_x +
                              (Math.cos(angle) * (60 - 60 / 30) * 8) / 5;
                            var y2 =
                              center_y +
                              (Math.sin(angle) * (60 - 60 / 30) * 8) / 5;
                            ctx.moveTo(x1, y1);
                            ctx.lineTo(x2, y2);
                            ctx.lineCap = "round";
                            ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                            ctx.stroke();
                            ctx.closePath();
                          }
                        }
                        function fill(fn, params) {
                          ctx.beginPath();
                          fn(params);
                          ctx.fill();
                          ctx.closePath();
                        }
                        function clock_11_4() {
                          canvas = document.getElementById("canvas1-4");
                          ctx = canvas.getContext("2d");
                          ctx.beginPath(); // начало нового пути
                          ctx.lineWidth = 2;
                          ctx.fillStyle = "white";
                          ctx.strokeStyle = "white";
                          // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                          ctx.arc(
                            center_x,
                            center_y,
                            radius - 2,
                            0,
                            2 * pi,
                            false
                          );
                          ctx.fill();
                          ctx.stroke();
                          ctx.closePath();

                          ctx.beginPath(); // начало нового пути
                          ctx.fillStyle = "rgba(115, 115, 115, 1)";
                          // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                          ctx.arc(center_x, center_y, 9, 0, 2 * pi, false);
                          ctx.fill();
                          ctx.closePath();
                        }
                      }
                    </script>
                  </canvas>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-1-5"
                onclick="alert(getCode('btn-1-5'))"
              >
                <div class="design-1 widget-analog-clock-M-11-5-widget analog-clock-M">
                  <canvas id="canvas1-5" width="246px" height="246px">
                    <style>
                      * {
                        margin: 0;
                        padding: 0;
                      }
                      :root {
                        --size-2: 246px;
                        --background-widgets: rgba(30, 30, 30, 1);
                      }
                      .design-1 {
                        background-color: var(--background-widgets);
                        border-radius: 32px;
                      }
                      .widget-analog-clock-M-11-5-widget {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: var(--size-2);
                        height: var(--size-2);
                      }
                    </style>
                    <script>
                      analogClock_11_5();
                      function analogClock_11_5() {
                        let center_x = 123;
                        let center_y = 123;
                        let radius = 117;
                        pi = Math.PI;
                        drawClock_11_5();
                        setInterval(drawClock_11_5, 100);
                        // готовы
                        function drawClock_11_5() {
                          clock_11_5();
                          mark_circle_hours1(ctx, radius);
                          timing_11_5();
                        }
                        // стрелки
                        function timing_11_5() {
                          const d = new Date();
                          // часовая
                          ctx.beginPath();
                          ctx.lineWidth = 12;
                          ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                          ctx.moveTo(center_x, center_y);
                          ctx.lineTo(
                            center_x +
                              Math.sin((d.getHours() * Math.PI) / 6) *
                                radius *
                                0.35,
                            center_y -
                              Math.cos((d.getHours() * Math.PI) / 6) *
                                radius *
                                0.35
                          );
                          ctx.lineCap = "round";
                          ctx.stroke();
                          ctx.closePath();
                          // минутная
                          ctx.beginPath();
                          ctx.lineWidth = 8;
                          ctx.strokeStyle = "rgba(204, 204, 204, 1)";
                          ctx.moveTo(center_x, center_y);
                          ctx.lineTo(
                            center_x +
                              Math.sin((d.getMinutes() * Math.PI) / 30) *
                                radius *
                                0.65,
                            center_y -
                              Math.cos((d.getMinutes() * Math.PI) / 30) *
                                radius *
                                0.65
                          );
                          ctx.lineCap = "round";
                          ctx.stroke();
                          ctx.closePath();
                          // секундная
                          ctx.beginPath();
                          ctx.lineWidth = 4;
                          ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                          ctx.moveTo(center_x, center_y);
                          ctx.lineTo(
                            center_x +
                              Math.sin((d.getSeconds() * Math.PI) / 30) *
                                radius *
                                0.9,
                            center_y -
                              Math.cos((d.getSeconds() * Math.PI) / 30) *
                                radius *
                                0.9
                          );
                          ctx.lineCap = "round";
                          ctx.stroke();
                          ctx.closePath();
                        }
                        // часовые метки серые точечные
                        function mark_circle_hours1(ctx, radius) {
                          for (
                            var i = 0;
                            i <= Math.PI * 2;
                            i += (2 * Math.PI) / 12
                          ) {
                            fill(function () {
                              ctx.fillStyle = "rgba(115, 115, 115, 1)";
                              ctx.arc(
                                ctx.canvas.width / 2 +
                                  ((10 * radius) / 11) * Math.cos(i),
                                ctx.canvas.height / 2 +
                                  ((10 * radius) / 11) * Math.sin(i),
                                4,
                                0,
                                2 * Math.PI
                              );
                            });
                          }
                        }
                        function fill(fn, params) {
                          ctx.beginPath();
                          fn(params);
                          ctx.fill();
                          ctx.closePath();
                        }
                        function clock_11_5() {
                          canvas = document.getElementById("canvas1-5");
                          ctx = canvas.getContext("2d");
                          ctx.beginPath(); // начало нового пути
                          ctx.lineWidth = 2;
                          ctx.fillStyle = "rgba(16, 16, 16, 1)";
                          ctx.strokeStyle = "rgba(16, 16, 16, 1)";
                          // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                          ctx.arc(
                            center_x,
                            center_y,
                            radius - 2,
                            0,
                            2 * pi,
                            false
                          );
                          ctx.fill();
                          ctx.stroke();
                          ctx.closePath();
                        }
                      }
                    </script>
                  </canvas>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-1-6"
                onclick="alert(getCode('btn-1-6'))"
              >
                <div class="design-1 widget-analog-clock-M-11-6-widget analog-clock-M">
                  <canvas id="canvas1-6" width="246px" height="246px">
                    <style>
                      * {
                        margin: 0;
                        padding: 0;
                      }
                      :root {
                        --size-2: 246px;
                        --background-widgets: rgba(30, 30, 30, 1);
                      }
                      .design-1 {
                        background-color: var(--background-widgets);
                        border-radius: 32px;
                      }
                      .widget-analog-clock-M-11-6-widget {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: var(--size-2);
                        height: var(--size-2);
                      }
                    </style>
                    <script>
                      analogClock_11_6();
                      function analogClock_11_6() {
                        let center_x = 123;
                        let center_y = 123;
                        let radius = 117;
                        pi = Math.PI;
                        drawClock_11_6();
                        setInterval(drawClock_11_6, 100);
                        function drawClock_11_6() {
                          clock_11_6();
                          mark_line_hours2();
                          timing_11_6();
                        }
                        // стрелки
                        function timing_11_6() {
                          const d = new Date();
                          angle =
                            Math.PI * 2 * (d.getSeconds() / 60) -
                            (Math.PI * 2) / 4;
                          // часовая
                          ctx.beginPath();
                          ctx.lineWidth = 8;
                          ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                          ctx.moveTo(center_x, center_y);
                          let newX4 =
                            center_x +
                            Math.sin((d.getHours() * Math.PI) / 6) *
                              radius *
                              0.2;
                          let newY4 =
                            center_y -
                            Math.cos((d.getHours() * Math.PI) / 6) *
                              radius *
                              0.2;
                          ctx.lineTo(
                            center_x + Math.sin((d.getHours() * Math.PI) / 6),
                            center_y - Math.cos((d.getHours() * Math.PI) / 6)
                          );
                          ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                          ctx.moveTo(newX4, newY4);
                          ctx.lineTo(
                            newX4 +
                              Math.sin((d.getHours() * Math.PI) / 6) *
                                radius *
                                0.25,
                            newY4 -
                              Math.cos((d.getHours() * Math.PI) / 6) *
                                radius *
                                0.25
                          );
                          ctx.lineCap = "round";
                          ctx.stroke();
                          ctx.closePath();

                          ctx.beginPath();
                          ctx.lineWidth = 4;
                          ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                          ctx.moveTo(center_x, center_y);
                          ctx.lineTo(
                            center_x +
                              Math.sin((d.getHours() * Math.PI) / 6) *
                                radius *
                                0.2,
                            center_y -
                              Math.cos((d.getHours() * Math.PI) / 6) *
                                radius *
                                0.2
                          );
                          ctx.lineCap = "round";
                          ctx.stroke();
                          ctx.closePath();
                          //минутная
                          ctx.beginPath();
                          ctx.lineWidth = 8;
                          ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                          ctx.moveTo(center_x, center_y);
                          let newX3 =
                            center_x +
                            Math.sin((d.getMinutes() * Math.PI) / 30) *
                              radius *
                              0.2;
                          let newY3 =
                            center_y -
                            Math.cos((d.getMinutes() * Math.PI) / 30) *
                              radius *
                              0.2;
                          ctx.lineTo(
                            center_x +
                              Math.sin((d.getMinutes() * Math.PI) / 30),
                            center_y - Math.cos((d.getMinutes() * Math.PI) / 30)
                          );
                          ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                          ctx.moveTo(newX3, newY3);
                          ctx.lineTo(
                            newX3 +
                              Math.sin((d.getMinutes() * Math.PI) / 30) *
                                radius *
                                0.4,
                            newY3 -
                              Math.cos((d.getMinutes() * Math.PI) / 30) *
                                radius *
                                0.4
                          );
                          ctx.lineCap = "round";
                          ctx.stroke();
                          ctx.closePath();

                          ctx.beginPath();
                          ctx.lineWidth = 4;
                          ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                          ctx.moveTo(center_x, center_y);
                          ctx.lineTo(
                            center_x +
                              Math.sin((d.getMinutes() * Math.PI) / 30) *
                                radius *
                                0.2,
                            center_y -
                              Math.cos((d.getMinutes() * Math.PI) / 30) *
                                radius *
                                0.2
                          );
                          ctx.lineCap = "round";
                          ctx.stroke();
                          ctx.closePath();
                          // секундная
                          ctx.lineWidth = 3;
                          ctx.beginPath();
                          ctx.moveTo(center_x, center_y);
                          ctx.lineTo(
                            canvas.width / 2 + (Math.cos(angle) * 60 * 19) / 11,
                            canvas.height / 2 + (Math.sin(angle) * 60 * 19) / 11
                          );
                          ctx.moveTo(canvas.width / 2, canvas.height / 2);
                          ctx.lineTo(
                            canvas.width / 2 - Math.cos(angle) * 20,
                            canvas.height / 2 - Math.sin(angle) * 20
                          );
                          ctx.lineCap = "round";
                          ctx.strokeStyle = "rgb(115, 115, 115, 1)";
                          ctx.stroke();
                          ctx.closePath();
                          ctx.beginPath(); // начало нового пути
                          ctx.fillStyle = "rgba(115, 115, 115, 1)";
                          // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                          ctx.arc(center_x, center_y, 7, 0, 2 * pi, false);
                          ctx.fill();
                          ctx.closePath();
                          ctx.beginPath(); // начало нового пути
                          ctx.fillStyle = "rgba(255, 255, 255, 1)";
                          // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                          ctx.arc(center_x, center_y, 5, 0, 2 * pi, false);
                          ctx.fill();
                          ctx.closePath();
                        }
                        // часовые метки белые линейные
                        function mark_line_hours2() {
                          for (var i = 0; i < 12; i++) {
                            angle = ((i - 3) * (Math.PI * 2)) / 12;
                            ctx.lineWidth = 4;
                            ctx.beginPath();
                            var x1 =
                              center_x + (Math.cos(angle) * 60 * 17) / 10;
                            var y1 =
                              center_y + (Math.sin(angle) * 60 * 17) / 10;
                            var x2 =
                              center_x +
                              (Math.cos(angle) * (60 - 60 / 30) * 8) / 5;
                            var y2 =
                              center_y +
                              (Math.sin(angle) * (60 - 60 / 30) * 8) / 5;
                            ctx.moveTo(x1, y1);
                            ctx.lineTo(x2, y2);
                            ctx.lineCap = "round";
                            ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                            ctx.stroke();
                            ctx.closePath();
                          }
                        }
                        function fill(fn, params) {
                          ctx.beginPath();
                          fn(params);
                          ctx.fill();
                          ctx.closePath();
                        }
                        function clock_11_6() {
                          canvas = document.getElementById("canvas1-6");
                          ctx = canvas.getContext("2d");
                          ctx.beginPath(); // начало нового пути
                          ctx.lineWidth = 2;
                          ctx.fillStyle = "rgba(16, 16, 16, 1)";
                          ctx.strokeStyle = "rgba(16, 16, 16, 1)";
                          // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                          ctx.arc(
                            center_x,
                            center_y,
                            radius - 2,
                            0,
                            2 * pi,
                            false
                          );
                          ctx.fill();
                          ctx.stroke();
                          ctx.closePath();

                          ctx.beginPath(); // начало нового пути
                          ctx.fillStyle = "white";
                          // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                          ctx.arc(center_x, center_y, 9, 0, 2 * pi, false);
                          ctx.fill();
                          ctx.closePath();
                        }
                      }
                    </script>
                  </canvas>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-1-7"
                onclick="alert(getCode('btn-1-7'))"
              >
                <div class="design-1 widget-analog-clock-M-11-7-widget analog-clock-M">
                  <canvas id="canvas1-7" width="246px" height="246px">
                    <style>
                      @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                      * {
                        margin: 0;
                        padding: 0;
                      }
                      :root {
                        --size-2: 246px;
                        --background-widgets: rgba(30, 30, 30, 1);
                      }
                      .design-1 {
                        background-color: var(--background-widgets);
                        border-radius: 32px;
                      }
                      .widget-analog-clock-M-11-7-widget {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: var(--size-2);
                        height: var(--size-2);
                      }
                    </style>
                    <script>
                      analogClock_11_7();
                      function analogClock_11_7() {
                        let center_x = 123;
                        let center_y = 123;
                        let radius = 117;
                        pi = Math.PI;
                        drawClock_11_7();
                        setInterval(drawClock_11_7, 100);
                        function drawClock_11_7() {
                          clock_11_7();
                          mark_circle_seconds2();
                          mark_circle_hours2(ctx, radius);
                          drawWhiteNumbers(ctx, radius);
                          timing_11_7();
                        }
                        // стрелки
                        function timing_11_7() {
                          const d = new Date();
                          angle =
                            Math.PI * 2 * (d.getSeconds() / 60) -
                            (Math.PI * 2) / 4;
                          // часовая
                          ctx.beginPath();
                          ctx.lineWidth = 8;
                          ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                          ctx.moveTo(center_x, center_y);
                          let newX4 =
                            center_x +
                            Math.sin((d.getHours() * Math.PI) / 6) *
                              radius *
                              0.2;
                          let newY4 =
                            center_y -
                            Math.cos((d.getHours() * Math.PI) / 6) *
                              radius *
                              0.2;
                          ctx.lineTo(
                            center_x + Math.sin((d.getHours() * Math.PI) / 6),
                            center_y - Math.cos((d.getHours() * Math.PI) / 6)
                          );
                          ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                          ctx.moveTo(newX4, newY4);
                          ctx.lineTo(
                            newX4 +
                              Math.sin((d.getHours() * Math.PI) / 6) *
                                radius *
                                0.25,
                            newY4 -
                              Math.cos((d.getHours() * Math.PI) / 6) *
                                radius *
                                0.25
                          );
                          ctx.lineCap = "round";
                          ctx.stroke();
                          ctx.closePath();

                          ctx.beginPath();
                          ctx.lineWidth = 4;
                          ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                          ctx.moveTo(center_x, center_y);
                          ctx.lineTo(
                            center_x +
                              Math.sin((d.getHours() * Math.PI) / 6) *
                                radius *
                                0.2,
                            center_y -
                              Math.cos((d.getHours() * Math.PI) / 6) *
                                radius *
                                0.2
                          );
                          ctx.lineCap = "round";
                          ctx.stroke();
                          ctx.closePath();
                          //минутная
                          ctx.beginPath();
                          ctx.lineWidth = 8;
                          ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                          ctx.moveTo(center_x, center_y);
                          let newX3 =
                            center_x +
                            Math.sin((d.getMinutes() * Math.PI) / 30) *
                              radius *
                              0.2;
                          let newY3 =
                            center_y -
                            Math.cos((d.getMinutes() * Math.PI) / 30) *
                              radius *
                              0.2;
                          ctx.lineTo(
                            center_x +
                              Math.sin((d.getMinutes() * Math.PI) / 30),
                            center_y - Math.cos((d.getMinutes() * Math.PI) / 30)
                          );
                          ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                          ctx.moveTo(newX3, newY3);
                          ctx.lineTo(
                            newX3 +
                              Math.sin((d.getMinutes() * Math.PI) / 30) *
                                radius *
                                0.4,
                            newY3 -
                              Math.cos((d.getMinutes() * Math.PI) / 30) *
                                radius *
                                0.4
                          );
                          ctx.lineCap = "round";
                          ctx.stroke();
                          ctx.closePath();

                          ctx.beginPath();
                          ctx.lineWidth = 4;
                          ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                          ctx.moveTo(center_x, center_y);
                          ctx.lineTo(
                            center_x +
                              Math.sin((d.getMinutes() * Math.PI) / 30) *
                                radius *
                                0.2,
                            center_y -
                              Math.cos((d.getMinutes() * Math.PI) / 30) *
                                radius *
                                0.2
                          );
                          ctx.lineCap = "round";
                          ctx.stroke();
                          ctx.closePath();
                          // секундная
                          ctx.lineWidth = 3;
                          ctx.beginPath();
                          ctx.moveTo(center_x, center_y);
                          ctx.lineTo(
                            canvas.width / 2 + (Math.cos(angle) * 60 * 19) / 11,
                            canvas.height / 2 + (Math.sin(angle) * 60 * 19) / 11
                          );
                          ctx.moveTo(canvas.width / 2, canvas.height / 2);
                          ctx.lineTo(
                            canvas.width / 2 - Math.cos(angle) * 20,
                            canvas.height / 2 - Math.sin(angle) * 20
                          );
                          ctx.lineCap = "round";
                          ctx.strokeStyle = "rgb(255, 255, 255, 1)";
                          ctx.stroke();
                          ctx.closePath();

                          ctx.beginPath(); // начало нового пути
                          ctx.fillStyle = "rgba(255, 255, 255, 1)";
                          // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                          ctx.arc(center_x, center_y, 4, 0, 2 * pi, false);
                          ctx.fill();
                          ctx.closePath();
                        }
                        function mark_circle_hours2(ctx, radius) {
                          for (
                            var i = 0;
                            i <= Math.PI * 2;
                            i += (2 * Math.PI) / 12
                          ) {
                            fill(function () {
                              ctx.fillStyle = "rgba(255, 255, 255, 1)";
                              ctx.arc(
                                ctx.canvas.width / 2 +
                                  ((90 * radius) / 100) * Math.cos(i),
                                ctx.canvas.height / 2 +
                                  ((90 * radius) / 100) * Math.sin(i),
                                4,
                                0,
                                2 * Math.PI
                              );
                            });
                          }
                        }

                        //  секундные метки темно-серые точечные
                        function mark_circle_seconds2() {
                          for (var i = 0; i < 60; i++) {
                            angle = ((i - 3) * (Math.PI * 2)) / 60; // THE ANGLE TO MARK.
                            ctx.lineWidth = 3; // HAND WIDTH.
                            ctx.beginPath();
                            ctx.fillStyle = "rgba(64, 64, 64, 1)";
                            var x1 = center_x + (Math.cos(angle) * 60 * 14) / 8;
                            var y1 = center_y + (Math.sin(angle) * 60 * 14) / 8;
                            ctx.arc(x1, y1, 4, 0, 2 * pi, false);
                            ctx.fill();
                            ctx.closePath();
                          }
                        }
                        function fill(fn, params) {
                          ctx.beginPath();
                          fn(params);
                          ctx.fill();
                          ctx.closePath();
                        }
                        // отрисовка цифр белые
                        function drawWhiteNumbers(ctx, radius) {
                          var ang;
                          var num;
                          ctx.font = radius * 0.18 + "px rubik";
                          ctx.textBaseline = "middle";
                          ctx.textAlign = "center";
                          for (num = 1; num < 13; num++) {
                            ang = (num * Math.PI) / 6;
                            ctx.rotate(ang);
                            ctx.translate(0, -radius * 0.75);
                            ctx.rotate(-ang);
                            ctx.fillText(num.toString(), center_x, center_y);
                            ctx.rotate(ang);
                            ctx.translate(0, radius * 0.75);
                            ctx.rotate(-ang);
                          }
                        }
                        function clock_11_7() {
                          canvas = document.getElementById("canvas1-7");
                          ctx = canvas.getContext("2d");
                          ctx.beginPath(); // начало нового пути
                          ctx.lineWidth = 2;
                          ctx.fillStyle = "rgba(16, 16, 16, 1)";
                          ctx.strokeStyle = "rgba(16, 16, 16, 1)";
                          // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                          ctx.arc(
                            center_x,
                            center_y,
                            radius - 2,
                            0,
                            2 * pi,
                            false
                          );
                          ctx.fill();
                          ctx.stroke();
                          ctx.closePath();

                          ctx.beginPath(); // начало нового пути
                          ctx.fillStyle = "rgba(115, 115, 115, 1)";
                          // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                          ctx.arc(center_x, center_y, 7, 0, 2 * pi, false);
                          ctx.fill();
                          ctx.closePath();
                        }
                      }
                    </script>
                  </canvas>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-1-8"
                onclick="alert(getCode('btn-1-8'))"
              >
                <div class="design-1 widget-analog-clock-M-11-8-widget analog-clock-M">
                  <canvas id="canvas1-8" width="246px" height="246px">
                    <style>
                      * {
                        margin: 0;
                        padding: 0;
                      }
                      :root {
                        --size-2: 246px;
                        --background-widgets: rgba(30, 30, 30, 1);
                      }
                      .design-1 {
                        background-color: var(--background-widgets);
                        border-radius: 32px;
                      }
                      .widget-analog-clock-M-11-8-widget {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: var(--size-2);
                        height: var(--size-2);
                      }
                    </style>
                    <script>
                      analogClock_11_8();
                      function analogClock_11_8() {
                        let center_x = 123;
                        let center_y = 123;
                        let radius = 117;
                        pi = Math.PI;
                        drawClock_11_8();
                        setInterval(drawClock_11_8, 100);
                        // готовы
                        function drawClock_11_8() {
                          clock_11_8();
                          mark_circle_hours3(ctx, radius);
                          timing_11_8();
                        }
                        // стрелки
                        function timing_11_8() {
                          const d = new Date();
                          // часовая
                          ctx.beginPath();
                          ctx.lineWidth = 8;
                          ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                          ctx.moveTo(center_x, center_y);
                          ctx.lineTo(
                            center_x +
                              Math.sin((d.getHours() * Math.PI) / 6) *
                                radius *
                                0.45,
                            center_y -
                              Math.cos((d.getHours() * Math.PI) / 6) *
                                radius *
                                0.45
                          );
                          ctx.lineCap = "round";
                          ctx.stroke();
                          ctx.closePath();
                          // минутная
                          ctx.beginPath();
                          ctx.lineWidth = 8;
                          ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                          ctx.moveTo(center_x, center_y);
                          ctx.lineTo(
                            center_x +
                              Math.sin((d.getMinutes() * Math.PI) / 30) *
                                radius *
                                0.7,
                            center_y -
                              Math.cos((d.getMinutes() * Math.PI) / 30) *
                                radius *
                                0.7
                          );
                          ctx.lineCap = "round";
                          ctx.stroke();
                          ctx.closePath();
                          //секуная
                          angle =
                            Math.PI * 2 * (d.getSeconds() / 60) -
                            (Math.PI * 2) / 4;
                          ctx.lineWidth = 4;
                          ctx.beginPath();
                          ctx.moveTo(center_x, center_y);
                          ctx.lineTo(
                            canvas.width / 2 + (Math.cos(angle) * 60 * 18) / 11,
                            canvas.height / 2 + (Math.sin(angle) * 60 * 18) / 11
                          );
                          ctx.moveTo(canvas.width / 2, canvas.height / 2);
                          ctx.lineTo(
                            canvas.width / 2 - Math.cos(angle) * 20,
                            canvas.height / 2 - Math.sin(angle) * 20
                          );
                          ctx.lineCap = "round";
                          ctx.strokeStyle = "rgb(255, 255, 255, 1)";
                          ctx.stroke();
                          ctx.closePath();
                        }
                        // часовые метки белые точечные
                        function mark_circle_hours3(ctx, radius) {
                          for (
                            var i = 0;
                            i <= Math.PI * 2;
                            i += (2 * Math.PI) / 12
                          ) {
                            fill(function () {
                              ctx.fillStyle = "rgba(255, 255, 255, 1)";
                              ctx.arc(
                                ctx.canvas.width / 2 +
                                  ((6 * radius) / 7) * Math.cos(i),
                                ctx.canvas.height / 2 +
                                  ((6 * radius) / 7) * Math.sin(i),
                                5,
                                0,
                                2 * Math.PI
                              );
                            });
                          }
                        }
                        function fill(fn, params) {
                          ctx.beginPath();
                          fn(params);
                          ctx.fill();
                          ctx.closePath();
                        }
                        function clock_11_8() {
                          canvas = document.getElementById("canvas1-8");
                          ctx = canvas.getContext("2d");
                          ctx.beginPath(); // начало нового пути
                          ctx.lineWidth = 3;
                          ctx.strokeStyle = "white";
                          ctx.fillStyle = "rgba(16, 16, 16, 1)";
                          // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                          ctx.arc(
                            center_x,
                            center_y,
                            radius - 2,
                            0,
                            2 * pi,
                            false
                          );
                          ctx.fill();
                          ctx.stroke();
                          ctx.closePath();

                          ctx.beginPath(); // начало нового пути
                          ctx.fillStyle = "white";
                          // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                          ctx.arc(center_x, center_y, 8, 0, 2 * pi, false);
                          ctx.fill();
                          ctx.closePath();
                        }
                      }
                    </script>
                  </canvas>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="dropright-1">
        <button class="drop-1">
          Цифровые часы <br />
          11 вариант
        </button>
        <div class="drop-content-1">
          <div class="navbar-2">
            <div class="dropdown-2">
              <button
                class="drop-2"
                id="btn-2-1"
                onclick="alert(getCode('btn-2-1'))"
              >
                <div
                  class="design-1 widget-digital-clock-XL-11-1-widget digital-clock-XL"
                >
                  <p id="hour-minutes11-1"></p>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-2: 246px;
                      --size-4: 508px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-digital-clock-XL-11-1-widget {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: var(--size-4);
                      height: var(--size-2);
                    }
                    .widget-digital-clock-XL-11-1-widget p {
                      font-family: rubik;
                      font-size: 140px;
                      font-weight: 300;
                      color: var(--text-color);
                    }
                  </style>
                  <script>
                    setInterval(function setTime_11_1() {
                      d = new Date();
                      document.getElementById(
                        "hour-minutes11-1"
                      ).innerHTML = \`\${d.toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}\`;
                    }, 100);
                  </script>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-2-2"
                onclick="alert(getCode('btn-2-2'))"
              >
                <div
                  class="design-1 widget-digital-clock-XL-11-2-widget digital-clock-XL"
                >
                  <p id="hour-minutes11-2"></p>
                  <p id="seconds11-2"></p>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-2: 246px;
                      --size-4: 508px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-digital-clock-XL-11-2-widget {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: var(--size-4);
                      height: var(--size-2);
                    }
                    .widget-digital-clock-XL-11-2-widget p {
                      font-family: rubik;
                      font-size: 140px;
                      font-weight: 300;
                      color: var(--text-color);
                    }
                    .widget-digital-clock-XL-11-2-widget p:first-child {
                      width: 380px;
                      text-align: center;
                    }
                    .widget-digital-clock-XL-11-2-widget p:nth-child(2) {
                      margin-top: 50px;
                      width: 88px;
                      font-size: 70px;
                      color: rgba(64, 64, 64, 1);
                      text-align: start;
                    }
                  </style>
                  <script>
                    setInterval(function setTime_11_2() {
                      d = new Date();
                      document.getElementById(
                        "hour-minutes11-2"
                      ).innerHTML = \`\${d.toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}\`;
                      document.getElementById(
                        "seconds11-2"
                      ).innerHTML = \`\${d.toLocaleTimeString([], {
                        second: "2-digit",
                      })}\`;
                    }, 100);
                  </script>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-2-3"
                onclick="alert(getCode('btn-2-3'))"
              >
                <div
                  class="design-1 widget-digital-clock-L-11-3-widget digital-clock-L"
                >
                  <p id="hour11-3"></p>
                  <p>:</p>
                  <p id="minutes11-3"></p>
                  <p>:</p>
                  <p id="seconds11-3"></p>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-1: 115px;
                      --size-3: 377px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-digital-clock-L-11-3-widget {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: var(--size-3);
                      height: var(--size-1);
                    }
                    .widget-digital-clock-L-11-3-widget p {
                      font-family: rubik;
                      font-size: 70px;
                      font-weight: 300;
                      color: var(--text-color);
                    }
                    .widget-digital-clock-L-11-3-widget p:nth-child(2n + 1) {
                      width: 88px;
                      text-align: center;
                    }
                    .widget-digital-clock-L-11-3-widget p:nth-child(5) {
                      color: rgba(64, 64, 64, 1);
                      width: 88px;
                    }
                  </style>
                  <script>
                    setInterval(function setTime_11_3() {
                      d = new Date();
                      document.getElementById(
                        "hour11-3"
                      ).innerHTML = \`\${d.toLocaleTimeString([], {
                        hour: "2-digit",
                      })}\`;
                      document.getElementById(
                        "minutes11-3"
                      ).innerHTML = \`\${d.toLocaleTimeString([], {
                        minute: "2-digit",
                      })}\`;
                      document.getElementById(
                        "seconds11-3"
                      ).innerHTML = \`\${d.toLocaleTimeString([], {
                        second: "2-digit",
                      })}\`;
                    }, 100);
                  </script>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-2-4"
                onclick="alert(getCode('btn-2-4'))"
              >
                <div class="design-1 widget-clock-S-11-4-widget digital-clock-S">
                  <p id="hour-minutes11-4"></p>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-1: 115px;
                      --size-2: 246px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-clock-S-11-4-widget {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: var(--size-2);
                      height: var(--size-1);
                    }
                    .widget-clock-S-11-4-widget p {
                      font-family: rubik;
                      font-size: 70px;
                      font-weight: 300;
                      color: var(--text-color);
                    }
                  </style>
                  <script>
                    setInterval(function setTime_11_4() {
                      d = new Date();
                      document.getElementById(
                        "hour-minutes11-4"
                      ).innerHTML = \`\${d.toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}\`;
                    }, 100);
                  </script>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="dropright-1">
        <button class="drop-1">
          Календари <br />
          11 вариант
        </button>
        <div class="drop-content-1">
          <div class="navbar-2">
            <div class="dropdown-2">
              <button
                class="drop-2"
                id="btn-3-1"
                onclick="alert(getCode('btn-3-1'))"
              >
                <div class="design-1 widget-calendar-XL-11-1-widget calendar-XL">
                  <table id="calendar11-1">
                    <thead>
                      <tr>
                        <td
                          style="font-weight: 500; text-align: center;width:100%;"
                          colspan="7"
                        ></td>
                        <td>
                          <tr style="font-weight: 500">
                            <td>пн</td>
                            <td>вт</td>
                            <td>ср</td>
                            <td>чт</td>
                            <td>пт</td>
                            <td>сб</td>
                            <td>вс</td>
                          </tr>
                        </td>
                      </tr>
                    </thead>
                    <tbody id="body-calendar-11-1"></tbody>
                  </table>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-3: 377px;
                      --size-4: 508px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    #calendar11-1 {
                      text-align: center;
                      font-size: 26px;
                      color: var(--text-color);
                      font-weight: 300;
                      border-spacing: 15px 5px;
                      margin: auto;
                      display: flex;
                      flex-direction: column;
                      justify-content: space-around;
                    }
                    .widget-calendar-XL-11-1-widget {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      font-family: Rubik;
                      width: var(--size-4);
                      height: var(--size-3);
                    }
                    #today-11-1 {
                      color: var(--background-widgets);
                      background-color: var(--text-color);
                      border-radius: 16px;
                    }
                    #body-calendar-11-1 tr td {
                      width: 46px;
                      height: 46px;
                      text-align: center;
                    }
                    thead tr:nth-child(1) {
                      display: flex;
                      justify-content: center;
                    }
                    thead tr:nth-child(2) {
                      display: flex;
                      justify-content: space-evenly;
                      align-items: flex-end;
                      height: 50px;
                    }
                    thead tr td {
                      width: 46px;
                    }
                  </style>

                  <script>
                    const getCalendar_11_1 = () => {
                      var D1 = new Date(),
                        D1last = new Date(
                          D1.getFullYear(),
                          D1.getMonth() + 1,
                          0
                        ).getDate(), // последний день месяца
                        D1Nlast = new Date(
                          D1.getFullYear(),
                          D1.getMonth(),
                          D1last
                        ).getDay(), // день недели последнего дня месяца
                        D1Nfirst = new Date(
                          D1.getFullYear(),
                          D1.getMonth(),
                          1
                        ).getDay(), // день недели первого дня месяца
                        calendar1 = "<tr>",
                        month = [
                          "Январь",
                          "Февраль",
                          "Март",
                          "Апрель",
                          "Май",
                          "Июнь",
                          "Июль",
                          "Август",
                          "Сентябрь",
                          "Октябрь",
                          "Ноябрь",
                          "Декабрь",
                        ]; // название месяца, вместо цифр 0-11

                      // пустые клетки до первого дня текущего месяца
                      if (D1Nfirst != 0) {
                        for (var i = 1; i < D1Nfirst; i++) calendar1 += "<td>";
                      } else {
                        // если первый день месяца выпадает на воскресенье, то требуется 7 пустых клеток
                        for (var i = 0; i < 6; i++) calendar1 += "<td>";
                      }

                      // дни месяца
                      for (var i = 1; i <= D1last; i++) {
                        if (i != D1.getDate()) {
                          calendar1 += "<td>" + i;
                        } else {
                          calendar1 += '<td id="today-11-1">' + i; // сегодняшней дате можно задать стиль CSS
                        }
                        if (
                          new Date(
                            D1.getFullYear(),
                            D1.getMonth(),
                            i
                          ).getDay() == 0
                        ) {
                          // если день выпадает на воскресенье, то перевод строки
                          calendar1 += "<tr>";
                        }
                      }

                      // пустые клетки после последнего дня месяца
                      if (D1Nlast != 0) {
                        for (var i = D1Nlast; i < 7; i++) calendar1 += "<td>";
                      }

                      document.querySelector("#calendar11-1 tbody").innerHTML =
                        calendar1;
                      // document.querySelector('#calendar11-1 thead td:last-child').innerHTML = D1.getFullYear();
                      document.querySelector(
                        "#calendar11-1 thead td:first-child"
                      ).innerHTML = month[D1.getMonth()];
                    };
                    getCalendar_11_1();
                  </script>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-3-2"
                onclick="alert(getCode('btn-3-2'))"
              >
                <div class="design-1 widget-date-L-11-2-widget dates-XL">
                  <p id="previous-day-11-2-2"></p>
                  <p id="previous-day-11-2-1"></p>
                  <p id="current-day-11-2"></p>
                  <p id="next-day-11-2-1"></p>
                  <p id="next-day-11-2-2"></p>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-2: 246px;
                      --size-4: 508px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-date-L-11-2-widget {
                      display: flex;
                      justify-content: space-evenly;
                      flex-direction: column;
                      align-items: center;
                      width: var(--size-4);
                      height: var(--size-2);
                    }
                    .widget-date-L-11-2-widget p {
                      font-family: rubik;
                      color: rgba(64, 64, 64, 1);
                      font-size: 22px;
                    }
                    .widget-date-L-11-2-widget p:nth-child(3) {
                      font-family: rubik;
                      color: var(--text-color);
                      font-size: 32px;
                    }
                  </style>
                  <script>
                    const currentDate_11_2 = () => {
                      let date = new Date();
                      let days = [
                        "Воскресенье",
                        "Понедельник",
                        "Вторник",
                        "Среда",
                        "Четверг",
                        "Пятница",
                        "Суббота",
                      ];
                      let month = [
                        "января",
                        "февраля",
                        "марта",
                        "апреля",
                        "мая",
                        "июня",
                        "июля",
                        "августа",
                        "сентября",
                        "октября",
                        "ноября",
                        "декабря",
                      ];

                      return \`\${days[date.getDay()]}, \${date.getDate()} \${
                        month[date.getMonth()]
                      }\`;
                    };

                    const previous_day_11_2_1 = () => {
                      let date = new Date();
                      let days = [
                        "Воскресенье",
                        "Понедельник",
                        "Вторник",
                        "Среда",
                        "Четверг",
                        "Пятница",
                        "Суббота",
                      ];
                      let month = [
                        "января",
                        "февраля",
                        "марта",
                        "апреля",
                        "мая",
                        "июня",
                        "июля",
                        "августа",
                        "сентября",
                        "октября",
                        "ноября",
                        "декабря",
                      ];
                      let day = date.setDate(date.getDate() - 1);
                      return \`\${days[date.getDay()]}, \${date.getDate()} \${
                        month[date.getMonth()]
                      }\`;
                    };
                    const previous_day_11_2_2 = () => {
                      let date = new Date();
                      let days = [
                        "Воскресенье",
                        "Понедельник",
                        "Вторник",
                        "Среда",
                        "Четверг",
                        "Пятница",
                        "Суббота",
                      ];
                      let month = [
                        "января",
                        "февраля",
                        "марта",
                        "апреля",
                        "мая",
                        "июня",
                        "июля",
                        "августа",
                        "сентября",
                        "октября",
                        "ноября",
                        "декабря",
                      ];
                      let day = date.setDate(date.getDate() - 2);
                      return \`\${days[date.getDay()]}, \${date.getDate()} \${
                        month[date.getMonth()]
                      }\`;
                    };
                    const next_day_11_2_1 = () => {
                      let date = new Date();
                      let days = [
                        "Воскресенье",
                        "Понедельник",
                        "Вторник",
                        "Среда",
                        "Четверг",
                        "Пятница",
                        "Суббота",
                      ];
                      let month = [
                        "января",
                        "февраля",
                        "марта",
                        "апреля",
                        "мая",
                        "июня",
                        "июля",
                        "августа",
                        "сентября",
                        "октября",
                        "ноября",
                        "декабря",
                      ];
                      let day = date.setDate(date.getDate() + 1);
                      return \`\${days[date.getDay()]}, \${date.getDate()} \${
                        month[date.getMonth()]
                      }\`;
                    };
                    const next_day_11_2_2 = () => {
                      let date = new Date();
                      let days = [
                        "Воскресенье",
                        "Понедельник",
                        "Вторник",
                        "Среда",
                        "Четверг",
                        "Пятница",
                        "Суббота",
                      ];
                      let month = [
                        "января",
                        "февраля",
                        "марта",
                        "апреля",
                        "мая",
                        "июня",
                        "июля",
                        "августа",
                        "сентября",
                        "октября",
                        "ноября",
                        "декабря",
                      ];
                      let day = date.setDate(date.getDate() + 2);
                      return \`\${days[date.getDay()]}, \${date.getDate()} \${
                        month[date.getMonth()]
                      }\`;
                    };

                    setInterval(() => {
                      document.getElementById("current-day-11-2").innerHTML =
                        currentDate_11_2();
                      document.getElementById("previous-day-11-2-1").innerHTML =
                        previous_day_11_2_1();
                      document.getElementById("previous-day-11-2-2").innerHTML =
                        previous_day_11_2_2();
                      document.getElementById("next-day-11-2-1").innerHTML =
                        next_day_11_2_1();
                      document.getElementById("next-day-11-2-2").innerHTML =
                        next_day_11_2_2();
                    }, 100);
                  </script>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-3-3"
                onclick="alert(getCode('btn-3-3'))"
              >
                <div class="design-1 widget-date-M-11-3-widget dates-L">
                  <p id="current-day-11-3"></p>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-1: 115px;
                      --size-4: 508px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-date-M-11-3-widget {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: var(--size-4);
                      height: var(--size-1);
                    }
                    .widget-date-M-11-3-widget p {
                      font-family: rubik;
                      font-size: 32px;
                      color: var(--text-color);
                    }
                  </style>
                  <script>
                    const currentDate_11_3 = () => {
                      let date = new Date();
                      let days = [
                        "Воскресенье",
                        "Понедельник",
                        "Вторник",
                        "Среда",
                        "Четверг",
                        "Пятница",
                        "Суббота",
                      ];
                      let month = [
                        "января",
                        "февраля",
                        "марта",
                        "апреля",
                        "мая",
                        "июня",
                        "июля",
                        "августа",
                        "сентября",
                        "октября",
                        "ноября",
                        "декабря",
                      ];

                      return \`\${days[date.getDay()]}, \${date.getDate()} \${
                        month[date.getMonth()]
                      }\`;
                    };
                    setInterval(() => {
                      document.getElementById("current-day-11-3").innerHTML =
                        currentDate_11_3();
                    }, 100);
                  </script>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-3-4"
                onclick="alert(getCode('btn-3-4'))"
              >
                <div class="design-1 widget-date-11-4-widget dates-M">
                  <p id="previous-day-11-4-2"></p>
                  <p id="previous-day-11-4-1"></p>
                  <p id="current-day-11-4"></p>
                  <p id="next-day-11-4-1"></p>
                  <p id="next-day-11-4-2"></p>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-2: 246px;
                      --size-3: 377px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-date-11-4-widget {
                      display: flex;
                      justify-content: space-evenly;
                      flex-direction: column;
                      align-items: center;
                      width: var(--size-3);
                      height: var(--size-2);
                    }
                    .widget-date-11-4-widget p {
                      font-family: rubik;
                      color: rgba(64, 64, 64, 1);
                      font-size: 22px;
                    }
                    .widget-date-11-4-widget p:nth-child(3) {
                      font-family: rubik;
                      color: var(--text-color);
                      font-size: 32px;
                    }
                  </style>
                  <script>
                    const currentDate_11_4 = () => {
                      let date = new Date();
                      let days = [
                        "Воскресенье",
                        "Понедельник",
                        "Вторник",
                        "Среда",
                        "Четверг",
                        "Пятница",
                        "Суббота",
                      ];
                      let month = [
                        "января",
                        "февраля",
                        "марта",
                        "апреля",
                        "мая",
                        "июня",
                        "июля",
                        "августа",
                        "сентября",
                        "октября",
                        "ноября",
                        "декабря",
                      ];

                      return \`\${days[date.getDay()]}, \${date.getDate()} \${
                        month[date.getMonth()]
                      }\`;
                    };

                    const previous_day_11_4_1 = () => {
                      let date = new Date();
                      let days = [
                        "Воскресенье",
                        "Понедельник",
                        "Вторник",
                        "Среда",
                        "Четверг",
                        "Пятница",
                        "Суббота",
                      ];
                      let month = [
                        "января",
                        "февраля",
                        "марта",
                        "апреля",
                        "мая",
                        "июня",
                        "июля",
                        "августа",
                        "сентября",
                        "октября",
                        "ноября",
                        "декабря",
                      ];
                      let day = date.setDate(date.getDate() - 1);
                      return \`\${days[date.getDay()]}, \${date.getDate()} \${
                        month[date.getMonth()]
                      }\`;
                    };
                    const previous_day_11_4_2 = () => {
                      let date = new Date();
                      let days = [
                        "Воскресенье",
                        "Понедельник",
                        "Вторник",
                        "Среда",
                        "Четверг",
                        "Пятница",
                        "Суббота",
                      ];
                      let month = [
                        "января",
                        "февраля",
                        "марта",
                        "апреля",
                        "мая",
                        "июня",
                        "июля",
                        "августа",
                        "сентября",
                        "октября",
                        "ноября",
                        "декабря",
                      ];
                      let day = date.setDate(date.getDate() - 2);
                      return \`\${days[date.getDay()]}, \${date.getDate()} \${
                        month[date.getMonth()]
                      }\`;
                    };
                    const next_day_11_4_1 = () => {
                      let date = new Date();
                      let days = [
                        "Воскресенье",
                        "Понедельник",
                        "Вторник",
                        "Среда",
                        "Четверг",
                        "Пятница",
                        "Суббота",
                      ];
                      let month = [
                        "января",
                        "февраля",
                        "марта",
                        "апреля",
                        "мая",
                        "июня",
                        "июля",
                        "августа",
                        "сентября",
                        "октября",
                        "ноября",
                        "декабря",
                      ];
                      let day = date.setDate(date.getDate() + 1);
                      return \`\${days[date.getDay()]}, \${date.getDate()} \${
                        month[date.getMonth()]
                      }\`;
                    };
                    const next_day_11_4_2 = () => {
                      let date = new Date();
                      let days = [
                        "Воскресенье",
                        "Понедельник",
                        "Вторник",
                        "Среда",
                        "Четверг",
                        "Пятница",
                        "Суббота",
                      ];
                      let month = [
                        "января",
                        "февраля",
                        "марта",
                        "апреля",
                        "мая",
                        "июня",
                        "июля",
                        "августа",
                        "сентября",
                        "октября",
                        "ноября",
                        "декабря",
                      ];
                      let day = date.setDate(date.getDate() + 2);
                      return \`\${days[date.getDay()]}, \${date.getDate()} \${
                        month[date.getMonth()]
                      }\`;
                    };

                    setInterval(() => {
                      document.getElementById("current-day-11-4").innerHTML =
                        currentDate_11_4();
                      document.getElementById("previous-day-11-4-1").innerHTML =
                        previous_day_11_4_1();
                      document.getElementById("previous-day-11-4-2").innerHTML =
                        previous_day_11_4_2();
                      document.getElementById("next-day-11-4-1").innerHTML =
                        next_day_11_4_1();
                      document.getElementById("next-day-11-4-2").innerHTML =
                        next_day_11_4_2();
                    }, 100);
                  </script>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-3-5"
                onclick="alert(getCode('btn-3-5'))"
              >
                <div class="design-1 widget-date-11-5-widget dates-S">
                  <p id="current-day-11-5"></p>
                  <p id="current-month-11-5"></p>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-2: 246px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-date-11-5-widget {
                      display: flex;
                      justify-content: center;
                      flex-direction: column;
                      align-items: center;
                      width: var(--size-2);
                      height: var(--size-2);
                    }
                    .widget-date-11-5-widget p {
                      font-family: rubik;
                      color: var(--text-color);
                      font-size: 140px;
                      font-weight: 300;
                    }
                    .widget-date-11-5-widget p:nth-child(1) {
                      line-height: 120px;
                    }
                    .widget-date-11-5-widget p:nth-child(2) {
                      font-family: rubik;
                      font-size: 32px;
                      font-weight: 400;
                    }
                  </style>
                  <script>
                    const currentDay_11_5 = () => {
                      let date = new Date();
                      return \`\${date.getDate()}\`;
                    };
                    const currentMonth_11_5 = () => {
                      let date = new Date();
                      let month = [
                        "января",
                        "февраля",
                        "марта",
                        "апреля",
                        "мая",
                        "июня",
                        "июля",
                        "августа",
                        "сентября",
                        "октября",
                        "ноября",
                        "декабря",
                      ];
                      return \`\${month[date.getMonth()]}\`;
                    };
                    setInterval(() => {
                      document.getElementById("current-day-11-5").innerHTML =
                        currentDay_11_5();
                    }, 100);
                    setInterval(() => {
                      document.getElementById("current-month-11-5").innerHTML =
                        currentMonth_11_5();
                    }, 100);
                  </script>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-3-6"
                onclick="alert(getCode('btn-3-6'))"
              >
                <div class="design-1 widget-date-S-11-6-widget dates-XS">
                  <p id="current-date-11-6"></p>
                  <p id="current-day-11-6"></p>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-1: 115px;
                      --size-2: 246px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-date-S-11-6-widget {
                      display: flex;
                      flex-direction: column;
                      justify-content: center;
                      align-items: center;
                      width: var(--size-2);
                      height: var(--size-1);
                    }

                    .widget-date-S-11-6-widget p {
                      color: var(--text-color);
                      font-family: Rubik;
                      font-size: 26px;
                      font-weight: 500;
                    }
                    .widget-date-S-11-6-widget p:nth-child(2) {
                      color: rgba(115, 115, 115, 1);
                      font-size: 26px;
                    }
                  </style>
                  <script>
                    const currentDate_11_6 = () => {
                      let date = new Date();
                      let month = [
                        "января",
                        "февраля",
                        "марта",
                        "апреля",
                        "мая",
                        "июня",
                        "июля",
                        "августа",
                        "сентября",
                        "октября",
                        "ноября",
                        "декабря",
                      ];

                      return \`\${date.getDate()} \${month[date.getMonth()]}\`;
                    };

                    const currentDay_11_6 = () => {
                      let date = new Date();
                      let days = [
                        "Воскресенье",
                        "Понедельник",
                        "Вторник",
                        "Среда",
                        "Четверг",
                        "Пятница",
                        "Суббота",
                      ];
                      return \`\${days[date.getDay()]}\`;
                    };

                    setInterval(() => {
                      document.getElementById("current-date-11-6").innerHTML =
                        currentDate_11_6();
                      document.getElementById("current-day-11-6").innerHTML =
                        currentDay_11_6();
                    }, 100);
                  </script>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-3-7"
                onclick="alert(getCode('btn-3-7'))"
              >
                <div class="design-1 widget-date-S-11-7-widget dates-XS">
                  <p id="current-day-11-7"></p>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-1: 115px;
                      --size-2: 246px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-date-S-11-7-widget {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: var(--size-2);
                      height: var(--size-1);
                    }
                    .widget-date-S-11-7-widget p {
                      color: var(--text-color);
                      font-family: rubik;
                      font-size: 32px;
                    }
                  </style>
                  <script>
                    const currentDay_11_7 = () => {
                      let date = new Date();
                      let days = [
                        "Воскресенье",
                        "Понедельник",
                        "Вторник",
                        "Среда",
                        "Четверг",
                        "Пятница",
                        "Суббота",
                      ];
                      return \`\${days[date.getDay()]}\`;
                    };

                    setInterval(() => {
                      document.getElementById("current-day-11-7").innerHTML =
                        currentDay_11_7();
                    }, 100);
                  </script>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-3-8"
                onclick="alert(getCode('btn-3-8'))"
              >
                <div class="design-1 widget-date-S-11-8-widget dates-XS">
                  <p id="current-date-11-8"></p>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-1: 115px;
                      --size-2: 246px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-date-S-11-8-widget {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: var(--size-2);
                      height: var(--size-1);
                    }
                    .widget-date-S-11-8-widget p {
                      color: var(--text-color);
                      font-family: rubik;
                      font-size: 32px;
                    }
                  </style>
                  <script>
                    const currentDate_11_8 = () => {
                      let date = new Date();
                      let month = [
                        "января",
                        "февраля",
                        "марта",
                        "апреля",
                        "мая",
                        "июня",
                        "июля",
                        "августа",
                        "сентября",
                        "октября",
                        "ноября",
                        "декабря",
                      ];

                      return \`\${date.getDate()} \${month[date.getMonth()]}\`;
                    };
                    setInterval(() => {
                      document.getElementById("current-date-11-8").innerHTML =
                        currentDate_11_8();
                    }, 100);
                  </script>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="dropright-1">
        <button class="drop-1">
          Погода <br />
          11 вариант
        </button>
        <div class="drop-content-1">
          <div class="navbar-2">
            <div class="dropdown-2">
              <button
                class="drop-2"
                id="btn-4-1"
                onclick="alert(getCode('btn-4-1'))"
              >
                <div class="design-1 widget-weather-XL-11-1-widget weather-XL">
                  <div class="current-weather-11-1">
                    <div>
                      <p id="current-weather-11-1"></p>
                      <p id="status-weather-11-1"></p>
                    </div>
                    <img id="current-status-img-11-1" src="" alt="" />
                  </div>
                  <div class="weather-per-day-11-1">
                    <div>
                      <img id="status-img-11-1-1" src="" alt="" />
                      <p>Утро</p>
                    </div>
                    <div>
                      <img id="status-img-11-1-2" src="" alt="" />
                      <p>День</p>
                    </div>
                    <div>
                      <img id="status-img-11-1-3" src="" alt="" />
                      <p>Вечер</p>
                    </div>
                    <div>
                      <img id="status-img-11-1-4" src="" alt="" />
                      <p>Ночь</p>
                    </div>
                  </div>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-2: 246px;
                      --size-4: 508px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                      --color-icon: "";
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-weather-XL-11-1-widget {
                      display: flex;
                      flex-direction: column;
                      justify-content: space-around;
                      width: var(--size-4);
                      height: var(--size-2);
                    }

                    .current-weather-11-1 {
                      display: flex;
                      justify-content: space-around;
                      align-items: center;
                    }
                    .current-weather-11-1 p {
                      color: var(--text-color);
                      font-family: rubik;
                      font-size: 70px;
                      font-weight: 300;
                      text-align: start;
                    }
                    .current-weather-11-1 p:nth-child(2) {
                      font-size: 26px;
                      font-weight: 300;
                      color: rgba(115, 115, 115, 1);
                    }
                    .current-weather-11-1 img {
                      width: 80px;
                      height: 80px;
                      filter: var(--color-icon);
                    }
                    .weather-per-day-11-1 {
                      display: flex;
                      justify-content: space-evenly;
                      align-items: center;
                    }
                    .weather-per-day-11-1 p {
                      font-family: rubik;
                      font-size: 26px;
                      font-weight: 300;
                      color: rgba(115, 115, 115, 1);
                    }
                    .weather-per-day-11-1 div {
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                    }
                    .weather-per-day-11-1 img {
                      width: 46px;
                      height: 46px;
                    }
                  </style>
                  <script>
                    const get_weather_11_1 = () => {
                      fetch("http://212.41.9.251:8000/get_weather", {
                        method: "GET",
                        headers: {
                          accept: "application/json",
                        },
                      })
                        .then((response) => response.json())
                        .then((result) => {
                          document.getElementById(
                            "current-weather-11-1"
                          ).innerHTML = result[0][0];
                          document.getElementById(
                            "status-weather-11-1"
                          ).innerHTML = result[0][1];

                          const weather = {
                            Ясно: "http://212.41.9.251:8000/static/weather_clear.svg",
                            Облачно:
                              "http://212.41.9.251:8000/static/weather_cloudy.svg",
                            "Переменная облачность":
                              "http://212.41.9.251:8000/static/weather_p_cloudy.svg",
                            "Местами дождь":
                              "http://212.41.9.251:8000/static/weather_rain.svg",
                            "Местами грозы": "",
                            "Местами легкий дождь с грозой":
                              "http://212.41.9.251:8000/static/weather_rain.svg",
                            "Моросящий дождь":
                              "http://212.41.9.251:8000/static/weather_rain.svg",
                          };

                          for (key in weather) {
                            if (key == result[0][1]) {
                              document
                                .getElementById("current-status-img-11-1")
                                .setAttribute("src", weather[key]);
                            }
                            if (key == result[1][0][1]) {
                              document
                                .getElementById("status-img-11-1-1")
                                .setAttribute("src", weather[key]);
                            }
                            if (key == result[1][1][1]) {
                              document
                                .getElementById("status-img-11-1-2")
                                .setAttribute("src", weather[key]);
                            }
                            if (key == result[1][2][1]) {
                              document
                                .getElementById("status-img-11-1-3")
                                .setAttribute("src", weather[key]);
                            }
                            if (key == result[1][3][1]) {
                              document
                                .getElementById("status-img-11-1-4")
                                .setAttribute("src", weather[key]);
                            }
                          }
                        });
                    };
                    setTimeout(() => {
                      setInterval(() => {
                        get_weather_11_1;
                      }, 300000);
                      get_weather_11_1();
                    }, 1000);
                  </script>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-4-2"
                onclick="alert(getCode('btn-4-2'))"
              >
                <div class="design-1 widget-weather-L-11-2-widget weather-L">
                  <p id="current-weather-11-2"></p>
                  <img id="current-status-img-11-2" src="" alt="" />
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-1: 115px;
                      --size-3: 377px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                      --color-icon: "";
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-weather-L-11-2-widget {
                      display: flex;
                      align-items: center;
                      justify-content: space-around;
                      width: var(--size-3);
                      height: var(--size-1);
                    }
                    .widget-weather-L-11-2-widget p {
                      font-family: rubik;
                      color: var(--text-color);
                      font-size: 70px;
                      font-weight: 300;
                    }
                    .widget-weather-L-11-2-widget img {
                      width: 80px;
                      height: 80px;
                      filter: var(--color-icon);
                    }
                  </style>
                  <script>
                    const get_weather_11_2 = () => {
                      fetch("http://212.41.9.251:8000/get_weather", {
                        method: "GET",
                        headers: {
                          accept: "application/json",
                        },
                      })
                        .then((response) => response.json())
                        .then((result) => {
                          document.getElementById(
                            "current-weather-11-2"
                          ).innerHTML = result[0][0];

                          const weather = {
                            Ясно: "http://212.41.9.251:8000/static/weather_clear.svg",
                            Облачно:
                              "http://212.41.9.251:8000/static/weather_cloudy.svg",
                            "Переменная облачность":
                              "http://212.41.9.251:8000/static/weather_p_cloudy.svg",
                            "Местами дождь":
                              "http://212.41.9.251:8000/static/weather_rain.svg",
                            "Местами грозы": "",
                            "Местами легкий дождь с грозой":
                              "http://212.41.9.251:8000/static/weather_rain.svg",
                            "Моросящий дождь":
                              "http://212.41.9.251:8000/static/weather_rain.svg",
                          };

                          for (key in weather) {
                            if (key == result[0][1]) {
                              document
                                .getElementById("current-status-img-11-2")
                                .setAttribute("src", weather[key]);
                            }
                          }
                        });
                    };
                    setTimeout(() => {
                      setInterval(() => {
                        get_weather_11_2;
                      }, 300000);
                      get_weather_11_2();
                    }, 5000);
                  </script>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-4-3"
                onclick="alert(getCode('btn-4-3'))"
              >
                <div class="design-1 widget-weather-M-11-3-widget weather-M">
                  <div>
                    <img id="current-status-img-11-3" src="" alt="" />
                    <p id="current-status-weather-11-3"></p>
                    <p id="current-weather-11-3"></p>
                  </div>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-2: 246px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                      --color-icon: "";
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-weather-M-11-3-widget {
                      display: flex;
                      width: var(--size-2);
                      height: var(--size-2);
                    }
                    .widget-weather-M-11-3-widget div {
                      display: flex;
                      flex-direction: column;
                      justify-content: space-evenly;
                      padding: 25px;
                    }
                    .widget-weather-M-11-3-widget p {
                      font-family: rubik;
                      font-weight: 300;
                    }
                    .widget-weather-M-11-3-widget p:nth-child(2) {
                      color: rgba(115, 115, 115, 1);
                      font-size: 26px;
                      text-align: start;
                    }
                    .widget-weather-M-11-3-widget p:nth-child(3) {
                      color: var(--text-color);
                      font-size: 70px;
                    }
                    .widget-weather-M-11-3-widget img {
                      width: 70px;
                      height: 70px;
                      filter: var(--color-icon);
                    }
                    .current-status-weather-11-3 {
                      text-align: start;
                    }
                  </style>
                  <script>
                    const currentWeather_11_3 = () => {
                      fetch("http://212.41.9.251:8000/get_weather", {
                        method: "GET",
                        headers: {
                          accept: "application/json",
                        },
                      })
                        .then((response) => response.json())
                        .then((result) => {
                          document.getElementById(
                            "current-weather-11-3"
                          ).innerHTML = result[0][0];
                          document.getElementById(
                            "current-status-weather-11-3"
                          ).innerHTML = result[0][1];

                          const weather = {
                            Ясно: "http://212.41.9.251:8000/static/weather_clear.svg",
                            Облачно:
                              "http://212.41.9.251:8000/static/weather_cloudy.svg",
                            "Переменная облачность":
                              "http://212.41.9.251:8000/static/weather_p_cloudy.svg",
                            "Местами дождь":
                              "http://212.41.9.251:8000/static/weather_rain.svg",
                            "Местами грозы": "",
                            "Местами легкий дождь с грозой":
                              "http://212.41.9.251:8000/static/weather_rain.svg",
                            "Моросящий дождь":
                              "http://212.41.9.251:8000/static/weather_rain.svg",
                          };

                          for (key in weather) {
                            if (key == result[0][1]) {
                              document
                                .getElementById("current-status-img-11-3")
                                .setAttribute("src", weather[key]);
                            }
                          }
                        });
                    };
                    setTimeout(() => {
                      setInterval(() => {
                        currentWeather_11_3;
                      }, 300000);
                      currentWeather_11_3();
                    }, 5000);
                  </script>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-4-4"
                onclick="alert(getCode('btn-4-4'))"
              >
                <div class="design-1 widget-weather-S-11-4-widget weather-S">
                  <p id="current-weather-11-4"></p>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-1: 115px;
                      --size-2: 246px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-weather-S-11-4-widget {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: var(--size-2);
                      height: var(--size-1);
                    }
                    .widget-weather-S-11-4-widget p {
                      font-family: rubik;
                      color: var(--text-color);
                      font-size: 70px;
                      font-weight: 300;
                    }
                  </style>
                  <script>
                    const currentWeather_11_4 = () => {
                      fetch("http://212.41.9.251:8000/get_weather", {
                        method: "GET",
                        headers: {
                          accept: "application/json",
                        },
                      })
                        .then((response) => response.json())
                        .then((result) => {
                          document.getElementById(
                            "current-weather-11-4"
                          ).innerHTML = result[0][0];
                        });
                    };
                    setTimeout(() => {
                      setInterval(() => {
                        currentWeather_11_4;
                      }, 300000);
                      currentWeather_11_4();
                    }, 5000);
                  </script>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="dropright-1">
        <button class="drop-1">
          Пробки <br />
          11 вариант
        </button>
        <div class="drop-content-1">
          <div class="navbar-2">
            <div class="dropdown-2">
              <button
                class="drop-2"
                id="btn-5-1"
                onclick="alert(getCode('btn-5-1'))"
              >
                <div class="design-1 widget-traffic-L-11-1-widget traffic-L">
                  <p>Пробки</p>
                  <div class="space-div-5-1"></div>
                  <p id="current-traffic-11-1"></p>
                  <div class="space-div-5-1"></div>
                  <p>баллов</p>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-1: 115px;
                      --size-3: 377px;
                      --style: "";
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-traffic-L-11-1-widget {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: var(--size-3);
                      height: var(--size-1);
                    }
                    .widget-traffic-L-11-1-widget p {
                      font-family: rubik;
                      color: var(--text-color);
                      font-size: 32px;
                    }
                    .widget-traffic-L-11-1-widget p:nth-child(3) {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: 54px;
                      height: 54px;
                      border: var(--style);
                      border-radius: 50%;
                    }
                    .space-div-5-1 {
                      width: 16px;
                    }
                  </style>
                  <script>
                    const getTraffic_11_1 = () => {
                      min = Math.ceil(1);
                      max = Math.floor(8);
                      return Math.floor(Math.random() * (max - min) + min);
                    };
                    const updateBackgroud = () => {
                      let value = document.getElementById(
                        "current-traffic-11-1"
                      ).innerHTML;
                      if (value == "10") {
                        var style = \`6px solid rgba(250, 46, 35, 1)\`;
                      } else if (value == "9") {
                        var style = \`6px solid rgba(249, 80, 32, 1)\`;
                      } else if (value == "8") {
                        var style = \`6px solid rgba(248, 111, 28, 1)\`;
                      } else if (value == "7") {
                        var style = \`6px solid rgba(247, 138, 25, 1)\`;
                      } else if (value == "6") {
                        var style = \`6px solid rgba(247, 165, 22, 1)\`;
                      } else if (value == "5") {
                        var style = \`6px solid rgba(245, 191, 19, 1)\`;
                      } else if (value == "4") {
                        var style = \`6px solid rgba(239, 222, 21, 1)\`;
                      } else if (value == "3") {
                        var style = \`6px solid rgba(210, 250, 11, 1)\`;
                      } else if (value == "2") {
                        var style = \`6px solid rgba(164, 243, 18, 1)\`;
                      } else if (value == "1") {
                        var style = \`6px solid rgba(144, 243, 13, 1)\`;
                      } else {
                        var style = \`6px solid rgba(77, 243, 12, 1)\`;
                      }
                      document.documentElement.style.setProperty(
                        \`--style\`,
                        \`\${style}\`
                      );
                    };
                    document.getElementById("current-traffic-11-1").innerHTML =
                      getTraffic_11_1();
                    updateBackgroud();
                    setInterval(() => {
                      document.getElementById(
                        "current-traffic-11-1"
                      ).innerHTML = getTraffic_11_1();

                      updateBackgroud();
                    }, 1800000);
                  </script>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-5-2"
                onclick="alert(getCode('btn-5-2'))"
              >
                <div class="design-1 widget-traffic-M-11-2-widget traffic-M">
                  <p>Пробки</p>
                  <div class="space-div-5-2"></div>
                  <p id="current-traffic-11-2"></p>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-1: 115px;
                      --size-2: 246px;
                      --style2: "";
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-traffic-M-11-2-widget {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: var(--size-2);
                      height: var(--size-1);
                    }
                    .widget-traffic-M-11-2-widget p {
                      font-family: rubik;
                      color: var(--text-color);
                      font-size: 32px;
                    }
                    .widget-traffic-M-11-2-widget p:nth-child(3) {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: 54px;
                      height: 54px;
                      border: var(--style2);
                      border-radius: 50%;
                    }
                    .space-div-5-2 {
                      width: 6px;
                    }
                  </style>
                  <script>
                    const getTraffic_11_2 = () => {
                      min = Math.ceil(1);
                      max = Math.floor(8);
                      return Math.floor(Math.random() * (max - min) + min);
                    };
                    const updateBackgroud2 = () => {
                      let value = document.getElementById(
                        "current-traffic-11-2"
                      ).innerHTML;
                      if (value == "10") {
                        var style = \`6px solid rgba(250, 46, 35, 1)\`;
                      } else if (value == "9") {
                        var style = \`6px solid rgba(249, 80, 32, 1)\`;
                      } else if (value == "8") {
                        var style = \`6px solid rgba(248, 111, 28, 1)\`;
                      } else if (value == "7") {
                        var style = \`6px solid rgba(247, 138, 25, 1)\`;
                      } else if (value == "6") {
                        var style = \`6px solid rgba(247, 165, 22, 1)\`;
                      } else if (value == "5") {
                        var style = \`6px solid rgba(245, 191, 19, 1)\`;
                      } else if (value == "4") {
                        var style = \`6px solid rgba(239, 222, 21, 1)\`;
                      } else if (value == "3") {
                        var style = \`6px solid rgba(210, 250, 11, 1)\`;
                      } else if (value == "2") {
                        var style = \`6px solid rgba(164, 243, 18, 1)\`;
                      } else if (value == "1") {
                        var style = \`6px solid rgba(144, 243, 13, 1)\`;
                      } else {
                        var style = \`6px solid rgba(77, 243, 12, 1)\`;
                      }
                      document.documentElement.style.setProperty(
                        \`--style2\`,
                        \`\${style}\`
                      );
                    };
                    document.getElementById("current-traffic-11-2").innerHTML =
                      getTraffic_11_2();
                    updateBackgroud2();
                    setInterval(() => {
                      document.getElementById(
                        "current-traffic-11-2"
                      ).innerHTML = getTraffic_11_2();

                      updateBackgroud2();
                    }, 1800000);
                  </script>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-5-3"
                rates-S
                onclick="alert(getCode('btn-5-3'))"
              >
                <div class="design-1 widget-traffic-S-11-3-widget traffic-XS">
                  <p id="current-traffic-11-3"></p>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-1: 115px;
                      --style3: "";
                      --background-widgets: rgba(30, 30, 30, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-traffic-S-11-3-widget {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: var(--size-1);
                      height: var(--size-1);
                    }
                    .widget-traffic-S-11-3-widget p {
                      font-family: rubik;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: 90px;
                      height: 90px;
                      background-color: var(--style3);
                      border-radius: 50%;
                      font-size: 70px;
                      color: var(--background-widgets);
                    }
                  </style>
                  <script>
                    const getTraffic_11_3 = () => {
                      min = Math.ceil(1);
                      max = Math.floor(8);
                      return Math.floor(Math.random() * (max - min) + min);
                    };
                    const updateBackgroud3 = () => {
                      let value = document.getElementById(
                        "current-traffic-11-3"
                      ).innerHTML;
                      if (value == "10") {
                        var style = \`rgba(250, 46, 35, 1)\`;
                      } else if (value == "9") {
                        var style = \`rgba(249, 80, 32, 1)\`;
                      } else if (value == "8") {
                        var style = \`rgba(248, 111, 28, 1)\`;
                      } else if (value == "7") {
                        var style = \`rgba(247, 138, 25, 1)\`;
                      } else if (value == "6") {
                        var style = \`rgba(247, 165, 22, 1)\`;
                      } else if (value == "5") {
                        var style = \`rgba(245, 191, 19, 1)\`;
                      } else if (value == "4") {
                        var style = \`rgba(239, 222, 21, 1)\`;
                      } else if (value == "3") {
                        var style = \`rgba(210, 250, 11, 1)\`;
                      } else if (value == "2") {
                        var style = \`rgba(164, 243, 18, 1)\`;
                      } else if (value == "1") {
                        var style = \`rgba(144, 243, 13, 1)\`;
                      } else {
                        var style = \`rgba(77, 243, 12, 1)\`;
                      }
                      document.documentElement.style.setProperty(
                        \`--style3\`,
                        \`\${style}\`
                      );
                    };
                    document.getElementById("current-traffic-11-3").innerHTML =
                      getTraffic_11_3();
                    updateBackgroud3();
                    setInterval(() => {
                      document.getElementById(
                        "current-traffic-11-3"
                      ).innerHTML = getTraffic_11_3();

                      updateBackgroud3();
                    }, 1800000);
                  </script>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="dropright-1">
        <!-- API 06a8513530ea408b92b64a840914c5c8 -->
        <button class="drop-1">
          Новости <br />
          11 вариант
        </button>
        <div class="drop-content-1">
          <div class="navbar-2">
            <div class="dropdown-2">
              <button
                class="drop-2"
                id="btn-6-1"
                onclick="alert(getCode('btn-6-1'))"
              >
                <div class="design-1 widget-news-11-1-widget news-L">
                  <p id="header-news-11-1">------</p>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-2: 246px;
                      --size-4: 508px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-news-11-1-widget {
                      width: var(--size-4);
                      height: var(--size-2);
                      display: flex;
                      flex-direction: column;
                      justify-content: center;
                    }
                    .widget-news-11-1-widget p {
                      color: var(--text-color);
                      font-family: Rubik;
                      font-weight: 300;
                      font-size: 26px;
                      text-align: start;
                      margin-left: 32px;
                      padding-left: 16px;
                      margin-right: 32px;
                      border-left: 3px solid var(--text-color);
                    }
                  </style>
                  <script>
                    const getNews_11_1 = () => {
                      fetch("http://212.41.9.251:8000/news", {
                        method: "GET",
                        headers: {
                          accept: "application/json",
                        },
                      })
                        .then((response) => response.json())
                        .then((result) => {
                          document.getElementById(
                            "header-news-11-1"
                          ).innerHTML = result[0];
                        });
                    };
                    setTimeout(() => {
                      setInterval(() => {
                        getNews_11_1();
                      }, 300000);
                      getNews_11_1();
                    }, 5000);
                  </script>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-6-2"
                onclick="alert(getCode('btn-6-2'))"
              >
                <div class="design-1 widget-news-11-2-widget news-L">
                  <div class="left-line-11-2"></div>
                  <div><p id="header-news-11-2">------</p></div>
                  <div class="left-line-11-2"></div>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-2: 246px;
                      --size-4: 508px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-news-11-2-widget {
                      width: var(--size-4);
                      height: var(--size-2);
                      display: flex;
                      flex-direction: column;
                      justify-content: center;
                      align-items: center;
                    }
                    .widget-news-11-2-widget div:nth-child(2) {
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    }
                    .widget-news-11-2-widget p {
                      color: var(--text-color);
                      font-family: Rubik;
                      font-weight: 300;
                      font-size: 26px;
                      text-align: center;
                      padding-left: 32px;
                      padding-right: 32px;
                    }
                    .left-line-11-2 {
                      width: 40%;
                      height: 3px;
                      background-color: var(--text-color);
                      margin-top: 26px;
                      margin-bottom: 26px;
                    }
                  </style>
                  <script>
                    const getNews_11_2 = () => {
                      fetch("http://212.41.9.251:8000/news", {
                        method: "GET",
                        headers: {
                          accept: "application/json",
                        },
                      })
                        .then((response) => response.json())
                        .then((result) => {
                          document.getElementById(
                            "header-news-11-2"
                          ).innerHTML = result[0];
                        });
                    };
                    setTimeout(() => {
                      setInterval(() => {
                        getNews_11_2();
                      }, 300000);
                      getNews_11_2();
                    }, 5000);
                  </script>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="dropright-1">
        <button class="drop-1">
          Курc доллара/евро <br />
          11 вариант
        </button>
        <div class="drop-content-1">
          <div class="navbar-2">
            <div class="dropdown-2">
              <button
                class="drop-2"
                id="btn-7-1"
                onclick="alert(getCode('btn-7-1'))"
              >
                <div class="design-1 widget-rates-L-11-1-widget rates-XL">
                  <div>
                    <p>\$</p>
                    <div class="space-div-7-1"></div>
                    <p id="usd-11-1">0.00</p>
                  </div>
                  <div style="padding-left: 32px; padding-right: 32px">
                    <canvas id="diagram-11-1" width="350" height="180"></canvas>
                  </div>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-2: 246px;
                      --size-3: 377px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-rates-L-11-1-widget {
                      display: flex;
                      flex-direction: column;
                      width: var(--size-3);
                      height: var(--size-2);
                    }

                    .widget-rates-L-11-1-widget div:first-child {
                      display: flex;
                      margin-left: 32px;
                    }
                    .widget-rates-L-11-1-widget div:nth-child(3) {
                      display: flex;
                      justify-content: center;
                    }
                    .widget-rates-L-11-1-widget p {
                      font-family: rubik;
                      color: var(--text-color);
                      font-size: 70px;
                      font-weight: 300;
                    }
                    .widget-rates-L-11-1-widget p:first-child {
                      color: rgba(115, 115, 115, 1);
                    }
                    .space-div-7-1 {
                      width: 18px;
                    }
                  </style>
                  <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.5.0/Chart.min.js"></script>
                  <script>
                    const getUSD_11_1 = async () => {
                      const response = await fetch(
                        "https://www.cbr-xml-daily.ru/daily_json.js",
                        {
                          method: "GET",
                        }
                      );
                      const result = await response.json();
                      return result;
                    };
                    const myChart_11_1 = new Chart(
                      document.getElementById("diagram-11-1").getContext("2d"),
                      {
                        type: "line",
                        data: {
                          labels: ["", "", "", "", "", "", "", "", "", ""],
                          datasets: [
                            {
                              label: "\$",
                              lineTension: 0,
                              data: [
                                0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
                                0.0,
                              ],

                              pointRadius: 0,
                              borderColor: "#fff",
                              borderWidth: 4,
                              fill: false,
                            },
                          ],
                        },
                        options: {
                          legend: {
                            display: false,
                            maintainAspectRatio: false,
                          },
                          scales: {
                            xAxes: [
                              {
                                gridLines: {
                                  display: false,
                                },
                              },
                            ],
                            yAxes: [
                              {
                                gridLines: {
                                  color: "rgba(64,64,64,1)",
                                },
                              },
                            ],
                          },
                        },
                      }
                    );
                    setTimeout(() => {
                      setInterval(() => {
                        getUSD_11_1().then((result) => {
                          document.getElementById("usd-11-1").innerHTML =
                            result.Valute.USD.Value.toFixed(2);
                          myChart_11_1.data.datasets[0].data.splice(0, 1);
                          myChart_11_1.data.datasets[0].data.push(
                            result.Valute.USD.Value.toFixed(2)
                          );
                          myChart_11_1.update();
                        });
                      }, 43200000);
                      getUSD_11_1().then((result) => {
                        document.getElementById("usd-11-1").innerHTML =
                          result.Valute.USD.Value.toFixed(2);

                        const myChart_11_1_1 = new Chart(
                          document
                            .getElementById("diagram-11-1")
                            .getContext("2d"),
                          {
                            type: "line",
                            data: {
                              labels: ["", "", "", "", "", "", "", "", "", ""],
                              datasets: [
                                {
                                  label: "\$",
                                  lineTension: 0,
                                  data: [
                                    87.37, 87.21, 87.07, 88.05, 88.0, 84.96,
                                    85.75, 87.99, 87.95, 88.12,
                                  ],
                                  pointRadius: 0,
                                  borderColor: "#fff",
                                  borderWidth: 4,
                                  fill: false,
                                },
                              ],
                            },
                            options: {
                              legend: {
                                display: false,
                                maintainAspectRatio: false,
                              },
                              scales: {
                                xAxes: [
                                  {
                                    gridLines: {
                                      display: false,
                                    },
                                  },
                                ],
                                yAxes: [
                                  {
                                    gridLines: {
                                      color: "rgba(64,64,64,1)",
                                    },
                                  },
                                ],
                              },
                            },
                          }
                        );
                        myChart_11_1_1.data.datasets[0].data.splice(0, 1);
                        myChart_11_1_1.data.datasets[0].data.push(
                          result.Valute.USD.Value.toFixed(2)
                        );
                        myChart_11_1_1.update();
                      });
                    }, 5000);
                  </script>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-7-2"
                onclick="alert(getCode('btn-7-2'))"
              >
                <div class="design-1 widget-rates-L-11-2-widget rates-XL">
                  <div>
                    <p>€</p>
                    <div class="space-div-7-2"></div>
                    <p id="eur-11-2">0.00</p>
                  </div>
                  <div style="padding-left: 32px; padding-right: 32px">
                    <canvas id="diagram-11-2" width="350" height="180"></canvas>
                  </div>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-2: 246px;
                      --size-3: 377px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-rates-L-11-2-widget {
                      display: flex;
                      flex-direction: column;
                      width: var(--size-3);
                      height: var(--size-2);
                    }
                    .widget-rates-L-11-2-widget div:first-child {
                      display: flex;
                      margin-left: 32px;
                    }
                    .widget-rates-L-11-2-widget p {
                      font-family: rubik;
                      color: var(--text-color);
                      font-size: 70px;
                      font-weight: 300;
                    }
                    .widget-rates-L-11-2-widget p:first-child {
                      color: rgba(115, 115, 115, 1);
                    }
                    .space-div-7-2 {
                      width: 18px;
                    }
                  </style>
                  <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.5.0/Chart.min.js"></script>
                  <script>
                    const getEUR_11_2 = async () => {
                      const response = await fetch(
                        "https://www.cbr-xml-daily.ru/daily_json.js",
                        {
                          method: "GET",
                        }
                      );
                      const data = await response.json();
                      return data;
                    };
                    const myChart_11_2 = new Chart(
                      document.getElementById("diagram-11-2").getContext("2d"),
                      {
                        type: "line",
                        data: {
                          labels: ["", "", "", "", "", "", "", "", "", ""],
                          datasets: [
                            {
                              label: "\$",
                              lineTension: 0,
                              data: [
                                0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
                                0.0,
                              ],
                              pointRadius: 0,
                              borderColor: "#fff",
                              borderWidth: 4,
                              fill: false,
                            },
                          ],
                        },
                        options: {
                          legend: {
                            display: false,
                            maintainAspectRatio: false,
                          },
                          scales: {
                            xAxes: [
                              {
                                gridLines: {
                                  display: false,
                                },
                              },
                            ],
                            yAxes: [
                              {
                                gridLines: {
                                  color: "rgba(64,64,64,1)",
                                },
                              },
                            ],
                          },
                        },
                      }
                    );
                    setTimeout(() => {
                      setInterval(() => {
                        getEUR_11_2().then((result) => {
                          document.getElementById("eur-11-2").innerHTML =
                            result.Valute.EUR.Value.toFixed(2);
                          myChart_11_2.data.datasets[0].data.splice(0, 1);
                          myChart_11_2.data.datasets[0].data.push(
                            result.Valute.EUR.Value.toFixed(2)
                          );
                          myChart_11_2.update();
                        });
                      }, 43200000);
                      getEUR_11_2().then((result) => {
                        document.getElementById("eur-11-2").innerHTML =
                          result.Valute.EUR.Value.toFixed(2);

                        const myChart_11_2_2 = new Chart(
                          document
                            .getElementById("diagram-11-2")
                            .getContext("2d"),
                          {
                            type: "line",
                            data: {
                              labels: ["", "", "", "", "", "", "", "", "", ""],
                              datasets: [
                                {
                                  label: "\$",
                                  lineTension: 0,
                                  data: [
                                    94.08, 93.74, 94.11, 90.99, 92.39, 93.96,
                                    93.69, 94.58, 94.98, 95.1,
                                  ],
                                  pointRadius: 0,
                                  borderColor: "#fff",
                                  borderWidth: 4,
                                  fill: false,
                                },
                              ],
                            },
                            options: {
                              legend: {
                                display: false,
                                maintainAspectRatio: false,
                              },
                              scales: {
                                xAxes: [
                                  {
                                    gridLines: {
                                      display: false,
                                    },
                                  },
                                ],
                                yAxes: [
                                  {
                                    gridLines: {
                                      color: "rgba(64,64,64,1)",
                                    },
                                  },
                                ],
                              },
                            },
                          }
                        );
                        myChart_11_2_2.data.datasets[0].data.splice(0, 1);
                        myChart_11_2_2.data.datasets[0].data.push(
                          result.Valute.EUR.Value.toFixed(2)
                        );
                        myChart_11_2_2.update();
                      });
                    }, 5000);
                  </script>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-7-3"
                onclick="alert(getCode('btn-7-3'))"
              >
                <div class="design-1 widget-rates-11-3-widget rates-M">
                  <p>\$</p>
                  <div class="space-div-7-3"></div>
                  <p id="usd-11-3">0.00</p>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-1: 115px;
                      --size-3: 377px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-rates-11-3-widget {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: var(--size-3);
                      height: var(--size-1);
                    }
                    .widget-rates-11-3-widget p {
                      font-family: rubik;
                      font-weight: 300;
                      color: var(--text-color);
                      font-size: 70px;
                    }
                    .widget-rates-11-3-widget p:first-child {
                      color: rgba(115, 115, 115, 1);
                    }
                    .space-div-7-3 {
                      width: 16px;
                    }
                  </style>
                  <script>
                    const getUSD_11_3 = () => {
                      fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
                        method: "GET",
                      })
                        .then((response) => response.json())
                        .then((result) => {
                          document.getElementById("usd-11-3").innerHTML =
                            result.Valute.USD.Value.toFixed(2);
                        });
                    };
                    setTimeout(() => {
                      setInterval(() => {
                        getUSD_11_3;
                      }, 43200000);
                      getUSD_11_3();
                    }, 1000);
                  </script>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-7-4"
                onclick="alert(getCode('btn-7-4'))"
              >
                <div class="design-1 widget-rates-11-4-widget rates-M">
                  <p>€</p>
                  <div class="space-div-7-4"></div>
                  <p id="eur-11-4">0.00</p>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-1: 115px;
                      --size-3: 377px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-rates-11-4-widget {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: var(--size-3);
                      height: var(--size-1);
                    }
                    .widget-rates-11-4-widget p {
                      font-family: rubik;
                      font-weight: 300;
                      color: var(--text-color);
                      font-size: 70px;
                    }
                    .widget-rates-11-4-widget p:first-child {
                      color: rgba(115, 115, 115, 1);
                    }
                    .space-div-7-4 {
                      width: 16px;
                    }
                  </style>
                  <script>
                    const getEUR_11_4 = () => {
                      fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
                        method: "GET",
                      })
                        .then((response) => response.json())
                        .then((result) => {
                          document.getElementById("eur-11-4").innerHTML =
                            result.Valute.EUR.Value.toFixed(2);
                        });
                    };
                    setTimeout(() => {
                      setInterval(() => {
                        getEUR_11_4;
                      }, 43200000);
                      getEUR_11_4();
                    }, 1000);
                  </script>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-7-5"
                onclick="alert(getCode('btn-7-5'))"
              >
                <div class="design-1 widget-rates-M-11-5-widget rates-S">
                  <div>
                    <p>USD</p>
                    <div class="space-div-7-5"></div>
                    <p id="usd-11-5">0.00</p>
                  </div>
                  <div>
                    <p>EUR</p>
                    <div class="space-div-7-5"></div>
                    <p id="eur-11-5">0.00</p>
                  </div>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-1: 115px;
                      --size-2: 246px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-rates-M-11-5-widget {
                      display: flex;
                      flex-direction: column;
                      justify-content: space-evenly;
                      width: var(--size-2);
                      height: var(--size-1);
                    }
                    .widget-rates-M-11-5-widget div {
                      display: flex;
                      justify-content: center;
                    }
                    .widget-rates-M-11-5-widget div p:first-child {
                      color: rgba(115, 115, 115, 1);
                    }
                    .widget-rates-M-11-5-widget p {
                      font-family: rubik;
                      color: var(--text-color);
                      font-size: 26px;
                      font-weight: 300;
                    }
                    .space-div-7-5 {
                      width: 12px;
                    }
                  </style>
                  <script>
                    const getUSD_EUR_11_5 = () => {
                      fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
                        method: "GET",
                      })
                        .then((response) => response.json())
                        .then((result) => {
                          document.getElementById("usd-11-5").innerHTML =
                            result.Valute.USD.Value.toFixed(2);
                          document.getElementById("eur-11-5").innerHTML =
                            result.Valute.EUR.Value.toFixed(2);
                        });
                    };

                    setTimeout(() => {
                      setInterval(() => {
                        getUSD_EUR_11_5;
                      }, 43200000);
                      getUSD_EUR_11_5();
                    }, 5000);
                  </script>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-7-6"
                onclick="alert(getCode('btn-7-6'))"
              >
                <div class="design-1 widget-rates-M-11-6-widget rates-S">
                  <p>USD</p>
                  <div class="space-div-7-6"></div>
                  <p id="usd-11-6">0.00</p>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-1: 115px;
                      --size-2: 246px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-rates-M-11-6-widget {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: var(--size-2);
                      height: var(--size-1);
                    }
                    .widget-rates-M-11-6-widget p {
                      font-family: rubik;
                      color: var(--text-color);
                      font-size: 32px;
                      font-weight: 400;
                    }
                    .widget-rates-M-11-6-widget p:first-child {
                      color: rgba(115, 115, 115, 1);
                    }
                    .space-div-7-6 {
                      width: 14px;
                    }
                  </style>
                  <script>
                    const getUSD_11_6 = () => {
                      fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
                        method: "GET",
                      })
                        .then((response) => response.json())
                        .then((result) => {
                          document.getElementById("usd-11-6").innerHTML =
                            result.Valute.USD.Value.toFixed(2);
                        });
                    };

                    setTimeout(() => {
                      setInterval(() => {
                        getUSD_11_6;
                      }, 43200000);
                      getUSD_11_6();
                    }, 5000);
                  </script>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-7-7"
                onclick="alert(getCode('btn-7-7'))"
              >
                <div class="design-1 widget-rates-M-11-7-widget rates-S">
                  <p>EUR</p>
                  <div class="space-div-7-7"></div>
                  <p id="eur-11-7">0.00</p>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-1: 115px;
                      --size-2: 246px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-rates-M-11-7-widget {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: var(--size-2);
                      height: var(--size-1);
                    }
                    .widget-rates-M-11-7-widget p {
                      font-family: rubik;
                      color: var(--text-color);
                      font-size: 32px;
                      font-weight: 400;
                    }
                    .widget-rates-M-11-7-widget p:first-child {
                      color: rgba(115, 115, 115, 1);
                    }
                    .space-div-7-7 {
                      width: 14px;
                    }
                  </style>
                  <script>
                    const getEUR_11_7 = () => {
                      fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
                        method: "GET",
                      })
                        .then((response) => response.json())
                        .then((result) => {
                          document.getElementById("eur-11-7").innerHTML =
                            result.Valute.EUR.Value.toFixed(2);
                        });
                    };

                    setTimeout(() => {
                      setInterval(() => {
                        getEUR_11_7;
                      }, 43200000);
                      getEUR_11_7();
                    }, 5000);
                  </script>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-7-8"
                onclick="alert(getCode('btn-7-8'))"
              >
                <div class="design-1 widget-rates-S-11-8-widget rates-XS">
                  <div>
                    <p>\$</p>
                    <div class="space-div-7-8"></div>
                    <p id="usd-11-8">0.00</p>
                  </div>
                  <div>
                    <p>€</p>
                    <div class="space-div-7-8"></div>
                    <p id="eur-11-8">0.00</p>
                  </div>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-1: 115px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-rates-S-11-8-widget {
                      display: flex;
                      flex-direction: column;
                      justify-content: space-evenly;
                      width: var(--size-1);
                      height: var(--size-1);
                    }
                    .widget-rates-S-11-8-widget p {
                      font-family: rubik;
                      color: var(--text-color);
                      font-size: 26px;
                      font-weight: 300;
                    }
                    .widget-rates-S-11-8-widget div {
                      display: flex;
                      justify-content: center;
                    }
                    .widget-rates-S-11-8-widget div p:first-child {
                      color: rgba(115, 115, 115, 1);
                    }
                    .space-div-7-8 {
                      width: 4px;
                    }
                  </style>
                  <script>
                    const getUSD_EUR_11_8 = () => {
                      fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
                        method: "GET",
                      })
                        .then((response) => response.json())
                        .then((result) => {
                          document.getElementById("usd-11-8").innerHTML =
                            result.Valute.USD.Value.toFixed(2);
                          document.getElementById("eur-11-8").innerHTML =
                            result.Valute.EUR.Value.toFixed(2);
                        });
                    };

                    setTimeout(() => {
                      setInterval(() => {
                        getUSD_EUR_11_8;
                      }, 43200000);
                      getUSD_EUR_11_8();
                    }, 5000);
                  </script>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="dropright-1">
        <button class="drop-1">
          Цвет. металлы <br />
          11 вариант
        </button>
        <div class="drop-content-1">
          <div class="navbar-2">
            <div class="dropdown-2">
              <button
                class="drop-2"
                id="btn-8-1"
                onclick="alert(getCode('btn-8-1'))"
              >
                <div class="design-1 widget-metals-XL-11-1-widget metal-XL">
                  <div>
                    <p class="name-metal-11-1">Нефть</p>
                    <p id="oil-divide-price-11-1">---,--</p>
                    <p id="oil-perc-price-11-1">---,--</p>
                    <div class="widget-metal-last-11-1">
                      <p id="oil-price-11-1">---,--</p>
                      <div class="space-div-8-1"></div>
                      <img
                        id="updown-11-1-1"
                        src="http://212.41.9.251:8000/static/red_triangle.svg"
                      />
                    </div>
                  </div>
                  <div>
                    <p class="name-metal-11-1">Серебро</p>
                    <p id="silver-divide-price-11-1">---,--</p>
                    <p id="silver-perc-price-11-1">---,--</p>
                    <div class="widget-metal-last-11-1">
                      <p id="silver-price-11-1">---,--</p>
                      <div class="space-div-8-1"></div>
                      <img
                        id="updown-11-1-2"
                        src="http://212.41.9.251:8000/static/red_triangle.svg"
                      />
                    </div>
                  </div>
                  <div>
                    <p class="name-metal-11-1">Золото</p>
                    <p id="gold-divide-price-11-1">---,--</p>
                    <p id="gold-perc-price-11-1">---,--</p>
                    <div class="widget-metal-last-11-1">
                      <p id="gold-price-11-1">---,--</p>
                      <div class="space-div-8-1"></div>
                      <img
                        id="updown-11-1-3"
                        src="http://212.41.9.251:8000/static/red_triangle.svg"
                      />
                    </div>
                  </div>
                  <div>
                    <p class="name-metal-11-1">Платина</p>
                    <p id="platinum-divide-price-11-1">---,--</p>
                    <p id="platinum-perc-price-11-1">---,--</p>
                    <div class="widget-metal-last-11-1">
                      <p id="platinum-price-11-1">---,--</p>
                      <div class="space-div-8-1"></div>
                      <img
                        id="updown-11-1-4"
                        src="http://212.41.9.251:8000/static/red_triangle.svg"
                      />
                    </div>
                  </div>
                  <div>
                    <p class="name-metal-11-1">Палладий</p>
                    <p id="palladium-divide-price-11-1">---,--</p>
                    <p id="palladium-perc-price-11-1">---,--</p>
                    <div class="widget-metal-last-11-1">
                      <p id="palladium-price-11-1">---,--</p>
                      <div class="space-div-8-1"></div>
                      <img
                        id="updown-11-1-5"
                        src="http://212.41.9.251:8000/static/red_triangle.svg"
                      />
                    </div>
                  </div>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-2: 246px;
                      --size-4: 508px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-metals-XL-11-1-widget {
                      display: flex;
                      flex-direction: column;
                      justify-content: space-evenly;
                      width: var(--size-4);
                      height: var(--size-2);
                    }
                    .widget-metals-XL-11-1-widget div {
                      display: flex;
                      justify-content: space-evenly;
                      align-items: center;
                      color: var(--text-color);
                      font-size: 18;
                      font-family: Rubik;
                    }
                    .name-metal-11-1 {
                      color: white;
                      text-align: start;
                      width: 129px;
                    }
                    .widget-metals-XL-11-1-widget div p:nth-child(2) {
                      color: rgba(115, 115, 115, 1);
                      width: 61px;
                      text-align: end;
                    }
                    .widget-metals-XL-11-1-widget div p:nth-child(3) {
                      color: rgba(115, 115, 115, 1);
                      width: 80px;
                      text-align: end;
                    }
                    .widget-metal-last-11-1 p {
                      width: 125px;
                      text-align: end;
                    }
                    .widget-metals-XL-11-1-widget img {
                      width: 12px;
                      height: 11px;
                    }
                    .space-div-8-1 {
                      width: 6px;
                    }
                  </style>
                  <script>
                    const getOil_11_1 = () => {
                      fetch("http://212.41.9.251:8000/get_brent", {
                        method: "GET",
                        headers: {
                          accept: "application/json",
                        },
                      })
                        .then((response) => response.json())
                        .then((result) => {
                          var old_data =
                            document.getElementById("oil-price-11-1").innerHTML;
                          var new_data = result[1];
                          if (new_data >= old_data) {
                            document
                              .getElementById("updown-11-1-1")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/green_triangle.svg"
                              );
                          } else {
                            document
                              .getElementById("updown-11-1-1")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/red_triangle.svg"
                              );
                          }
                          document.getElementById("oil-price-11-1").innerHTML =
                            result[1];
                          document.getElementById(
                            "oil-divide-price-11-1"
                          ).innerHTML = result[2];
                          document.getElementById(
                            "oil-perc-price-11-1"
                          ).innerHTML = result[3];
                        });
                    };
                    const getMetal_11_1 = () => {
                      fetch(
                        "https://api.metalpriceapi.com/v1/latest?api_key=5196052db469251707517ada2cc2f6e0&base=USD&currencies=XAG,%20XAU,%20XPT,%20XPD",
                        {
                          method: "GET",
                        }
                      )
                        .then((response) => response.json())
                        .then((result) => {
                          var old_silver_price =
                            document.getElementById(
                              "silver-price-11-1"
                            ).innerHTML;
                          var new_silver_price = result.rates.USDXAG;

                          if (new_silver_price >= old_silver_price) {
                            document
                              .getElementById("updown-11-1-2")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/green_triangle.svg"
                              );
                          } else {
                            document
                              .getElementById("updown-11-1-2")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/red_triangle.svg"
                              );
                          }
                          document.getElementById(
                            "silver-divide-price-11-1"
                          ).innerHTML = (
                            new_silver_price - old_silver_price
                          ).toFixed(2);
                          document.getElementById(
                            "silver-perc-price-11-1"
                          ).innerHTML = \`\${(
                            ((new_silver_price - old_silver_price) /
                              new_silver_price) *
                            100
                          ).toFixed(2)}%\`;
                          document.getElementById(
                            "silver-price-11-1"
                          ).innerHTML = result.rates.USDXAG.toFixed(2);
                          //------------------------------------
                          var old_gold_price =
                            document.getElementById(
                              "gold-price-11-1"
                            ).innerHTML;
                          var new_gold_price = result.rates.USDXAU;

                          if (new_gold_price >= old_gold_price) {
                            document
                              .getElementById("updown-11-1-3")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/green_triangle.svg"
                              );
                          } else {
                            document
                              .getElementById("updown-11-1-3")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/red_triangle.svg"
                              );
                          }
                          document.getElementById(
                            "gold-divide-price-11-1"
                          ).innerHTML = (
                            new_gold_price - old_gold_price
                          ).toFixed(2);
                          document.getElementById(
                            "gold-perc-price-11-1"
                          ).innerHTML = \`\${(
                            ((new_gold_price - old_gold_price) /
                              new_gold_price) *
                            100
                          ).toFixed(2)}%\`;
                          document.getElementById("gold-price-11-1").innerHTML =
                            result.rates.USDXAU.toFixed(2);
                          //------------------------------------
                          var old_platinum_price = document.getElementById(
                            "platinum-price-11-1"
                          ).innerHTML;
                          var new_platinum_price =
                            result.rates.USDXPT.toFixed(2);

                          if (new_platinum_price >= old_platinum_price) {
                            document
                              .getElementById("updown-11-1-4")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/green_triangle.svg"
                              );
                          } else {
                            document
                              .getElementById("updown-11-1-4")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/red_triangle.svg"
                              );
                          }
                          document.getElementById(
                            "platinum-divide-price-11-1"
                          ).innerHTML = (
                            new_gold_price - old_platinum_price
                          ).toFixed(2);
                          document.getElementById(
                            "platinum-perc-price-11-1"
                          ).innerHTML = \`\${(
                            ((new_platinum_price - old_platinum_price) /
                              new_platinum_price) *
                            100
                          ).toFixed(2)}%\`;
                          document.getElementById(
                            "platinum-price-11-1"
                          ).innerHTML = result.rates.USDXPT.toFixed(2);
                          //------------------------------------
                          var old_palladium_price = document.getElementById(
                            "palladium-price-11-1"
                          ).innerHTML;
                          var new_palladium_price = result.rates.USDXPD;

                          if (new_palladium_price >= old_palladium_price) {
                            document
                              .getElementById("updown-11-1-5")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/green_triangle.svg"
                              );
                          } else {
                            document
                              .getElementById("updown-11-1-5")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/red_triangle.svg"
                              );
                          }
                          document.getElementById(
                            "palladium-divide-price-11-1"
                          ).innerHTML = (
                            new_palladium_price - old_palladium_price
                          ).toFixed(2);
                          document.getElementById(
                            "palladium-perc-price-11-1"
                          ).innerHTML = \`\${(
                            ((new_palladium_price - old_palladium_price) /
                              new_palladium_price) *
                            100
                          ).toFixed(2)}%\`;
                          document.getElementById(
                            "palladium-price-11-1"
                          ).innerHTML = result.rates.USDXPD.toFixed(2);
                        });
                    };
                    // setTimeout(() => {
                    //   setInterval(() => {
                    //     getOil_11_1;
                    //     getMetal_11_1;
                    //   }, 172800000);
                    //   getOil_11_1();
                    //   getMetal_11_1();
                    // }, 1000);
                  </script>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-8-2"
                onclick="alert(getCode('btn-8-2'))"
              >
                <div class="design-1 widget-metals-11-2-widget metal-L">
                  <div>
                    <p class="name-metal-11-2">Нефть</p>
                    <p id="oil-divide-price-11-2">---,--</p>
                    <p id="oil-perc-price-11-2">---,--</p>
                    <div class="widget-metal-last-11-2">
                      <p id="oil-price-11-2">---,--</p>
                      <div class="space-div-8-2"></div>
                      <img
                        id="updown-11-2-1"
                        src="http://212.41.9.251:8000/static/red_triangle.svg"
                      />
                    </div>
                  </div>
                  <div>
                    <p class="name-metal-11-2">Серебро</p>
                    <p id="silver-divide-price-11-2">---,--</p>
                    <p id="silver-perc-price-11-2">---,--</p>
                    <div class="widget-metal-last-11-2">
                      <p id="silver-price-11-2">---,--</p>
                      <div class="space-div-8-2"></div>
                      <img
                        id="updown-11-2-2"
                        src="http://212.41.9.251:8000/static/red_triangle.svg"
                      />
                    </div>
                  </div>
                  <div>
                    <p class="name-metal-11-2">Золото</p>
                    <p id="gold-divide-price-11-2">---,--</p>
                    <p id="gold-perc-price-11-2">---,--</p>
                    <div class="widget-metal-last-11-2">
                      <p id="gold-price-11-2">---,--</p>
                      <div class="space-div-8-2"></div>
                      <img
                        id="updown-11-2-3"
                        src="http://212.41.9.251:8000/static/red_triangle.svg"
                      />
                    </div>
                  </div>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-1: 115px;
                      --size-4: 508px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-metals-11-2-widget {
                      display: flex;
                      flex-direction: column;
                      justify-content: space-evenly;
                      width: var(--size-4);
                      height: var(--size-1);
                    }
                    .widget-metals-11-2-widget div {
                      display: flex;
                      justify-content: space-evenly;
                      align-items: center;
                      color: var(--text-color);
                      font-size: 18;
                      font-family: Rubik;
                    }
                    .name-metal-11-2 {
                      color: white;
                      text-align: start;
                      width: 106px;
                    }
                    .widget-metals-11-2-widget div p:nth-child(2) {
                      color: rgba(115, 115, 115, 1);
                      width: 61px;
                      text-align: end;
                    }
                    .widget-metals-11-2-widget div p:nth-child(3) {
                      color: rgba(115, 115, 115, 1);
                      width: 80px;
                      text-align: end;
                    }
                    .widget-metals-11-2-widget div p:nth-child(4) {
                      width: 100px;
                      text-align: end;
                    }
                    .widget-metals-11-2-widget img {
                      width: 12px;
                      height: 11px;
                    }
                    .space-div-8-2 {
                      width: 6px;
                    }
                    .widget-metal-last-11-2 p {
                      width: 108px;
                      text-align: end;
                    }
                  </style>
                  <script>
                    const getOil_11_2 = () => {
                      fetch("http://212.41.9.251:8000/get_brent", {
                        method: "GET",
                        headers: {
                          accept: "application/json",
                        },
                      })
                        .then((response) => response.json())
                        .then((result) => {
                          var old_data =
                            document.getElementById("oil-price-11-2").innerHTML;
                          var new_data = result[1];
                          if (new_data >= old_data) {
                            document
                              .getElementById("updown-11-2-1")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/green_triangle.svg"
                              );
                          } else {
                            document
                              .getElementById("updown-11-2-1")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/red_triangle.svg"
                              );
                          }
                          document.getElementById("oil-price-11-2").innerHTML =
                            result[1];
                          document.getElementById(
                            "oil-divide-price-11-2"
                          ).innerHTML = result[2];
                          document.getElementById(
                            "oil-perc-price-11-2"
                          ).innerHTML = result[3];
                        });
                    };
                    const getMetal_11_2 = () => {
                      fetch(
                        "https://api.metalpriceapi.com/v1/latest?api_key=5196052db469251707517ada2cc2f6e0&base=USD&currencies=XAG,%20XAU,%20XPT,%20XPD",
                        {
                          method: "GET",
                        }
                      )
                        .then((response) => response.json())
                        .then((result) => {
                          var old_silver_price =
                            document.getElementById(
                              "silver-price-11-2"
                            ).innerHTML;
                          var new_silver_price = result.rates.USDXAG;

                          if (new_silver_price >= old_silver_price) {
                            document
                              .getElementById("updown-11-2-2")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/green_triangle.svg"
                              );
                          } else {
                            document
                              .getElementById("updown-11-2-2")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/red_triangle.svg"
                              );
                          }
                          document.getElementById(
                            "silver-divide-price-11-2"
                          ).innerHTML = (
                            new_silver_price - old_silver_price
                          ).toFixed(2);
                          document.getElementById(
                            "silver-perc-price-11-2"
                          ).innerHTML = \`\${(
                            ((new_silver_price - old_silver_price) /
                              new_silver_price) *
                            100
                          ).toFixed(2)}%\`;
                          document.getElementById(
                            "silver-price-11-2"
                          ).innerHTML = result.rates.USDXAG.toFixed(2);
                          //------------------------------------
                          var old_gold_price =
                            document.getElementById(
                              "gold-price-11-2"
                            ).innerHTML;
                          var new_gold_price = result.rates.USDXAU;

                          if (new_gold_price >= old_gold_price) {
                            document
                              .getElementById("updown-11-2-3")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/green_triangle.svg"
                              );
                          } else {
                            document
                              .getElementById("updown-11-2-3")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/red_triangle.svg"
                              );
                          }
                          document.getElementById(
                            "gold-divide-price-11-2"
                          ).innerHTML = (
                            new_gold_price - old_gold_price
                          ).toFixed(2);
                          document.getElementById(
                            "gold-perc-price-11-2"
                          ).innerHTML = \`\${(
                            ((new_gold_price - old_gold_price) /
                              new_gold_price) *
                            100
                          ).toFixed(2)}%\`;
                          document.getElementById("gold-price-11-2").innerHTML =
                            result.rates.USDXAU.toFixed(2);
                        });
                    };
                    // setTimeout(() => {
                    //   setInterval(() => {
                    //     getOil_11_2;
                    //     getMetal_11_2;
                    //   }, 172800000);
                    //   getOil_11_2();
                    //   getMetal_11_2();
                    // }, 1000);
                  </script>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-8-3"
                onclick="alert(getCode('btn-8-3'))"
              >
                <div class="design-1 widget-metals-L-11-3-widget metal-M">
                  <div>
                    <p class="name-metal-11-3">Нефть</p>
                    <div class="widget-metal-last-11-3">
                      <p id="oil-price-11-3">---,--</p>
                      <div class="space-div-8-3"></div>
                      <img
                        id="updown-11-3-1"
                        src="http://212.41.9.251:8000/static/red_triangle.svg"
                      />
                    </div>
                  </div>
                  <div>
                    <p class="name-metal-11-3">Серебро</p>
                    <div class="widget-metal-last-11-3">
                      <p id="silver-price-11-3">---,--</p>
                      <div class="space-div-8-3"></div>
                      <img
                        id="updown-11-3-2"
                        src="http://212.41.9.251:8000/static/red_triangle.svg"
                      />
                    </div>
                  </div>
                  <div>
                    <p class="name-metal-11-3">Золото</p>
                    <div class="widget-metal-last-11-3">
                      <p id="gold-price-11-3">---,--</p>
                      <div class="space-div-8-3"></div>
                      <img
                        id="updown-11-3-3"
                        src="http://212.41.9.251:8000/static/red_triangle.svg"
                      />
                    </div>
                  </div>
                  <div>
                    <p class="name-metal-11-3">Платина</p>
                    <div class="widget-metal-last-11-3">
                      <p id="platinum-price-11-3">---,--</p>
                      <div class="space-div-8-3"></div>
                      <img
                        id="updown-11-3-4"
                        src="http://212.41.9.251:8000/static/red_triangle.svg"
                      />
                    </div>
                  </div>
                  <div>
                    <p class="name-metal-11-3">Палладий</p>
                    <div class="widget-metal-last-11-3">
                      <p id="palladium-price-11-3">---,--</p>
                      <div class="space-div-8-3"></div>
                      <img
                        id="updown-11-3-5"
                        src="http://212.41.9.251:8000/static/red_triangle.svg"
                      />
                    </div>
                  </div>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-2: 246px;
                      --size-3: 377px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-metals-L-11-3-widget {
                      display: flex;
                      flex-direction: column;
                      justify-content: space-evenly;
                      width: var(--size-3);
                      height: var(--size-2);
                    }
                    .widget-metals-L-11-3-widget div {
                      display: flex;
                      justify-content: space-around;
                      align-items: center;
                      color: var(--text-color);
                      font-size: 18;
                      font-family: Rubik;
                    }
                    .name-metal-11-3 {
                      text-align: start;
                      width: 106px;
                      color: rgba(115, 115, 115, 1);
                    }
                    .space-div-8-3 {
                      width: 6px;
                    }
                    .widget-metals-L-11-3-widget img {
                      width: 12px;
                      height: 11px;
                    }
                    .widget-metal-last-11-3 p {
                      width: 100px;
                      text-align: end;
                    }
                  </style>
                  <script>
                    const getOil_11_3 = () => {
                      fetch("http://212.41.9.251:8000/get_brent", {
                        method: "GET",
                        headers: {
                          accept: "application/json",
                        },
                      })
                        .then((response) => response.json())
                        .then((result) => {
                          var old_data =
                            document.getElementById("oil-price-11-3").innerHTML;
                          var new_data = result[1];
                          if (new_data >= old_data) {
                            document
                              .getElementById("updown-11-3-1")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/green_triangle.svg"
                              );
                          } else {
                            document
                              .getElementById("updown-11-3-1")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/red_triangle.svg"
                              );
                          }
                          document.getElementById("oil-price-11-3").innerHTML =
                            result[1];
                        });
                    };
                    const getMetal_11_3 = () => {
                      fetch(
                        "https://api.metalpriceapi.com/v1/latest?api_key=5196052db469251707517ada2cc2f6e0&base=USD&currencies=XAG,%20XAU,%20XPT,%20XPD",
                        {
                          method: "GET",
                        }
                      )
                        .then((response) => response.json())
                        .then((result) => {
                          var old_silver_price =
                            document.getElementById(
                              "silver-price-11-3"
                            ).innerHTML;
                          var new_silver_price = result.rates.USDXAG;

                          if (new_silver_price >= old_silver_price) {
                            document
                              .getElementById("updown-11-3-2")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/green_triangle.svg"
                              );
                          } else {
                            document
                              .getElementById("updown-11-3-2")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/red_triangle.svg"
                              );
                          }
                          document.getElementById(
                            "silver-price-11-3"
                          ).innerHTML = result.rates.USDXAG.toFixed(2);
                          //------------------------------------
                          var old_gold_price =
                            document.getElementById(
                              "gold-price-11-3"
                            ).innerHTML;
                          var new_gold_price = result.rates.USDXAU;

                          if (new_gold_price >= old_gold_price) {
                            document
                              .getElementById("updown-11-3-3")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/green_triangle.svg"
                              );
                          } else {
                            document
                              .getElementById("updown-11-3-3")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/red_triangle.svg"
                              );
                          }
                          document.getElementById("gold-price-11-3").innerHTML =
                            result.rates.USDXAU.toFixed(2);
                          //------------------------------------
                          var old_platinum_price = document.getElementById(
                            "platinum-price-11-3"
                          ).innerHTML;
                          var new_platinum_price =
                            result.rates.USDXPT.toFixed(2);

                          if (new_platinum_price >= old_platinum_price) {
                            document
                              .getElementById("updown-11-3-4")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/green_triangle.svg"
                              );
                          } else {
                            document
                              .getElementById("updown-11-3-4")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/red_triangle.svg"
                              );
                          }
                          document.getElementById(
                            "platinum-price-11-3"
                          ).innerHTML = result.rates.USDXPT.toFixed(2);
                          //------------------------------------
                          var old_palladium_price = document.getElementById(
                            "palladium-price-11-3"
                          ).innerHTML;
                          var new_palladium_price = result.rates.USDXPD;

                          if (new_palladium_price >= old_palladium_price) {
                            document
                              .getElementById("updown-11-3-5")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/green_triangle.svg"
                              );
                          } else {
                            document
                              .getElementById("updown-11-3-5")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/red_triangle.svg"
                              );
                          }
                          document.getElementById(
                            "palladium-price-11-3"
                          ).innerHTML = result.rates.USDXPD.toFixed(2);
                        });
                    };
                    // setTimeout(() => {
                    //   setInterval(() => {
                    //     getOil_11_3;
                    //     getMetal_11_3;
                    //   }, 172800000);
                    //   getOil_11_3();
                    //   getMetal_11_3();
                    // }, 1000);
                  </script>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-8-4"
                onclick="alert(getCode('btn-8-4'))"
              >
                <div class="design-1 widget-metals-11-4-widget metal-S">
                  <div>
                    <p class="name-metal-11-4">Нефть</p>
                    <div class="widget-metal-last-11-4">
                      <p id="oil-price-11-4">---,--</p>
                      <div class="space-div-8-4"></div>
                      <img
                        id="updown-11-4-1"
                        src="http://212.41.9.251:8000/static/red_triangle.svg"
                      />
                    </div>
                  </div>
                  <div>
                    <p class="name-metal-11-4">Серебро</p>
                    <div class="widget-metal-last-11-4">
                      <p id="silver-price-11-4">---,--</p>
                      <div class="space-div-8-4"></div>
                      <img
                        id="updown-11-4-2"
                        src="http://212.41.9.251:8000/static/red_triangle.svg"
                      />
                    </div>
                  </div>
                  <div>
                    <p class="name-metal-11-4">Золото</p>
                    <div class="widget-metal-last-11-4">
                      <p id="gold-price-11-4">---,--</p>
                      <div class="space-div-8-4"></div>
                      <img
                        id="updown-11-4-3"
                        src="http://212.41.9.251:8000/static/red_triangle.svg"
                      />
                    </div>
                  </div>
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-1: 115px;
                      --size-3: 377px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-metals-11-4-widget {
                      display: flex;
                      flex-direction: column;
                      justify-content: space-evenly;
                      width: var(--size-3);
                      height: var(--size-1);
                    }
                    .widget-metals-11-4-widget div {
                      display: flex;
                      justify-content: space-around;
                      align-items: center;
                      color: var(--text-color);
                      font-size: 18;
                      font-family: Rubik;
                    }
                    .name-metal-11-4 {
                      text-align: start;
                      width: 106px;
                      color: rgba(115, 115, 115, 1);
                    }
                    .space-div-8-4 {
                      width: 6px;
                    }
                    .widget-metals-L-11-4 img {
                      width: 12px;
                      height: 11px;
                    }
                    .widget-metal-last-11-4 p {
                      width: 100px;
                      text-align: end;
                    }
                  </style>
                  <script>
                    const getOil_11_4 = () => {
                      fetch("http://212.41.9.251:8000/get_brent", {
                        method: "GET",
                        headers: {
                          accept: "application/json",
                        },
                      })
                        .then((response) => response.json())
                        .then((result) => {
                          var old_data =
                            document.getElementById("oil-price-11-4").innerHTML;
                          var new_data = result[1];
                          if (new_data >= old_data) {
                            document
                              .getElementById("updown-11-4-1")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/green_triangle.svg"
                              );
                          } else {
                            document
                              .getElementById("updown-11-4-1")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/red_triangle.svg"
                              );
                          }
                          document.getElementById("oil-price-11-4").innerHTML =
                            result[1];
                        });
                    };
                    const getMetal_11_4 = () => {
                      fetch(
                        "https://api.metalpriceapi.com/v1/latest?api_key=5196052db469251707517ada2cc2f6e0&base=USD&currencies=XAG,%20XAU,%20XPT,%20XPD",
                        {
                          method: "GET",
                        }
                      )
                        .then((response) => response.json())
                        .then((result) => {
                          var old_silver_price =
                            document.getElementById(
                              "silver-price-11-4"
                            ).innerHTML;
                          var new_silver_price = result.rates.USDXAG;

                          if (new_silver_price >= old_silver_price) {
                            document
                              .getElementById("updown-11-4-2")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/green_triangle.svg"
                              );
                          } else {
                            document
                              .getElementById("updown-11-4-2")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/red_triangle.svg"
                              );
                          }
                          document.getElementById(
                            "silver-price-11-4"
                          ).innerHTML = result.rates.USDXAG.toFixed(2);
                          //------------------------------------
                          var old_gold_price =
                            document.getElementById(
                              "gold-price-11-4"
                            ).innerHTML;
                          var new_gold_price = result.rates.USDXAU;

                          if (new_gold_price >= old_gold_price) {
                            document
                              .getElementById("updown-11-4-3")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/green_triangle.svg"
                              );
                          } else {
                            document
                              .getElementById("updown-11-4-3")
                              .setAttribute(
                                "src",
                                "http://212.41.9.251:8000/static/red_triangle.svg"
                              );
                          }
                          document.getElementById("gold-price-11-4").innerHTML =
                            result.rates.USDXAU.toFixed(2);
                        });
                    };
                    // setTimeout(() => {
                    //   setInterval(() => {
                    //     getOil_11_4;
                    //     getMetal_11_4;
                    //   }, 172800000);
                    //   getOil_11_4();
                    //   getMetal_11_4();
                    // }, 1000);
                  </script>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="dropright-1">
        <button class="drop-1">
          Управляющая компания <br />
          11 вариант
        </button>
        <div class="drop-content-1">
          <div class="navbar-2">
            <div class="dropdown-2">
              <button
                class="drop-2"
                id="btn-9-1"
                onclick="alert(getCode('btn-9-1'))"
              >
                <div class="design-1 widget-about-company-11-1-widget company-L">
                  

                    <div>
                      <p>Лифт обслуживает компания</p>
                      <input
                        type="text"
                        
                        id="text1"
                        name="input1"
                        style="
                          text-align: end;
                          background-color: rgba(0, 0, 0, 0);
                          border: none;
                          color: white;
                          font-family: rubik;
                          color: var(--text-color);
                          font-size: 18px;
                          width: 180px;
                        "
                      />
                    </div>
                    <div>
                      <p>Телефон поддержки</p>
                      <input type="text"  name="input1" id="text2" style="
                      text-align: end;
                      background-color: rgba(0, 0, 0, 0);
                      border: none;
                      color: white;
                      font-family: rubik;
                      color: var(--text-color);
                      font-size: 18px;
                      width: 180px;
                    "/>
                    </div>
                    
                    <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-1: 115px;
                      --size-4: 508px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --text-color: rgba(255, 255, 255, 1);
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-about-company-11-1-widget {
                      display: flex;
                      flex-direction: column;
                      justify-content: space-evenly;
                      width: var(--size-4);
                      height: var(--size-1);
                    }
                    .widget-about-company-11-1-widget div {
                      display: flex;
                      justify-content: space-around;
                    }
                    .widget-about-company-11-1-widget p {
                      font-family: rubik;
                      color: var(--text-color);
                      font-size: 18px;
                      width: 255px;
                      text-align: start;
                    }
                    .widget-about-company-11-1-widget p:first-child {
                      color: rgba(115, 115, 115, 1);
                    }
                  </style>
                  <script>
                    const submit_action = (e) => {
                      if (e.key === 'Enter') {
                        // Получаем все input элементы внутри формы
                      const inputs =
                        document.querySelectorAll('input[type="text"]');

                      // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
                      inputs.forEach((input) => {
                        const newValue = input.value;
                        const newInput = document.createElement("input");
                        newInput.type = "text";
                        newInput.name = input.name;
                        newInput.value = newValue;
                        newInput.style.color = "black";
                        input.outerHTML =
                          input.outerHTML.slice(0, 6) +
                          \` value="\${newValue}" \` +
                          input.outerHTML.slice(6);
                        console.log(input.outerHTML);
                      });
                      }
                      

                    };
                    document.addEventListener("keypress", submit_action)
                  </script>
                 

                  
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-9-2"
                onclick="alert(getCode('btn-9-2'))"
              >
                <div class="design-1 widget-about-company-11-2-widget company-L">
                  <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
                  <div>
                    <img
                      style="width: 116px; height: 12px"
                      src="http://212.41.9.251:8000/static/light_ipanel.svg"
                      alt=""
                    />
                    <div class="space-div-9-2"></div>
                    <img
                      src="http://212.41.9.251:8000/static/light_liftbrand.svg"
                      alt=""
                    />
                  </div>
                  <img
                    src="http://212.41.9.251:8000/static/light_videovision.svg"
                    alt=""
                  />
                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-1: 115px;
                      --size-4: 508px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --color-icon: "";
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-about-company-11-2-widget {
                      display: flex;
                      align-items: center;
                      justify-content: space-around;
                      width: var(--size-4);
                      height: var(--size-1);
                    }
                    .widget-about-company-11-2-widget div {
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                    }
                    .space-div-9-2 {
                      height: 16px;
                    }
                    .widget-about-company-11-2-widget img {
                      filter: var(--color-icon);
                    }
                  </style>
                </div>
              </button>
              <button
                class="drop-2"
                id="btn-9-3"
                onclick="alert(getCode('btn-9-3'))"
              >
                <div class="design-1 widget-about-company-11-3-widget company-L">
                  <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
                  <img
                    src="http://212.41.9.251:8000/static/light_ipanel.svg"
                    alt=""
                  />
                  <img
                    src="http://212.41.9.251:8000/static/light_liftbrand.svg"
                    alt=""
                  />

                  <style>
                    @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
                    * {
                      margin: 0;
                      padding: 0;
                    }
                    :root {
                      --size-1: 115px;
                      --size-4: 508px;
                      --background-widgets: rgba(30, 30, 30, 1);
                      --color-icon: "";
                    }
                    .design-1 {
                      background-color: var(--background-widgets);
                      border-radius: 32px;
                    }
                    .widget-about-company-11-3-widget {
                      display: flex;
                      justify-content: space-around;
                      align-items: center;
                      width: var(--size-4);
                      height: var(--size-1);
                    }
                    .widget-about-company-11-3-widget img {
                      filter: var(--color-icon);
                    }
                  </style>
                </div>
               
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>`;
